/*
@license
  Impulse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/impulse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

window.theme = window.theme || {};
window.Shopify = window.Shopify || {};

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: 'screen and (max-width: '+ 769 +'px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute('dir') == 'rtl' ? true : false
};

if (theme.config.isTouch) {
  document.documentElement.className += ' supports-touch';
}

if (console && console.log) {
  console.log('Impulse theme ('+theme.settings.themeVersion+') by ARCHΞTYPE | Learn more at https://archetypethemes.co');
}

theme.recentlyViewed = {
  recent: {}, // will store handle+url of recent products
  productInfo: {} // will store product data to reduce API calls
};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

(function(){
  'use strict';

  theme.delegate = {
    on: function(event, callback, options){
      if( !this.namespaces ) // save the namespaces on the DOM element itself
        this.namespaces = {};
  
      this.namespaces[event] = callback;
      options = options || false;
  
      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    },
    off: function(event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    }
  };
  
  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;
  
  theme.utils = {
    defaultTo: function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    },
  
    wrap: function(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },
  
    debounce: function(wait, callback, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      }
    },
  
    throttle: function(limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      }
    },
  
    prepareTransition: function(el, callback) {
      el.addEventListener('transitionend', removeClass);
  
      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }
  
      el.classList.add('is-transitioning');
      el.offsetWidth; // check offsetWidth to force the style rendering
  
      if (typeof callback === 'function') {
        callback();
      }
    },
  
    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
  
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },
  
    serialize: function(form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
          !field.name ||
          field.disabled ||
          ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
          return;
        if (field.type === 'select-multiple') {
          Array.prototype.slice.call(field.options).forEach(function(option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                '=' +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
        );
      });
      return arr.join('&');
    }
  };
  
  theme.a11y = {
    trapFocus: function(options) {
      var eventsName = {
        focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
        focusout: options.namespace
          ? 'focusout.' + options.namespace
          : 'focusout',
        keydown: options.namespace
          ? 'keydown.' + options.namespace
          : 'keydown.handleFocus'
      };
  
      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter(el => el.offsetParent !== null);
  
      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];
  
      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }
  
      options.container.setAttribute('tabindex', '-1');
      options.elementToFocus.focus();
  
      document.documentElement.off('focusin');
      document.documentElement.on(eventsName.focusout, function() {
        document.documentElement.off(eventsName.keydown);
      });
  
      document.documentElement.on(eventsName.focusin, function(evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;
  
        document.documentElement.on(eventsName.keydown, function(evt) {
          _manageFocus(evt);
        });
      });
  
      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }
    },
    removeTrapFocus: function(options) {
      var eventName = options.namespace
        ? 'focusin.' + options.namespace
        : 'focusin';
  
      if (options.container) {
        options.container.removeAttribute('tabindex');
      }
  
      document.documentElement.off(eventName);
    },
  
    lockMobileScrolling: function(namespace, element) {
      var el = element ? element : document.documentElement;
      document.documentElement.classList.add('lock-scroll');
      el.on('touchmove' + namespace, function() {
        return true;
      });
    },
  
    unlockMobileScrolling: function(namespace, element) {
      document.documentElement.classList.remove('lock-scroll');
      var el = element ? element : document.documentElement;
      el.off('touchmove' + namespace);
    }
  };
  
  // Add class when tab key starts being used to show outlines
  document.documentElement.on('keyup.tab', function(evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add('tab-outline');
      document.documentElement.off('keyup.tab');
    }
  });
  
  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
   * - getBaseUnit - Splits unit price apart to get value + unit
   *
   */
  
  theme.Currency = (function() {
    var moneyFormat = '${{amount}}';
    var superScript = theme && theme.settings && theme.settings.superScriptPrice;
  
    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }
  
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = (format || moneyFormat);
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ',');
        decimal = theme.utils.defaultTo(decimal, '.');
  
        if (isNaN(number) || number == null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
  
          if (superScript && value && value.includes('.')) {
            value = value.replace('.', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
  
          if (superScript && value && value.includes('.')) {
            value = value.replace(',', '<sup>') + '</sup>';
          }
  
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }
  
      if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
        return;
      }
  
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
  
    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit
    }
  })();
  
  theme.Images = (function() {
  
    /**
     * Find the Shopify image attribute size
     */
    function imageSize(src) {
      if (!src) {
        return '620x'; // default based on theme
      }
  
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
  
      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }
  
    /**
     * Adds a Shopify size attribute to a URL
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }
  
      if (size == null) {
        return src;
      }
  
      if (size === 'master') {
        return this.removeProtocol(src);
      }
  
      var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  
      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];
  
        return this.removeProtocol(prefix[0] + '_' + size + suffix);
      }
  
      return null;
    }
  
    function removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    }
  
    function lazyloadImagePath(string) {
      var image;
  
      if (string !== null) {
        image = string.replace(/(\.[^.]*)$/, "_{width}x$1");
      }
  
      return image;
    }
  
    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      lazyloadImagePath: lazyloadImagePath
    };
  })();
  
  theme.loadImageSection = function(container) {
    // Wait until images inside container have lazyloaded class
    function setAsLoaded() {
      container.classList.remove('loading', 'loading--delayed');
      container.classList.add('loaded');
    }
  
    function checkForLazyloadedImage() {
      return container.querySelector('.lazyloaded');
    }
  
    // If it has SVGs it's in the onboarding state so set as loaded
    if (container.querySelector('svg')) {
      setAsLoaded();
      return;
    };
  
    if (checkForLazyloadedImage()) {
      setAsLoaded();
      return;
    }
  
    var interval = setInterval(function() {
      if (checkForLazyloadedImage()) {
        clearInterval(interval);
        setAsLoaded();
      }
    }, 25);
  };
  
  // Init section function when it's visible, then disable observer
  theme.initWhenVisible = function(options) {
    var threshold = options.threshold ? options.threshold : 0;
  
    var observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    }, {rootMargin: '0px 0px '+ threshold +'px 0px'});
  
    observer.observe(options.element);
  };
  
  theme.LibraryLoader = (function() {
    var types = {
      link: 'link',
      script: 'script'
    };
  
    var status = {
      requested: 'requested',
      loaded: 'loaded'
    };
  
    var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';
  
    var libraries = {
      youtubeSdk: {
        tagId: 'youtube-sdk',
        src: 'https://www.youtube.com/iframe_api',
        type: types.script
      },
      vimeo: {
        tagId: 'vimeo-api',
        src: 'https://player.vimeo.com/api/player.js',
        type: types.script
      },
      shopifyXr: {
        tagId: 'shopify-model-viewer-xr',
        src: cloudCdn + 'shopify-xr-js/assets/v1.0/shopify-xr.en.js',
        type: types.script
      },
      modelViewerUi: {
        tagId: 'shopify-model-viewer-ui',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.en.js',
        type: types.script
      },
      modelViewerUiStyles: {
        tagId: 'shopify-model-viewer-ui-styles',
        src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
        type: types.link
      }
    };
  
    function load(libraryName, callback) {
      var library = libraries[libraryName];
  
      if (!library) return;
      if (library.status === status.requested) return;
  
      callback = callback || function() {};
      if (library.status === status.loaded) {
        callback();
        return;
      }
  
      library.status = status.requested;
  
      var tag;
  
      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }
  
      tag.id = library.tagId;
      library.element = tag;
  
      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  
    function createScriptTag(library, callback) {
      var tag = document.createElement('script');
      tag.src = library.src;
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    function createLinkTag(library, callback) {
      var tag = document.createElement('link');
      tag.href = library.src;
      tag.rel = 'stylesheet';
      tag.type = 'text/css';
      tag.addEventListener('load', function() {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }
  
    return {
      load: load
    };
  })();
  
  theme.rteInit = function() {
    // Wrap tables so they become scrollable on small screens
    document.querySelectorAll('.rte table').forEach(table => {
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('table-wrapper');
      theme.utils.wrap(table, wrapWith);
    });
  
    // Wrap video iframe embeds so they are responsive
    document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach(iframe => {
      wrapVideo(iframe);
    });
    document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach(iframe => {
      wrapVideo(iframe);
    });
  
    function wrapVideo(iframe) {
      // Reset the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      iframe.src = iframe.src;
      var wrapWith = document.createElement('div');
      wrapWith.classList.add('video-wrapper');
      theme.utils.wrap(iframe, wrapWith);
    }
  
    // Remove CSS that adds animated underline under image links
    document.querySelectorAll('.rte a img').forEach(img => {
      img.parentNode.classList.add('rte__image');
    });
  }
  
  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];
  
    document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
    document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
    document.addEventListener('shopify:section:select', this._onSelect.bind(this));
    document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
    document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
    document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
  };
  
  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function(container, constructor, scope) {
      var id = container.getAttribute('data-section-id');
      var type = container.getAttribute('data-section-type');
  
      constructor = constructor || this.constructors[type];
  
      if (typeof constructor === 'undefined') {
        return;
      }
  
      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }
  
      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },
  
    _findInstance: function(id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },
  
    _removeInstance: function(id) {
      var i = this.instances.length;
      var instance;
  
      while(i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }
  
      return instance;
    },
  
    _onSectionLoad: function(evt, subSection, subSectionId) {
      if (window.AOS) { AOS.refreshHard() }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }
  
      var container = subSection ? subSection : evt.target;
      var section = subSection ? subSection : evt.target.querySelector('[data-section-id]');
  
      if (!section) {
        return;
      }
  
      this._createInstance(section);
  
      var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);
  
      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll('[data-subsection]');
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }
  
      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === 'function') {
        instance.onLoad(evt);
      }
  
      // Force editor to trigger scroll event when loading a section
      setTimeout(function() {
        window.dispatchEvent(new Event('scroll'));
      }, 200);
    },
  
    _onSectionUnload: function(evt) {
      this.instances = this.instances.filter(function(instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;
  
        if (isEventInstance) {
          if (typeof instance.onUnload === 'function') {
            instance.onUnload(evt);
          }
        }
  
        return !isEventInstance;
      });
    },
  
    loadSubSections: function(scope) {
      if (!scope) {
        return;
      }
  
      var sections = scope.querySelectorAll('[data-section-id]');
  
      sections.forEach(el => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },
  
    _onSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onSelect === 'function'
      ) {
        instance.onSelect(evt);
      }
    },
  
    _onDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onDeselect === 'function'
      ) {
        instance.onDeselect(evt);
      }
    },
  
    _onBlockSelect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockSelect === 'function'
      ) {
        instance.onBlockSelect(evt);
      }
    },
  
    _onBlockDeselect: function(evt) {
      var instance = this._findInstance(evt.detail.sectionId);
  
      if (
        typeof instance !== 'undefined' &&
        typeof instance.onBlockDeselect === 'function'
      ) {
        instance.onBlockDeselect(evt);
      }
    },
  
    register: function(type, constructor, scope) {
      this.constructors[type] = constructor;
  
      var sections = document.querySelectorAll('[data-section-type="' + type + '"]');
  
      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }
  
      sections.forEach(
        function(container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },
  
    reinit: function(section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance['type'] === section) {
          if (typeof instance.forceReload === 'function') {
            instance.forceReload();
          }
        }
      }
    }
  });
  
  /*
    Options:
      container
      enableHistoryState - enable when on single product page to update URL
      singleOptionSelector - selector for individual variant option (e.g. 'Blue' or 'Small')
      originalSelectorId - selector for base variant selector (visually hidden)
      variants - JSON parsed object of product variant info
   */
  theme.Variants = (function() {
  
    function Variants(options) {
      this.container = options.container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentlySelectedValues = this._getCurrentOptions();
      this.currentVariant = this._getVariantFromOptions(this.currentlySelectedValues);
  
      this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
        el.addEventListener('change', this._onSelectChange.bind(this));
      });
    }
  
    Variants.prototype = Object.assign({}, Variants.prototype, {
  
      _getCurrentOptions: function() {
        var result = [];
  
        this.container.querySelectorAll(this.singleOptionSelector).forEach(el => {
          var type = el.getAttribute('type');
  
          if (type === 'radio' || type === 'checkbox') {
            if (el.checked) {
              result.push({
                value: el.value,
                index: el.dataset.index
              });
            }
          } else {
            result.push({
              value: el.value,
              index: el.dataset.index
            });
          }
        });
  
        // remove any unchecked input values if using radio buttons or checkboxes
        result = theme.utils.compact(result);
  
        return result;
      },
  
      _getVariantFromOptions: function(selectedValues) {
        var variants = this.variants;
        var found = false;
  
        if (selectedValues.length !== variants[0].options.length) return null;
  
        variants.forEach(function(variant) {
          var match = true;
          var options = variant.options;
  
          selectedValues.forEach(function(option) {
            if (match) {
              match = (variant[option.index] === option.value);
            }
          });
  
          if (match) {
            found = variant;
          }
        });
  
        return found || null;
      },
  
      _onSelectChange: function(evt) {
        var el = evt.srcElement
        var type = el.getAttribute('type');
  
        if (el.classList.contains('disabled')) {
          this.container.querySelectorAll(this.singleOptionSelector).forEach(input => {
            if (type === 'radio' || type === 'checkbox') {
              if (input !== el) {
                input.checked = false
              }
            }
          })
        }
  
        this.currentlySelectedValues = this._getCurrentOptions();
        var variant = this._getVariantFromOptions(this.currentlySelectedValues);
  
        this.container.dispatchEvent(new CustomEvent('variantChange', {
          detail: {
            variant: variant,
            currentlySelectedValues: this.currentlySelectedValues,
            value: evt.srcElement.value,
            index: evt.srcElement.parentElement.dataset.index
          }
        }));
  
        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: {
            variant: variant,
            currentlySelectedValues: this.currentlySelectedValues,
            value: evt.srcElement.value,
            index: evt.srcElement.parentElement.dataset.index
          }
        }));
  
        if (!variant) {
          return;
        }
  
        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;
  
        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },
  
      _updateImages: function(variant) {
        var variantImage = variant.featured_image || {};
        var currentVariantImage = this.currentVariant && this.currentVariant.featured_image || {};
  
        if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantImageChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updatePrice: function(variant) {
        if (this.currentVariant && variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateUnitPrice: function(variant) {
        if (this.currentVariant && variant.unit_price === this.currentVariant.unit_price) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantUnitPriceChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateSKU: function(variant) {
        if (this.currentVariant && variant.sku === this.currentVariant.sku) {
          return;
        }
  
        this.container.dispatchEvent(new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant
          }
        }));
      },
  
      _updateHistoryState: function(variant) {
        if (!history.replaceState || !variant) {
          return;
        }
  
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({path: newurl}, '', newurl);
      },
  
      _updateMasterSelect: function(variant) {
        this.container.querySelector(this.originalSelectorId).value = variant.id;
        // Force a change event so Shop Pay installments works after a variant is changed
        this.container.querySelector(this.originalSelectorId).dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  
    return Variants;
  })();
  
  window.vimeoApiReady = function() {
    theme.config.vimeoLoading = true;
  
    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady()
      .then(function() {
        theme.config.vimeoReady = true;
        theme.config.vimeoLoading = false;
        document.dispatchEvent(new CustomEvent('vimeoReady'));
      });
  }
  
  function checkIfVimeoIsReady() {
    var wait;
    var timeout;
  
    var deferred = new Promise((resolve, reject) => {
      wait = setInterval(function() {
        if (!Vimeo) {
          return;
        }
  
        clearInterval(wait);
        clearTimeout(timeout);
        resolve();
      }, 500);
  
      timeout = setTimeout(function() {
        clearInterval(wait);
        reject();
      }, 4000); // subjective. test up to 8 times over 4 seconds
    });
  
    return deferred;
  }
  
  theme.VimeoPlayer = (function() {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }
  
    var defaults = {
      background: true,
      byline: false,
      controls: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false
    };
  
    function VimeoPlayer(divId, videoId, options) {
      this.divId = divId;
      this.el = document.getElementById(divId);
      this.videoId = videoId;
      this.iframe = null;
      this.options = options;
  
      if (this.options && this.options.videoParent) {
        this.parent = this.el.closest(this.options.videoParent);
      }
  
      this.setAsLoading();
  
      if (theme.config.vimeoReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('vimeo', window.vimeoApiReady);
        document.addEventListener('vimeoReady', this.init.bind(this));
      }
    }
  
    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function() {
        var args = defaults;
        args.id = this.videoId;
  
        this.videoPlayer = new Vimeo.Player(this.el, args);
  
        this.videoPlayer.ready().then(this.playerReady.bind(this));
      },
  
      playerReady: function() {
        this.iframe = this.el.querySelector('iframe');
        this.iframe.setAttribute('tabindex', '-1');
  
        this.videoPlayer.setMuted(true);
  
        this.setAsLoaded();
  
        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, {rootMargin: '0px 0px 50px 0px'});
  
        observer.observe(this.iframe);
      },
  
      setAsLoading: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },
  
      setAsLoaded: function() {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {AOS.refreshHard()}
        }
      },
  
      enableInteraction: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },
  
      play: function() {
        if (this.videoPlayer && typeof this.videoPlayer.play === 'function') {
          this.videoPlayer.play();
        }
      },
  
      pause: function() {
        if (this.videoPlayer && typeof this.videoPlayer.pause === 'function') {
          this.videoPlayer.pause();
        }
      },
  
      destroy: function() {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });
  
    return VimeoPlayer;
  })();
  
  window.onYouTubeIframeAPIReady = function() {
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent('youTubeReady'));
  }
  
  /*============================================================================
    YouTube SDK method
    Parameters:
      - player div id (required)
      - arguments
        - videoId (required)
        - videoParent (selector, optional for section loading state)
        - events (object, optional)
  ==============================================================================*/
  theme.YouTube = (function() {
    var classes = {
      loading: 'loading',
      loaded: 'loaded',
      interactable: 'video-interactable'
    }
  
    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0
      }
    };
  
    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;
  
      this.attemptedToPlay = false;
  
      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this)
      };
  
      this.options = Object.assign({}, defaults, options);
  
      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document.getElementById(this.divId).closest(this.options.videoParent);
        }
  
        // Most YT videos will autoplay. If in product media,
        // will handle in theme.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay;
        }
  
        if (this.options.style === 'sound') {
          this.options.playerVars.controls = 1;
          this.options.playerVars.autoplay = 0;
        }
  
      }
  
      this.setAsLoading();
  
      if (theme.config.youTubeReady) {
        this.init();
      } else {
        theme.LibraryLoader.load('youtubeSdk');
        document.addEventListener('youTubeReady', this.init.bind(this));
      }
    }
  
    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function() {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },
  
      onVideoPlayerReady: function(evt) {
        this.iframe = document.getElementById(this.divId); // iframe once YT loads
        this.iframe.setAttribute('tabindex', '-1');
  
        if (this.options.style !== 'sound') {
          evt.target.mute();
        }
  
        // pause when out of view
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, {rootMargin: '0px 0px 50px 0px'});
  
        observer.observe(this.iframe);
      },
  
      onVideoStateChange: function(evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },
  
      setAsLoading: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },
  
      setAsLoaded: function() {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {AOS.refreshHard()}
        }
      },
  
      enableInteraction: function() {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },
  
      play: function() {
        if (this.videoPlayer && typeof this.videoPlayer.playVideo === 'function') {
          this.videoPlayer.playVideo();
        }
      },
  
      pause: function() {
        if (this.videoPlayer && typeof this.videoPlayer.pauseVideo === 'function') {
          this.videoPlayer.pauseVideo();
        }
      },
  
      destroy: function() {
        if (this.videoPlayer && typeof this.videoPlayer.destroy === 'function') {
          this.videoPlayer.destroy();
        }
      }
    });
  
    return YouTube;
  })();
  
  // Prevent vertical scroll while using flickity sliders
  (function() {
    var e = !1;
    var t;
  
    document.body.addEventListener('touchstart', function(i) {
      if (!i.target.closest('.flickity-slider')) {
        return e = !1;
        void 0;
      }
      e = !0;
      t = {
        x: i.touches[0].pageX,
        y: i.touches[0].pageY
      }
    })
  
    document.body.addEventListener('touchmove', function(i) {
      if (e && i.cancelable) {
        var n = {
          x: i.touches[0].pageX - t.x,
          y: i.touches[0].pageY - t.y
        };
        Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault()
      }
    }, { passive: !1 })
  })();
  

  /**
   * Ajax Renderer
   * -----------------------------------------------------------------------------
   * Render sections without reloading the page.
   * @param {Object[]} sections - The section to update on render.
   * @param {string} sections[].sectionId - The ID of the section from Shopify.
   * @param {string} sections[].nodeId - The ID of the DOM node to replace.
   * @param {Function} sections[].onReplace (optional) - The custom render function.
   * @param {boolean} debug - Output logs to console for debugging.
   *
   */
  
  theme.AjaxRenderer = (function () {
    function AjaxRenderer({ sections, onReplace, debug } = {}) {
      this.sections = sections || [];
      this.cachedSections = [];
      this.onReplace = onReplace;
      this.debug = Boolean(debug);
    }
  
    AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
      renderPage: function (basePath, newParams, updateURLHash = true) {
        const currentParams = new URLSearchParams(window.location.search);
        const updatedParams = this.getUpdatedParams(currentParams, newParams)
  
        const sectionRenders = this.sections.map(section => {
  
          const url = `${basePath}?section_id=${section.sectionId}&${updatedParams.toString()}`;
          const cachedSectionUrl = cachedSection => cachedSection.url === url;
  
          return this.cachedSections.some(cachedSectionUrl)
            ? this.renderSectionFromCache(cachedSectionUrl, section)
            : this.renderSectionFromFetch(url, section);
        });
  
        if (updateURLHash) this.updateURLHash(updatedParams);
  
        return Promise.all(sectionRenders);
      },
  
      renderSectionFromCache: function (url, section) {
        const cachedSection = this.cachedSections.find(url);
  
        this.log(`[AjaxRenderer] rendering from cache: url=${cachedSection.url}`);
        this.renderSection(cachedSection.html, section);
        return Promise.resolve(section);
      },
  
      renderSectionFromFetch: function (url, section) {
        this.log(`[AjaxRenderer] redering from fetch: url=${url}`);
  
        return new Promise((resolve, reject) => {
          fetch(url)
            .then(response => response.text())
            .then(responseText => {
              const html = responseText;
              this.cachedSections = [...this.cachedSections, { html, url }];
              this.renderSection(html, section);
              resolve(section);
            })
            .catch(err => reject(err));
        });
      },
  
      renderSection: function (html, section) {
        this.log(
          `[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`,
        );
  
        const newDom = new DOMParser().parseFromString(html, 'text/html');
        if (this.onReplace) {
          this.onReplace(newDom, section);
        } else {
          if (typeof section.nodeId === 'string') {
            var newContentEl = newDom.getElementById(section.nodeId);
            if (!newContentEl) {
              return;
            }
  
            document.getElementById(section.nodeId).innerHTML =
              newContentEl.innerHTML;
          } else {
            section.nodeId.forEach(id => {
              document.getElementById(id).innerHTML =
                newDom.getElementById(id).innerHTML;
            });
          }
        }
  
        return section;
      },
  
      getUpdatedParams: function (currentParams, newParams) {
        const clone = new URLSearchParams(currentParams);
        const preservedParams = ['sort_by', 'q', 'options[prefix]', 'type'];
  
        // Find what params need to be removed
        // delete happens first as we cannot specify keys based off of values
        for (const [key, value] of clone.entries()) {
          if (!newParams.getAll(key).includes(value) && !preservedParams.includes(key)) {
            clone.delete(key);
          };
        }
  
        // Find what params need to be added
        for (const [key, value] of newParams.entries()) {
          if (!clone.getAll(key).includes(value) && value !== '') {
            clone.append(key, value);
          }
        }
  
        return clone;
      },
  
      updateURLHash: function (searchParams) {
        history.pushState(
          {},
          '',
          `${window.location.pathname}${
            searchParams && '?'.concat(searchParams)
          }`,
        );
      },
  
      log: function (...args) {
        if (this.debug) {
          console.log(...args);
        }
      },
    });
  
    return AjaxRenderer;
  })();
  
  if (window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode) {
    navigator.sendBeacon('https://api.archetypethemes.co/api/beacon', new URLSearchParams({
      shop: window.Shopify.shop,
      themeName: window.theme && window.theme.settings && `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
      role: window.Shopify.theme.role,
      route: window.location.pathname,
      themeId: window.Shopify.theme.id,
      themeStoreId: window.Shopify.theme.theme_store_id || 0,
      isThemeEditor: !!window.Shopify.designMode
    }))
  }
  theme.cart = {
    getCart: function() {
      var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(response => response.json());
    },
  
    getCartProductMarkup: function() {
      var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());
  
      url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');
  
      return fetch(url, {
        credentials: 'same-origin',
        method: 'GET'
      })
      .then(function(response) {return response.text()});
    },
  
    changeItem: function(key, qty) {
      return this._updateCart({
        url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty
        })
      })
    },
  
    _updateCart: function(params) {
      return fetch(params.url, {
        method: 'POST',
        body: params.data,
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(function(cart) {
        return cart;
      });
    },
  
    updateAttribute: function(key, value) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          attributes: {
            [key]: theme.cart.attributeToString(value)
          }
        })
      });
    },
  
    updateNote: function(note) {
      return this._updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          note: theme.cart.attributeToString(note)
        })
      });
    },
  
    attributeToString: function(attribute) {
      if ((typeof attribute) !== 'string') {
        attribute += '';
        if (attribute === 'undefined') {
          attribute = '';
        }
      }
      return attribute.trim();
    }
  }
  
  /*============================================================================
    CartForm
    - Prevent checkout when terms checkbox exists
    - Listen to quantity changes, rebuild cart (both widget and page)
  ==============================================================================*/
  theme.CartForm = (function() {
    var selectors = {
      products: '[data-products]',
      qtySelector: '.js-qty__wrapper',
      discounts: '[data-discounts]',
      savings: '[data-savings]',
      subTotal: '[data-subtotal]',
  
      cartBubble: '.cart-link__bubble',
      cartNote: '[name="note"]',
      termsCheckbox: '.cart__terms-checkbox',
      checkoutBtn: '.cart__checkout'
    };
  
    var classes = {
      btnLoading: 'btn--loading'
    };
  
    var config = {
      requiresTerms: false
    };
  
    function CartForm(form) {
      if (!form) {
        return;
      }
  
      this.form = form;
      this.wrapper = form.parentNode;
      this.location = form.dataset.location;
      this.namespace = '.cart-' + this.location;
      this.products = form.querySelector(selectors.products)
      this.submitBtn = form.querySelector(selectors.checkoutBtn);
  
      this.discounts = form.querySelector(selectors.discounts);
      this.savings = form.querySelector(selectors.savings);
      this.subtotal = form.querySelector(selectors.subTotal);
      this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
      this.noteInput = form.querySelector(selectors.cartNote);
  
      if (this.termsCheckbox) {
        config.requiresTerms = true;
      }
  
      this.init();
    }
  
    CartForm.prototype = Object.assign({}, CartForm.prototype, {
      init: function() {
        this.initQtySelectors();
  
        document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));
  
        this.form.on('submit' + this.namespace, this.onSubmit.bind(this));
  
        if (this.noteInput) {
          this.noteInput.addEventListener('change', function() {
            var newNote = this.value;
            theme.cart.updateNote(newNote);
          });
        }
  
        // Dev-friendly way to build the cart
        document.addEventListener('cart:build', function() {
          this.buildCart();
        }.bind(this));
      },
  
      reInit: function() {
        this.initQtySelectors();
      },
  
      onSubmit: function(evt) {
        this.submitBtn.classList.add(classes.btnLoading);
  
        if (config.requiresTerms) {
          if (this.termsCheckbox.checked) {
            // continue to checkout
          } else {
            alert(theme.strings.cartTermsConfirmation);
            this.submitBtn.classList.remove(classes.btnLoading)
            evt.preventDefault();
            return false;
          }
        }
      },
  
      /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
      _parseProductHTML: function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        return {
          items: doc.querySelector('.cart__items'),
          discounts: doc.querySelector('.cart__discounts')
        }
      },
  
      buildCart: function() {
        theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
      },
  
      cartMarkup: function(html) {
        var markup = this._parseProductHTML(html);
        var items = markup.items;
        var count = parseInt(items.dataset.count);
        var subtotal = items.dataset.cartSubtotal;
        var savings = items.dataset.cartSavings;
  
        this.updateCartDiscounts(markup.discounts);
        this.updateSavings(savings);
  
        if (count > 0) {
          this.wrapper.classList.remove('is-empty');
        } else {
          this.wrapper.classList.add('is-empty');
        }
  
        this.updateCount(count);
  
        // Append item markup
        this.products.innerHTML = '';
        this.products.append(items);
  
        // Update subtotal
        this.subtotal.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
  
        this.reInit();
  
        if (window.AOS) { AOS.refreshHard() }
  
        if (Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
      },
  
      updateCartDiscounts: function(markup) {
        if (!this.discounts) {
          return;
        }
        this.discounts.innerHTML = '';
        this.discounts.append(markup);
      },
  
      /*============================================================================
        Quantity handling
      ==============================================================================*/
      initQtySelectors: function() {
        this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
          var selector = new theme.QtySelector(el, {
            namespace: this.namespace,
            isCart: true
          });
        });
      },
  
      quantityChanged: function(evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var el = evt.detail[2];
  
        if (!key || !qty) {
          return;
        }
  
        // Disable qty selector so multiple clicks can't happen while loading
        if (el) {
          el.classList.add('is-loading');
        }
  
        theme.cart.changeItem(key, qty)
          .then(function(cart) {
            if (cart.item_count > 0) {
              this.wrapper.classList.remove('is-empty');
            } else {
              this.wrapper.classList.add('is-empty');
            }
  
            this.buildCart();
  
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: {
                cart: cart
              }
            }));
          }.bind(this))
          .catch(function(XMLHttpRequest){});
      },
  
      /*============================================================================
        Update elements of the cart
      ==============================================================================*/
      updateSubtotal: function(subtotal) {
        this.form.querySelector(selectors.subTotal).innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
      },
  
      updateSavings: function(savings) {
        if (!this.savings) {
          return;
        }
  
        if (savings > 0) {
          var amount = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
          this.savings.classList.remove('hide');
          this.savings.innerHTML = theme.strings.cartSavings.replace('[savings]', amount);
        } else {
          this.savings.classList.add('hide');
        }
      },
  
      updateCount: function(count) {
        var countEls = document.querySelectorAll('.cart-link__bubble-num');
  
        if (countEls.length) {
          countEls.forEach(el => {
            el.innerText = count;
          });
        }
  
        // show/hide bubble(s)
        var bubbles = document.querySelectorAll(selectors.cartBubble);
        if (bubbles.length) {
          if (count > 0) {
            bubbles.forEach(b => {
              b.classList.add('cart-link__bubble--visible');
            });
          } else {
            bubbles.forEach(b => {
              b.classList.remove('cart-link__bubble--visible');
            });
          }
        }
      }
    });
  
    return CartForm;
  })();
  
  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  theme.collapsibles = (function() {
    var selectors = {
      trigger: '.collapsible-trigger',
      module: '.collapsible-content',
      moduleInner: '.collapsible-content__inner',
      tabs: '.collapsible-trigger--tab'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };
  
    var namespace = '.collapsible';
  
    var isTransitioning = false;
  
    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.trigger).forEach(trigger => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute('aria-expanded', state);
  
        trigger.off('click' + namespace);
        trigger.on('click' + namespace, toggle);
      });
    }
  
    function toggle(evt) {
      if (isTransitioning) {
        return;
      }
  
      isTransitioning = true;
  
      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);
  
      if (!moduleId) {
        moduleId = el.dataset.controls;
      }
  
      // No ID, bail
      if (!moduleId) {
        return;
      }
  
      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }
  
      if (!container) {
        isTransitioning = false;
        return;
      }
  
      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;
  
      if (isTab) {
        if(isOpen) {
          isTransitioning = false;
          return;
        }
  
        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="'+ el.dataset.id +'"]').forEach(el => {
          el.classList.remove(classes.open);
          newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
          setTransitionHeight(newModule, 0, true);
        });
      }
  
      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function() {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }
  
      if (isOpen && !isAutoHeight) {
        height = 0;
      }
  
      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }
  
      setTransitionHeight(container, height, isOpen, isAutoHeight);
  
      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var totalHeight = isOpen
                          ? parentCollapsibleEl.offsetHeight - childHeight
                          : height + parentCollapsibleEl.offsetHeight;
  
        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }
  
      // If Shopify Product Reviews app installed,
      // resize container on 'Write review' click
      // that shows form
      if (window.SPR) {
        var btn = container.querySelector('.spr-summary-actions-newreview');
        if (!btn) { return }
        btn.off('click' + namespace);
        btn.on('click' + namespace, function() {
          height = container.querySelector(selectors.moduleInner).offsetHeight;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        });
      }
    }
  
    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      theme.utils.prepareTransition(container, function() {
        container.style.height = height+'px';
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });
  
      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }
  
    return {
      init: init
    };
  })();
  
  // Shopify-built select-like popovers for currency and language selection
  theme.Disclosure = (function() {
    var selectors = {
      disclosureForm: '[data-disclosure-form]',
      disclosureList: '[data-disclosure-list]',
      disclosureToggle: '[data-disclosure-toggle]',
      disclosureInput: '[data-disclosure-input]',
      disclosureOptions: '[data-disclosure-option]'
    };
  
    var classes = {
      listVisible: 'disclosure-list--visible'
    };
  
    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._setupListeners();
    }
  
    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function() {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(selectors.disclosureList),
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureInput: this.container.querySelector(
            selectors.disclosureInput
          ),
          disclosureOptions: this.container.querySelectorAll(
            selectors.disclosureOptions
          )
        };
      },
  
      _setupListeners: function() {
        this.eventHandlers = this._setupEventHandlers();
  
        this.cache.disclosureToggle.addEventListener(
          'click',
          this.eventHandlers.toggleList
        );
  
        this.cache.disclosureOptions.forEach(function(disclosureOption) {
          disclosureOption.addEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);
  
        this.container.addEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );
  
        this.cache.disclosureList.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );
  
        this.cache.disclosureToggle.addEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );
  
        document.body.addEventListener('click', this.eventHandlers.onBodyClick);
      },
  
      _setupEventHandlers: function() {
        return {
          connectOptions: this._connectOptions.bind(this),
          toggleList: this._toggleList.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
          onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
          onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
        };
      },
  
      _connectOptions: function(event) {
        event.preventDefault();
  
        this._submitForm(event.currentTarget.dataset.value);
      },
  
      _onDisclosureToggleFocusOut: function(event) {
        var disclosureLostFocus =
          this.container.contains(event.relatedTarget) === false;
  
        if (disclosureLostFocus) {
          this._hideList();
        }
      },
  
      _onDisclosureListFocusOut: function(event) {
        var childInFocus = event.currentTarget.contains(event.relatedTarget);
  
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );
  
        if (isVisible && !childInFocus) {
          this._hideList();
        }
      },
  
      _onDisclosureKeyUp: function(event) {
        if (event.which !== 27) return;
        this._hideList();
        this.cache.disclosureToggle.focus();
      },
  
      _onBodyClick: function(event) {
        var isOption = this.container.contains(event.target);
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );
  
        if (isVisible && !isOption) {
          this._hideList();
        }
      },
  
      _submitForm: function(value) {
        this.cache.disclosureInput.value = value;
        this.cache.disclosureForm.submit();
      },
  
      _hideList: function() {
        this.cache.disclosureList.classList.remove(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', false);
      },
  
      _toggleList: function() {
        var ariaExpanded =
          this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
        this.cache.disclosureList.classList.toggle(classes.listVisible);
        this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
      },
  
      destroy: function() {
        this.cache.disclosureToggle.removeEventListener(
          'click',
          this.eventHandlers.toggleList
        );
  
        this.cache.disclosureOptions.forEach(function(disclosureOption) {
          disclosureOption.removeEventListener(
            'click',
            this.eventHandlers.connectOptions
          );
        }, this);
  
        this.container.removeEventListener(
          'keyup',
          this.eventHandlers.onDisclosureKeyUp
        );
  
        this.cache.disclosureList.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureListFocusOut
        );
  
        this.cache.disclosureToggle.removeEventListener(
          'focusout',
          this.eventHandlers.onDisclosureToggleFocusOut
        );
  
        document.body.removeEventListener(
          'click',
          this.eventHandlers.onBodyClick
        );
      }
    });
  
    return Disclosure;
  })();
  
  theme.Drawers = (function() {

    function Drawers(id, name) {
      this.config = {
        id: id,
        close: '.js-drawer-close',
        open: '.js-drawer-open-' + name,
        openClass: 'js-drawer-open',
        closingClass: 'js-drawer-closing',
        activeDrawer: 'drawer--is-open',
        namespace: '.drawer-' + name
      };
      
      this.nodes = {
        page: document.querySelector('#MainContent')
      };
  
      this.drawer = document.querySelector('#' + id);
      this.isOpen = false;
  
      if (!this.drawer) {
        return;
      }
      
      this.init();
    }
  
    Drawers.prototype = Object.assign({}, Drawers.prototype, {
      init: function() {
        // Setup open button(s)
        document.querySelectorAll(this.config.open).forEach(openBtn => {
          openBtn.setAttribute('aria-expanded', 'false');
          openBtn.addEventListener('click', this.open.bind(this));
        });
  
        this.drawer.querySelector(this.config.close).addEventListener('click', this.close.bind(this));
  
        // Close modal if a drawer is opened
        document.addEventListener('modalOpen', function() {
          this.close();
        }.bind(this));
      },
  
      open: function(evt, returnFocusEl) {
        if (evt) {
          evt.preventDefault();
        }
  
        if (this.isOpen) {
          return;
        }
  
        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          evt.currentTarget.setAttribute('aria-expanded', 'true');
          this.activeSource = evt.currentTarget;
        } else if (returnFocusEl) {
          returnFocusEl.setAttribute('aria-expanded', 'true');
          this.activeSource = returnFocusEl;
        }
  
        theme.utils.prepareTransition(this.drawer, function() {
          this.drawer.classList.add(this.config.activeDrawer);
        }.bind(this));
  
        document.documentElement.classList.add(this.config.openClass);
        this.isOpen = true;
  
        theme.a11y.trapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });
  
        document.dispatchEvent(new CustomEvent('drawerOpen'));
        document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));
  
        this.bindEvents();
      },
  
      close: function(evt) {
        if (!this.isOpen) {
          return;
        }
  
        // Do not close if click event came from inside drawer
        if (evt) {
          if (evt.target.closest('.js-drawer-close')) {
            // Do not close if using the drawer close button
          } else if (evt.target.closest('.drawer')) {
            return;
          }
        }
  
        // deselect any focused form elements
        document.activeElement.blur();
  
        theme.utils.prepareTransition(this.drawer, function() {
          this.drawer.classList.remove(this.config.activeDrawer);
        }.bind(this));
  
        document.documentElement.classList.remove(this.config.openClass);
        document.documentElement.classList.add(this.config.closingClass);
  
        window.setTimeout(function() {
          document.documentElement.classList.remove(this.config.closingClass);
          if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
            this.activeSource.setAttribute('aria-expanded', 'false');
            this.activeSource.focus();
          }
        }.bind(this), 500);
  
        this.isOpen = false;
  
        theme.a11y.removeTrapFocus({
          container: this.drawer,
          namespace: 'drawer_focus'
        });
  
        this.unbindEvents();
      },
  
      bindEvents: function() {
        // Clicking out of drawer closes it
        window.on('click' + this.config.namespace, function(evt) {
          this.close(evt)
          return;
        }.bind(this));
  
        // Pressing escape closes drawer
        window.on('keyup' + this.config.namespace, function(evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this));
  
        theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
      },
  
      unbindEvents: function() {
        window.off('click' + this.config.namespace);
        window.off('keyup' + this.config.namespace);
  
        theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
      }
    });
  
    return Drawers;
  })();
  
  theme.Modals = (function() {
    function Modal(id, name, options) {
      var defaults = {
        close: '.js-modal-close',
        open: '.js-modal-open-' + name,
        openClass: 'modal--is-active',
        closingClass: 'modal--is-closing',
        bodyOpenClass: ['modal-open'],
        bodyOpenSolidClass: 'modal-open--solid',
        bodyClosingClass: 'modal-closing',
        closeOffContentClick: true
      };
  
      this.id = id;
      this.modal = document.getElementById(id);
  
      if (!this.modal) {
        return false;
      }
  
      this.modalContent = this.modal.querySelector('.modal__inner');
  
      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal;
      this.isSolid = this.config.solid;
  
      this.init();
    }
  
    Modal.prototype.init = function() {
      document.querySelectorAll(this.config.open).forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', this.open.bind(this));
      });
  
      this.modal.querySelectorAll(this.config.close).forEach(btn => {
        btn.addEventListener('click', this.close.bind(this));
      });
  
      // Close modal if a drawer is opened
      document.addEventListener('drawerOpen', function() {
        this.close();
      }.bind(this));
    };
  
    Modal.prototype.open = function(evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;
  
      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }
  
      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }
  
      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute('aria-expanded', 'true');
      }
  
      if (this.modalIsOpen && !externalCall) {
        this.close();
      }
  
      this.modal.classList.add(this.config.openClass);
  
      document.documentElement.classList.add(...this.config.bodyOpenClass);
  
      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = true;
  
      theme.a11y.trapFocus({
        container: this.modal,
        elementToFocus: this.focusOnOpen,
        namespace: 'modal_focus'
      });
  
      document.dispatchEvent(new CustomEvent('modalOpen'));
      document.dispatchEvent(new CustomEvent('modalOpen.' + this.id));
  
      this.bindEvents();
    };
  
    Modal.prototype.close = function(evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }
  
      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest('.js-modal-close')) {
          // Do not close if using the modal close button
        } else if (evt.target.closest('.modal__inner')) {
          return;
        }
      }
  
      // deselect any focused form elements
      document.activeElement.blur();
  
      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);
  
      document.documentElement.classList.remove(...this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);
  
      window.setTimeout(function() {
        document.documentElement.classList.remove(this.config.bodyClosingClass);
        this.modal.classList.remove(this.config.closingClass);
        if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
          this.activeSource.setAttribute('aria-expanded', 'false').focus();
        }
      }.bind(this), 500); // modal close css transition
  
      if (this.isSolid) {
        document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
      }
  
      this.modalIsOpen = false;
  
      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: 'modal_focus'
      });
  
      document.dispatchEvent(new CustomEvent('modalClose.' + this.id));
  
      this.unbindEvents();
    };
  
    Modal.prototype.bindEvents = function() {
      window.on('keyup.modal', function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
  
      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on('click.modal', this.close.bind(this));
      }
    };
  
    Modal.prototype.unbindEvents = function() {
      document.documentElement.off('.modal');
  
      if (this.config.closeOffContentClick) {
        this.modal.off('.modal');
      }
    };
  
    return Modal;
  })();
  
  theme.parallaxSections = {};
  
  theme.Parallax = (function() {
    var speed = 0.85;
    var reset = false;
  
    function parallax(container, args) {
      this.isInit = false;
      this.isVisible = false;
      this.container = container;
      this.image = container.querySelector('.parallax-image');
      this.namespace = args.namespace;
      this.desktopOnly = args.desktopOnly;
  
      if (!this.container || !this.image) {
        return;
      }
  
      // If set for desktop only, setup listeners for disabling
      // on mobile and re-enabling on desktop
      if (this.desktopOnly) {
        document.addEventListener('matchSmall', function() {
          this.destroy();
        }.bind(this));
  
        document.addEventListener('unmatchSmall', function() {
          this.init(true);
        }.bind(this));
      }
  
      this.init(this.desktopOnly);
    }
  
    parallax.prototype = Object.assign({}, parallax.prototype, {
      init: function(desktopOnly) {
        // Reset in case initialized again
        if (this.isInit) {
          this.destroy();
        }
  
        this.isInit = true;
  
        // Do not setup scroll event if on mobile
        if (desktopOnly && theme.config.bpSmall) {
          return;
        }
  
        // Set position on page load
        this.setSizes();
        this.scrollHandler();
  
        var observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            this.isVisible = entry.isIntersecting;
            if (this.isVisible) {
              window.on('scroll' + this.namespace, this.onScroll.bind(this));
            } else {
              window.off('scroll' + this.namespace);
            }
          });
        }, {rootMargin: '200px 0px 200px 0px'});
  
        observer.observe(this.container);
  
        window.on('resize' + this.namespace, theme.utils.debounce(250, this.setSizes.bind(this)));
  
        document.addEventListener('shopify:section:reorder', theme.utils.debounce(250, this.onReorder.bind(this)));
      },
  
      onScroll: function() {
        if (!this.isVisible) {
          return;
        }
  
        // If a scroll event finds Shopify's review app,
        // update parallax scroll positions because of page reflows
        if (window.SPR && !reset) {
          this.setSizes();
          reset = true;
        }
  
        requestAnimationFrame(this.scrollHandler.bind(this));
      },
  
      scrollHandler: function() {
        var shiftDistance = (window.scrollY - this.elTop) * speed;
        this.image.style.transform = 'translate3d(0, ' + shiftDistance + 'px, 0)';
      },
  
      setSizes: function() {
        var rect = this.container.getBoundingClientRect();
        this.elTop = rect.top + window.scrollY;
      },
  
      onReorder: function() {
        this.setSizes();
        this.onScroll();
      },
  
      destroy: function() {
        this.image.style.transform = 'none';
        window.off('scroll' + this.namespace);
        window.off('resize' + this.namespace);
      }
    });
  
    return parallax;
  })();
  
  if (typeof window.noUiSlider === 'undefined') {
    throw new Error('theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js');
  }
  
  theme.PriceRange = (function () {
    var defaultStep = 10;
    var selectors = {
      priceRange: '.price-range',
      priceRangeSlider: '.price-range__slider',
      priceRangeInputMin: '.price-range__input-min',
      priceRangeInputMax: '.price-range__input-max',
      priceRangeDisplayMin: '.price-range__display-min',
      priceRangeDisplayMax: '.price-range__display-max',
    };
  
    function PriceRange(container, {onChange, onUpdate, ...sliderOptions} = {}) {
      this.container = container;
      this.onChange = onChange;
      this.onUpdate = onUpdate;
      this.sliderOptions = sliderOptions || {};
  
      return this.init();
    }
  
    PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
      init: function () {
        if (!this.container.classList.contains('price-range')) {
          throw new Error('You must instantiate PriceRange with a valid container')
        }
  
        this.formEl = this.container.closest('form');
        this.sliderEl = this.container.querySelector(selectors.priceRangeSlider);
        this.inputMinEl = this.container.querySelector(selectors.priceRangeInputMin);
        this.inputMaxEl = this.container.querySelector(selectors.priceRangeInputMax);
        this.displayMinEl = this.container.querySelector(selectors.priceRangeDisplayMin);
        this.displayMaxEl = this.container.querySelector(selectors.priceRangeDisplayMax);
  
        this.minRange = parseFloat(this.container.dataset.min) || 0;
        this.minValue = parseFloat(this.container.dataset.minValue) || 0;
        this.maxRange = parseFloat(this.container.dataset.max) || 100;
        this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;
  
        return this.createPriceRange();
      },
  
      createPriceRange: function () {
        if (this.sliderEl && this.sliderEl.noUiSlider && typeof this.sliderEl.noUiSlider.destroy === 'function') {
          this.sliderEl.noUiSlider.destroy();
        }
  
        var slider = noUiSlider.create(this.sliderEl, {
          connect: true,
          step: defaultStep,
          ...this.sliderOptions,
          // Do not allow overriding these options
          start: [this.minValue, this.maxValue],
          range: {
            min: this.minRange,
            max: this.maxRange,
          },
        });
  
        slider.on('update', values => {
          this.displayMinEl.innerHTML = theme.Currency.formatMoney(
            values[0],
            theme.settings.moneyFormat,
          );
          this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
            values[1],
            theme.settings.moneyFormat,
          );
  
          if (this.onUpdate) {
            this.onUpdate(values);
          }
        });
  
        slider.on('change', values => {
          this.inputMinEl.value = values[0];
          this.inputMaxEl.value = values[1];
  
          if (this.onChange) {
            const formData = new FormData(this.formEl);
            this.onChange(formData);
          }
        });
  
        return slider;
      },
    });
  
    return PriceRange;
  })();
  
  theme.AjaxProduct = (function() {
    var status = {
      loading: false
    };
  
    function ProductForm(form, submit, args) {
      this.form = form;
      this.args = args;
  
      var submitSelector = submit ? submit : '.add-to-cart';
  
      if (this.form) {
        this.addToCart = form.querySelector(submitSelector);
        this.form.addEventListener('submit', this.addItemFromForm.bind(this));
      }
    };
  
    ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
      addItemFromForm: function(evt, callback){
        evt.preventDefault();
  
        if (status.loading) {
          return;
        }
  
        // Loading indicator on add to cart button
        this.addToCart.classList.add('btn--loading');
  
        status.loading = true;
  
        var data = theme.utils.serialize(this.form);
  
        fetch(theme.routes.cartAdd, {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(function(data) {
          if (data.status === 422) {
            this.error(data);
          } else {
            var product = data;
            this.success(product);
          }
  
          status.loading = false;
          this.addToCart.classList.remove('btn--loading');
  
          // Reload page if adding product from a section on the cart page
          if (document.body.classList.contains('template-cart')) {
            window.scrollTo(0, 0);
            location.reload();
          }
        }.bind(this));
      },
  
      success: function(product) {
        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }
  
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: product,
            addToCartBtn: this.addToCart
          }
        }));
  
        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added:' + this.args.scopedEventId, {
            detail: {
              product: product,
              addToCartBtn: this.addToCart
            }
          }));
        }
      },
  
      error: function(error) {
        if (!error.description) {
          console.warn(error);
          return;
        }
  
        var errors = this.form.querySelector('.errors');
        if (errors) {
          errors.remove();
        }
  
        var errorDiv = document.createElement('div');
        errorDiv.classList.add('errors', 'text-center');
        errorDiv.textContent = error.description;
        this.form.append(errorDiv);
  
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: {
            errorMessage: error.description
          }
        }));
  
        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:error:' + this.args.scopedEventId, {
            detail: {
              errorMessage: error.description
            }
          }));
        }
      }
    });
  
    return ProductForm;
  })();
  
  theme.ProductMedia = (function() {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};
  
    var selectors = {
      mediaGroup: '[data-product-single-media-group]',
      xrButton: '[data-shopify-xr]'
    };
  
    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false
      };
  
      modelViewerContainers.forEach(function(container, index) {
        var mediaId = container.dataset.mediaId;
        var modelViewerElement = container.querySelector('model-viewer');
        var modelId = modelViewerElement.dataset.modelId;
  
        if (index === 0) {
          var mediaGroup = container.closest(selectors.mediaGroup);
          var xrButton = mediaGroup.querySelector(selectors.xrButton);
          xrButtons[sectionId] = {
            element: xrButton,
            defaultId: modelId
          };
        }
  
        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          container: container,
          element: modelViewerElement
        };
  
      });
  
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
          onLoad: setupShopifyXr
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: setupModelViewerUi
        }
      ]);
  
      theme.LibraryLoader.load('modelViewerUiStyles');
    }
  
    function setupShopifyXr(errors) {
      if (errors) return;
  
      if (!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', function() {
          setupShopifyXr();
        });
        return;
      }
  
      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];
  
          if (modelSection.loaded) continue;
  
          var modelJson = document.querySelector('#ModelJson-' + sectionId);
  
          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }
  
    function setupModelViewerUi(errors) {
      if (errors) return;
  
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi && Shopify) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
          }
          setupModelViewerListeners(model);
        }
      }
    }
  
    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];
  
      model.container.addEventListener('mediaVisible', function() {
        xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
        if (theme.config.isTouch) return;
        model.modelViewerUi.play();
      });
  
      model.container.addEventListener('mediaHidden', function() {
        xrButton.element.setAttribute('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      });
  
      model.container.addEventListener('xrLaunch', function() {
        model.modelViewerUi.pause();
      });
    }
  
    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }
  
    return {
      init: init,
      removeSectionModels: removeSectionModels
    };
  })();
  
  theme.QtySelector = (function() {
    var selectors = {
      input: '.js-qty__num',
      plus: '.js-qty__adjust--plus',
      minus: '.js-qty__adjust--minus'
    };
  
    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.minValue = this.input.getAttribute('min') || 1;
  
      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id
      };
  
      this.options = Object.assign({}, defaults, options);
  
      this.init();
    }
  
    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function() {
        this.plus.addEventListener('click', function() {
          var qty = this._getQty();
          this._change(qty + 1);
        }.bind(this));
  
        this.minus.addEventListener('click', function() {
          var qty = this._getQty();
          this._change(qty - 1);
        }.bind(this));
  
        this.input.addEventListener('change', function(evt) {
          this._change(this._getQty());
        }.bind(this));
      },
  
      _getQty: function() {
        var qty = this.input.value;
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },
  
      _change: function(qty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }
  
        this.input.value = qty;
  
        if (this.options.isCart) {
          document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
              detail: [this.options.key, qty, this.wrapper]
          }));
        }
      }
    });
  
    return QtySelector;
  })();
  
  theme.initQuickShop = function() {
    var ids = [];
    var products = document.querySelectorAll('.grid-product');
  
    if (!products.length || !theme.settings.quickView) {
      return;
    }
  
    products.forEach(product => {
      product.addEventListener('mouseover', productMouseover);
    });
  
    function productMouseover(evt) {
      var el = evt.currentTarget;
      // No quick view on mobile breakpoint
      if (!theme.config.bpSmall) {
        el.removeEventListener('mouseover', productMouseover);
        if (!el || !el.dataset.productId) {
          // Onboarding product, no real data
          return;
        }
        var productId = el.dataset.productId;
        var handle = el.dataset.productHandle;
        var btn = el.querySelector('.quick-product__btn');
        theme.preloadProductModal(handle, productId, btn);
      }
    }
  };
  
  theme.preloadProductModal = function(handle, productId, btn) {
    var holder = document.getElementById('QuickShopHolder-' + handle);
    var url = theme.routes.home + '/products/' + handle + '?view=modal';
  
    // remove double `/` in case shop might have /en or language in URL
    url = url.replace('//', '/');
  
    fetch(url).then(function(response) {
      return response.text();
    }).then(function(html) {
      // Convert the HTML string into a document object
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var div = doc.querySelector('.product-section[data-product-handle="'+handle+'"]');
  
      if (!holder) {
        return;
      }
  
      holder.innerHTML = '';
      holder.append(div);
  
      // Setup quick view modal
      var modalId = 'QuickShopModal-' + productId;
      var name = 'quick-modal-' + productId;
      new theme.Modals(modalId, name);
  
      // Register product template inside quick view
      theme.sections.register('product', theme.Product, holder);
  
      // Register collapsible elements
      theme.collapsibles.init();
  
      // Register potential video modal links (when video has sound)
      theme.videoModal();
  
      if (btn) {
        btn.classList.remove('quick-product__btn--not-ready');
      }
    });
  }
  
  // theme.Slideshow handles all flickity based sliders
  // Child navigation is only setup to work on product images
  theme.Slideshow = (function() {
    var classes = {
      animateOut: 'animate-out',
      isPaused: 'is-paused',
      isActive: 'is-active'
    };
  
    var selectors = {
      allSlides: '.slideshow__slide',
      currentSlide: '.is-selected',
      wrapper: '.slideshow-wrapper',
      pauseButton: '.slideshow__pause'
    };
  
    var productSelectors = {
      thumb: '.product__thumb-item:not(.hide)',
      links: '.product__thumb-item:not(.hide) a',
      arrow: '.product__thumb-arrow'
    };
  
    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: false,
      rightToLeft: theme.config.rtl,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true
    };
  
    function slideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);
  
      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this)
      };
  
      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(productSelectors.thumb);
        this.childNavLinks = this.args.childNav.querySelectorAll(productSelectors.links);
        this.arrows = this.args.childNav.querySelectorAll(productSelectors.arrow);
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }
  
      if (this.args.avoidReflow) {
        avoidReflow(el);
      }
  
      this.slideshow = new Flickity(el, this.args);
  
      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', this._togglePause.bind(this));
        }
      }
  
      // Reset dimensions on resize
      window.on('resize', theme.utils.debounce(300, function() {
        this.resize();
      }.bind(this)));
  
      // Set flickity-viewport height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return;
        var firstChild = el.firstChild;
        while(firstChild != null && firstChild.nodeType == 3){ // skip TextNodes
          firstChild = firstChild.nextSibling;
        }
        var style = document.createElement('style');
        style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
        document.head.appendChild(style);
      }
    }
  
    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      init: function(el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);
  
        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === 'function') {
            this.args.callbacks.onInit(this.currentSlide);
          }
        }
  
        if (window.AOS) { AOS.refresh() }
      },
  
      slideChange: function(index) {
        // Outgoing fade styles
        if (this.args.fade && this.currentSlide) {
          this.currentSlide.classList.add(classes.animateOut);
          this.currentSlide.addEventListener('transitionend', function() {
            this.currentSlide.classList.remove(classes.animateOut);
          }.bind(this));
        }
  
        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }
  
        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === 'function') {
            this.args.callbacks.onChange(index);
          }
        }
  
        // Show/hide arrows depending on selected index
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle('hide', index === 0);
          this.arrows[1].classList.toggle('hide', index === (this.childNavLinks.length - 1));
        }
      },
      afterChange: function(index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach(slide => {
            slide.classList.remove(classes.animateOut);
          });
        }
  
        this.currentSlide = this.el.querySelector(selectors.currentSlide);
  
        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      destroy: function() {
        if (this.args.childNav && this.childNavLinks.length) {
          this.childNavLinks.forEach(a => {
            a.classList.remove(classes.isActive);
          });
        }
        this.slideshow.destroy();
      },
      reposition: function() {
        this.slideshow.reposition();
      },
      _togglePause: function() {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      resize: function() {
        this.slideshow.resize();
      },
      play: function() {
        this.slideshow.playPlayer();
      },
      pause: function() {
        this.slideshow.pausePlayer();
      },
      goToSlide: function(i) {
        this.slideshow.select(i);
      },
      setDraggable: function(enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },
  
      initChildNav: function() {
        this.childNavLinks[this.args.initialIndex].classList.add('is-active');
  
        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute('data-index', i);
  
          link.addEventListener('click', function(evt) {
            evt.preventDefault();
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('focus', function(evt) {
            this.goToSlide(this.getChildIndex(evt.currentTarget))
          }.bind(this));
          link.addEventListener('keydown', function(evt) {
            if (evt.keyCode === 13) {
              this.goToSlide(this.getChildIndex(evt.currentTarget))
            }
          }.bind(this));
        });
  
        // Setup optional arrows
        if (this.arrows.length) {
          this.arrows.forEach(arrow => {
            arrow.addEventListener('click', this.arrowClick.bind(this));
          });;
        }
      },
  
      getChildIndex: function(target) {
        return parseInt(target.dataset.index);
      },
  
      childNavGoTo: function(index) {
        this.childNavLinks.forEach(a => {
          a.blur();
          a.classList.remove(classes.isActive);
        });
  
        var el = this.childNavLinks[index];
        el.classList.add(classes.isActive);
  
        if (!this.args.childNavScroller) {
          return;
        }
  
        if (this.args.childVertical) {
          var elTop = el.offsetTop;
          this.args.childNavScroller.scrollTop = elTop - 100;
        } else {
          var elLeft = el.offsetLeft;
          this.args.childNavScroller.scrollLeft = elLeft - 100;
        }
      },
  
      arrowClick: function(evt) {
        if (evt.currentTarget.classList.contains('product__thumb-arrow--prev')) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      }
    });
  
    return slideshow;
  })();
  
  /*============================================================================
    VariantAvailability
    - Cross out sold out or unavailable variants
    - To disable, set dynamicVariantsEnable to false in theme.liquid
    - Required markup:
      - class=variant-input-wrap to wrap select or button group
      - class=variant-input to wrap button/label
  ==============================================================================*/
  
  theme.VariantAvailability = (function() {
    var classes = {
      disabled: 'disabled'
    };
  
    function availability(args) {
      this.type = args.type;
      this.variantsObject = args.variantsObject;
      this.currentVariantObject = args.currentVariantObject;
      this.container = args.container;
      this.namespace = args.namespace;
  
      this.init();
    }
  
    availability.prototype = Object.assign({}, availability.prototype, {
      init: function() {
        this.container.on('variantChange' + this.namespace, this.setAvailability.bind(this));
  
        // Set default state based on current selected variant
        this.setInitialAvailability();
      },
  
      // Create a list of all options. If any variant exists and is in stock with that option, it's considered available
      createAvailableOptionsTree(variants, lastSelectedIndex, lastSelectedValue, currentlySelectedValues = []) {
        // Reduce variant array into option availability tree
        return variants.reduce((options, variant) => {
  
          const numberOfOptionTypes = variant.options.length;
  
          // Check each option group (e.g. option1, option2, option3) of the variant
          Object.keys(options).forEach(index => {
  
            if (variant[index] === null) return;
  
            let entry = options[index].find(option => option.value === variant[index]);
  
            if (typeof entry === 'undefined') {
              // If option has yet to be added to the options tree, add it
              entry = {value: variant[index], soldOut: true}
              options[index].push(entry);
            }
  
            if (currentlySelectedValues.length > 0) {
              // If the user has selected a value
                  if (numberOfOptionTypes === 1) {
                    // If we're dealing with a single variant selector, enable options that are available
                    entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                  } else if (numberOfOptionTypes === 2) {
                    // If we're dealing with a double variant selector
                    if (currentlySelectedValues.some(({value, index}) => variant[index] === value)) {
                      // Only enable options that have at least one match (.some()) with an available variant
                      entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                    }
                  } else if (numberOfOptionTypes === 3) {
                    // If we're dealing with a triple variant selector
                    if (currentlySelectedValues.length === 1) {
                      // If only one value has been selected
                      if (index !== lastSelectedIndex) {
                        // If we're checking an option that is not part of the group that was just selected
                        if (currentlySelectedValues.every(({value, index}) => variant[index] === value)) {
                          // Only enable options from variants that match the currently selected value
                          entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                        }
                      } else {
                        // Other options in the same group of the one that was selected should remain unchanged
                        entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                      }
  
                    } else if (currentlySelectedValues.length === 2) {
                      // If only two values have been selected
                      if (currentlySelectedValues.every(({value, index}) => variant[index] === value)) {
                        // Only enable options from variants that match the 2 currently selected values
                        entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                      }
                    } else if (currentlySelectedValues.length === 3) {
                      // If all three values have been selected
                      // Check how many selected option values match a variant
                      const variantOptionsThatMatchCurrent = currentlySelectedValues.reduce((count, {value, index}) => {
                        return variant[index] === value ? count + 1 : count;
                      },0)
  
                      // Only enable an option if an available variant matches any 2 currently selected values
                      if (variantOptionsThatMatchCurrent >= 2) {
                        entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
                      }
                    }
                  }
            } else {
              // If the user has not selected a value yet, show all options that are available.
              // An option will only initially appear disabled if it is out of stock/unavailable across all variants
              entry.soldOut = entry.soldOut && variant.available ? false : entry.soldOut;
            }
          })
  
          return options;
        }, { option1: [], option2: [], option3: []})
      },
  
      setInitialAvailability: function() {
        this.container.querySelectorAll('.variant-input-wrap').forEach(group => {
          this.disableVariantGroup(group);
        });
  
        const initialOptions = this.createAvailableOptionsTree(this.variantsObject);
  
        for (var [option, values] of Object.entries(initialOptions)) {
          this.manageOptionState(option, values);
        }
      },
  
      setAvailability: function(evt) {
  
        const {value: lastSelectedValue, index: lastSelectedIndex, currentlySelectedValues} = evt.detail;
  
        // Object to hold all options by value.
        // This will be what sets a button/dropdown as
        // sold out or unavailable (not a combo set as purchasable)
        const valuesToManage = this.createAvailableOptionsTree(this.variantsObject, lastSelectedIndex, lastSelectedValue, currentlySelectedValues)
  
        // Disable all options to start.
        // If coming from a variant change event, do not disable
        // options inside current index group
        this.container.querySelectorAll('.variant-input-wrap').forEach(group => {
          this.disableVariantGroup(group);
        });
  
        // Loop through all option levels and send each
        // value w/ args to function that determines to show/hide/enable/disable
        for (var [option, values] of Object.entries(valuesToManage)) {
          this.manageOptionState(option, values, lastSelectedValue);
        }
      },
  
      manageOptionState: function(option, values, selectedValue) {
        var group = this.container.querySelector('.variant-input-wrap[data-index="'+ option +'"]');
  
        // Loop through each option value
        values.forEach(obj => {
          this.enableVariantOption(group, obj, selectedValue);
        });
      },
  
      enableVariantOption: function(group, obj, selectedValue) {
        // Selecting by value so escape it
        var value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
  
        if (this.type === 'dropdown') {
          group.querySelector('option[value="'+ value +'"]').disabled = false;
        } else {
          var buttonGroup = group.querySelector('.variant-input[data-value="'+ value +'"]');
          var input = buttonGroup.querySelector('input');
          var label = buttonGroup.querySelector('label');
  
          // Variant exists - enable & show variant
          input.classList.remove(classes.disabled);
          label.classList.remove(classes.disabled);
  
          // Variant sold out - cross out option (remains selectable)
          if (obj.soldOut) {
            input.classList.add(classes.disabled);
            label.classList.add(classes.disabled);
  
            if (value !== selectedValue) {
              input.checked = false
            }
          }
        }
      },
  
      disableVariantGroup: function(group) {
        if (this.type === 'dropdown') {
          group.querySelectorAll('option').forEach(option => {
            option.disabled = true;
          });
        } else {
          group.querySelectorAll('input').forEach(input => {
            input.classList.add(classes.disabled);
          });
          group.querySelectorAll('label').forEach(label => {
            label.classList.add(classes.disabled);
          });
        }
      }
  
    });
  
    return availability;
  })();
  
  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function() {
    var youtubePlayer;
  
    var videoHolderId = 'VideoHolder';
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      mp4Trigger: '.product-video-trigger--mp4',
      mp4Player: '.product-video-mp4-sound'
    };
  
    var youtubeTriggers = document.querySelectorAll(selectors.youtube);
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);
  
    if (!youtubeTriggers.length && !mp4Triggers.length) {
      return;
    }
  
    var videoHolderDiv = document.getElementById(videoHolderId);
  
    if (youtubeTriggers.length) {
      theme.LibraryLoader.load('youtubeSdk');
    }
  
    var modal = new theme.Modals('VideoModal', 'video-modal', {
      closeOffContentClick: true,
      bodyOpenClass: ['modal-open', 'video-modal-open'],
      solid: true
    });
  
    youtubeTriggers.forEach(btn => {
      btn.addEventListener('click', triggerYouTubeModal);
    });
  
    mp4Triggers.forEach(btn => {
      btn.addEventListener('click', triggerMp4Modal);
    });
  
    document.addEventListener('modalClose.VideoModal', closeVideoModal);
  
    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.youTubeReady) {
        return;
      }
  
      evt.preventDefault();
      emptyVideoHolder();
  
      modal.open(evt);
  
      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute('href'));
      youtubePlayer = new theme.YouTube(
        videoHolderId,
        {
          videoId: videoId,
          style: 'sound',
          events: {
            onReady: onYoutubeReady
          }
        }
      );
    }
  
    function triggerMp4Modal(evt) {
      emptyVideoHolder();
  
      var el = evt.currentTarget;
      var player = el.parentNode.querySelector(selectors.mp4Player);
  
      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true);
      playerClone.classList.remove('hide');
  
      videoHolderDiv.append(playerClone);
      modal.open(evt);
  
      // Play new video element
      videoHolderDiv.querySelector('video').play();
    }
  
    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }
  
    function getYoutubeVideoId(url) {
      var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return (match&&match[7].length==11)? match[7] : false;
    }
  
    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = '';
    }
  
    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === 'function') {
        youtubePlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  };
  
  
  /*============================================================================
    ToolTip
  ==============================================================================*/
  
  class ToolTip extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.inner = this.querySelector('[data-tool-tip-inner]');
      this.closeButton = this.querySelector('[data-tool-tip-close]');
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
  
      this.triggers = document.querySelectorAll('[data-tool-tip-trigger]');
  
      document.addEventListener('tooltip:open', e => {
        this._open(e.detail.context, e.detail.content);
      });
    }
  
    _open(context, insertedHtml) {
      this.toolTipContent.innerHTML = insertedHtml;
  
      theme.a11y.trapFocus({
        container: this.el,
        namespace: 'tooltip_focus'
      });
  
      if (this.closeButton) {
        this.closeButton.on('click' + '.tooltip-close', () => {
          this._close();
        });
      }
  
      document.documentElement.on('click' + '.tooltip-outerclick', event => {
        if (this.el.dataset.toolTipOpen === 'true' && !this.inner.contains(event.target)) this._close();
      });
  
      document.documentElement.on('keydown' + '.tooltip-esc', event => {
        if (event.code === 'Escape') this._close();
      });
  
      this.el.dataset.toolTipOpen = true;
      this.el.dataset.toolTip = context;
    }
  
    _close() {
      this.toolTipContent.innerHTML = '';
      this.el.dataset.toolTipOpen = 'false';
      this.el.dataset.toolTip = '';
  
      theme.a11y.removeTrapFocus({
        container: this.el,
        namespace: 'tooltip_focus'
      });
  
      this.closeButton.off('click' + '.tooltip-close');
      document.documentElement.off('click' + '.tooltip-outerclick');
      document.documentElement.off('keydown' + '.tooltip-esc');
    }
  }
  
  customElements.define('tool-tip', ToolTip);
  
  /*============================================================================
    ToolTipTrigger
  ==============================================================================*/
  
  class ToolTipTrigger extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.toolTipContent = this.querySelector('[data-tool-tip-content]');
  
      this.init();
    }
  
    init() {
      //Create and dispatch customEvent
      const toolTipOpen = new CustomEvent('tooltip:open', {
        detail: {
          context: this.dataset.toolTip,
          content: this.toolTipContent.innerHTML
        },
        bubbles: true
      });
  
      this.el.addEventListener('click', e => {
        e.stopPropagation();
        this.dispatchEvent(toolTipOpen);
      });
    }
  }
  
  customElements.define('tool-tip-trigger', ToolTipTrigger);
  

  theme.announcementBar = (function() {
    var args = {
      autoPlay: 5000,
      avoidReflow: true,
      cellAlign: theme.config.rtl ? 'right' : 'left'
    };
    var bar;
    var flickity;
  
    function init() {
      bar = document.getElementById('AnnouncementSlider');
      if (!bar) {
        return;
      }
  
      unload();
  
      if (bar.dataset.blockCount === 1) {
        return;
      }
  
      if (theme.config.bpSmall || bar.dataset.compact === 'true') {
        initSlider();
      }
  
      document.addEventListener('matchSmall', function() {
        unload();
        initSlider();
      });
  
      document.addEventListener('unmatchSmall', function() {
        unload();
        if (bar.dataset.compact === 'true') {
          initSlider();
        }
      });
    }
  
    function initSlider() {
      flickity = new theme.Slideshow(bar, args);
    }
  
    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var slide = bar.querySelector('#AnnouncementSlide-' + id);
      var index = parseInt(slide.dataset.index);
  
      if (flickity && typeof flickity.pause === 'function') {
        flickity.goToSlide(index);
        flickity.pause();
      }
    }
  
    function onBlockDeselect() {
      if (flickity && typeof flickity.play === 'function') {
        flickity.play();
      }
    }
  
    function unload() {
      if (flickity && typeof flickity.destroy === 'function') {
        flickity.destroy();
      }
    }
  
    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload
    };
  })();
  
  theme.customerTemplates = function() {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();
  
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === '#recover') {
        toggleRecoverPasswordForm();
      }
    }
  
    function toggleRecoverPasswordForm() {
      var passwordForm = document.getElementById('RecoverPasswordForm').classList.toggle('hide');
      var loginForm = document.getElementById('CustomerLoginForm').classList.toggle('hide');
    }
  
    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById('RecoverPassword');
      if (recoverForm) {
        recoverForm.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
  
      // Hide reset password form
      var hideRecoverPassword = document.getElementById('HideRecoverPasswordLink');
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener('click', function(evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }
  
    function resetPasswordSuccess() {
      var formState = document.querySelector('.reset-password-success');
  
      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }
  
      // show success message
      document.getElementById('ResetSuccess').classList.remove('hide');
    }
  
    function customerAddressForm() {
      var newAddressForm = document.getElementById('AddressNewForm');
      var addressForms = document.querySelectorAll('.js-address-form');
  
      if (!newAddressForm || !addressForms.length) {
        return;
      }
  
      // Country/province selector can take a short time to load
      setTimeout(function() {
        document.querySelectorAll('.js-address-country').forEach(el => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;
  
          new Shopify.CountryProvinceSelector(
            countryId,
            provinceId,
            {
              hideElement: provinceContainerId
            }
          );
        });
      }, 1000);
  
      // Toggle new/edit address forms
      document.querySelectorAll('.address-new-toggle').forEach(el => {
        el.addEventListener('click', function() {
          newAddressForm.classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-edit-toggle').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          document.getElementById('EditAddress_' + formId).classList.toggle('hide');
        });
      });
  
      document.querySelectorAll('.address-delete').forEach(el => {
        el.addEventListener('click', function(evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;
  
          if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
            if (Shopify) {
              Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
            }
          }
        })
      });
    }
  };
  
  theme.CartDrawer = (function() {
    var selectors = {
      drawer: '#CartDrawer',
      form: '#CartDrawerForm'
    };
  
    function CartDrawer() {
      this.form = document.querySelector(selectors.form);
      this.drawer = new theme.Drawers('CartDrawer', 'cart');
  
      this.init();
    }
  
    CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
      init: function() {
        this.cartForm = new theme.CartForm(this.form);
        this.cartForm.buildCart();
  
        document.addEventListener('ajaxProduct:added', function(evt) {
          this.cartForm.buildCart();
          this.open();
        }.bind(this));
  
        // Dev-friendly way to open cart
        document.addEventListener('cart:open', this.open.bind(this));
        document.addEventListener('cart:close', this.close.bind(this));
      },
  
      open: function() {
        this.drawer.open();
      },
  
      close: function() {
        this.drawer.close();
      }
    });
  
    return CartDrawer;
  })();
  
  theme.headerNav = (function() {
    var selectors = {
      wrapper: '#HeaderWrapper',
      siteHeader: '#SiteHeader',
      searchBtn: '.js-search-header',
      closeSearch: '#SearchClose',
      searchContainer: '.site-header__search-container',
      logo: '#LogoContainer img',
      megamenu: '.megamenu',
      navItems: '.site-nav__item',
      navLinks: '.site-nav__link',
      navLinksWithDropdown: '.site-nav__link--has-dropdown',
      navDropdownLinks: '.site-nav__dropdown-link--second-level'
    };
  
    var classes = {
      hasDropdownClass: 'site-nav--has-dropdown',
      hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
      dropdownActive: 'is-focused'
    };
  
    var config = {
      namespace: '.siteNav',
      wrapperOverlayed: false,
      overlayedClass: 'is-light',
      overlayEnabledClass: 'header-wrapper--sticky',
      stickyEnabled: false,
      stickyActive: false,
      stickyClass: 'site-header--stuck',
      stickyHeaderWrapper: 'StickyHeaderWrap',
      openTransitionClass: 'site-header--opening',
      lastScroll: 0
    };
  
    // Elements used in resize functions, defined in init
    var wrapper;
    var siteHeader;
  
    function init() {
      wrapper = document.querySelector(selectors.wrapper);
      siteHeader = document.querySelector(selectors.siteHeader);
  
      config.stickyEnabled = (siteHeader.dataset.sticky === 'true');
      if (config.stickyEnabled) {
        config.wrapperOverlayed = wrapper.classList.contains(config.overlayedClass);
        stickyHeaderCheck();
      }
  
      theme.settings.overlayHeader = (siteHeader.dataset.overlay === 'true');
      // Disable overlay header if on collection template with no collection image
      if (theme.settings.overlayHeader && Shopify && Shopify.designMode) {
        if (document.body.classList.contains('template-collection') && !document.querySelector('.collection-hero')) {
          this.disableOverlayHeader();
        }
      }
  
      accessibleDropdowns();
      searchDrawer();
  
      window.on('load' + config.namespace, resizeLogo);
      window.on('resize' + config.namespace, theme.utils.debounce(150, resizeLogo));
    }
  
    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      wrapper.classList.remove(config.overlayEnabledClass, config.overlayedClass);
      config.wrapperOverlayed = false;
      theme.settings.overlayHeader = false;
    }
  
    function stickyHeaderCheck() {
      // Disable sticky header if any mega menu is taller than window
      theme.config.stickyHeader = doesMegaMenuFit();
  
      if (theme.config.stickyHeader) {
        config.forceStopSticky = false;
        stickyHeader();
      } else {
        config.forceStopSticky = true;
      }
    }
  
    function doesMegaMenuFit() {
      var largestMegaNav = 0;
      siteHeader.querySelectorAll(selectors.megamenu).forEach(nav => {
        var h = nav.offsetHeight;
        if (h > largestMegaNav) {
          largestMegaNav = h;
        }
      });
  
      // 120 ~ space of visible header when megamenu open
      if (window.innerHeight < (largestMegaNav + 120)) {
        return false;
      }
  
      return true;
    }
  
    function stickyHeader() {
      config.lastScroll = 0;
  
      var wrapWith = document.createElement('div');
      wrapWith.id = config.stickyHeaderWrapper;
      theme.utils.wrap(siteHeader, wrapWith);
  
      stickyHeaderHeight();
  
      window.on('resize' + config.namespace, theme.utils.debounce(50, stickyHeaderHeight));
      window.on('scroll' + config.namespace, theme.utils.throttle(20, stickyHeaderScroll));
  
      // This gets messed up in the editor, so here's a fix
      if (Shopify && Shopify.designMode) {
        setTimeout(function() {
          stickyHeaderHeight();
        }, 250);
      }
    }
  
    function stickyHeaderHeight() {
      if (!config.stickyEnabled) {
        return;
      }
      var h = siteHeader.offsetHeight;
      var stickyHeader = document.querySelector('#' + config.stickyHeaderWrapper);
      stickyHeader.style.height = h + 'px';
    }
  
    function stickyHeaderScroll() {
      if (!config.stickyEnabled) {
        return;
      }
  
      if (config.forceStopSticky) {
        return;
      }
  
      requestAnimationFrame(scrollHandler);
  
      config.lastScroll = window.scrollY;
    }
  
    function scrollHandler() {
      if (window.scrollY > 250) {
        if (config.stickyActive) {
          return;
        }
  
        config.stickyActive = true;
  
        siteHeader.classList.add(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.remove(config.overlayedClass);
        }
  
        // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly
        setTimeout(function() {
          siteHeader.classList.add(config.openTransitionClass);
        }, 100);
      } else {
        if (!config.stickyActive) {
          return;
        }
  
        config.stickyActive = false;
  
        siteHeader.classList.remove(config.openTransitionClass);
        siteHeader.classList.remove(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.add(config.overlayedClass);
        }
      }
    }
  
    function accessibleDropdowns() {
      var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
      var closeOnClickActive = false;
  
      // Touch devices open dropdown on first click, navigate to link on second
      if (theme.config.isTouch) {
        document.querySelectorAll(selectors.navLinksWithDropdown).forEach(el => {
          el.on('touchend' + config.namespace, function(evt) {
            var parent = evt.currentTarget.parentNode;
            if (!parent.classList.contains(classes.dropdownActive)) {
              evt.preventDefault();
              closeDropdowns();
              openFirstLevelDropdown(evt.currentTarget);
            } else {
              window.location.replace(evt.currentTarget.getAttribute('href'));
            }
          });
        });
      }
  
      // Open/hide top level dropdowns
      document.querySelectorAll(selectors.navLinks).forEach(el => {
        el.on('focusin' + config.namespace, accessibleMouseEvent);
        el.on('mouseover' + config.namespace, accessibleMouseEvent);
        el.on('mouseleave' + config.namespace, closeDropdowns);
      });
  
      document.querySelectorAll(selectors.navDropdownLinks).forEach(el => {
        if (theme.config.isTouch) {
          el.on('touchend' + config.namespace, function(evt) {
            var parent = evt.currentTarget.parentNode;
  
            // Open third level menu or go to link based on active state
            if (parent.classList.contains(classes.hasSubDropdownClass)) {
              if (!parent.classList.contains(classes.dropdownActive)) {
                evt.preventDefault();
                closeThirdLevelDropdown();
                openSecondLevelDropdown(evt.currentTarget);
              } else {
                window.location.replace(evt.currentTarget.getAttribute('href'));
              }
            } else {
              // No third level nav, go to link
              window.location.replace(evt.currentTarget.getAttribute('href'));
            }
          });
        }
  
        // Open/hide sub level dropdowns
        el.on('focusin' + config.namespace, function(evt) {
          closeThirdLevelDropdown();
          openSecondLevelDropdown(evt.currentTarget, true);
        })
      });
  
      // Clicking outside of the megamenu should close it
      if (theme.config.isTouch) {
        document.body.on('touchend' + config.namespace, function() {
          closeDropdowns();
        });
  
        // Exception to above: clicking anywhere on the megamenu content will NOT close it
        siteHeader.querySelectorAll(selectors.megamenu).forEach(el => {
          el.on('touchend' + config.namespace, function(evt) {
            evt.stopImmediatePropagation();
          });
        });
      }
  
      function accessibleMouseEvent(evt) {
        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }
  
        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }
  
        openFirstLevelDropdown(evt.currentTarget);
      }
  
      // Private dropdown functions
      function openFirstLevelDropdown(el) {
        var parent = el.parentNode;
        if (parent.classList.contains(classes.hasDropdownClass)) {
          parent.classList.add(classes.dropdownActive);
          hasActiveDropdown = true;
        }
  
        if (!theme.config.isTouch) {
          if (!closeOnClickActive) {
            var eventType = theme.config.isTouch ? 'touchend' : 'click';
            closeOnClickActive = true;
            document.documentElement.on(eventType + config.namespace, function() {
              closeDropdowns();
              document.documentElement.off(eventType + config.namespace);
              closeOnClickActive = false;
            }.bind(this));
          }
        }
      }
  
      function openSecondLevelDropdown(el, skipCheck) {
        var parent = el.parentNode;
        if (parent.classList.contains(classes.hasSubDropdownClass) || skipCheck) {
          parent.classList.add(classes.dropdownActive);
          hasActiveSubDropdown = true;
        }
      }
  
      function closeDropdowns() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      }
  
      function closeSecondLevelDropdown() {
        document.querySelectorAll(selectors.navItems).forEach(el => {
          el.classList.remove(classes.dropdownActive)
        });
      }
  
      function closeThirdLevelDropdown() {
        document.querySelectorAll(selectors.navDropdownLinks).forEach(el => {
          el.parentNode.classList.remove(classes.dropdownActive);
        });
      }
    }
  
    function searchDrawer() {
      document.querySelectorAll(selectors.searchBtn).forEach(btn => {
        btn.addEventListener('click', openSearchDrawer);
      });
  
      document.querySelector(selectors.closeSearch).addEventListener('click', closeSearchDrawer);
    }
  
    function openSearchDrawer(evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      var container = document.querySelector(selectors.searchContainer);
      theme.utils.prepareTransition(container, function() {
        container.classList.add('is-active');
      }.bind(this));
  
      document.documentElement.classList.add('js-drawer-open', 'js-drawer-open--search');
  
      setTimeout(function() {
        theme.a11y.trapFocus({
          container: container,
          namespace: 'header_search',
          elementToFocus: container.querySelector('.site-header__search-input')
        });
      }, 100);
  
      // If sticky is enabled, scroll to top on mobile when close to it
      // so you don't get an invisible search box
      if (theme.config.bpSmall && config.stickyEnabled && config.lastScroll < 300) {
        window.scrollTo(0,0);
      }
  
      // Bind events
      theme.a11y.lockMobileScrolling(config.namespace);
  
      bindSearchEvents();
    }
  
    function closeSearchDrawer(evt) {
      // Do not close if click event came from inside drawer
      if (evt) {
        // evt.path is non-standard, so have fallback
        var path = evt.path || (evt.composedPath && evt.composedPath());
        for (var i = 0; i < path.length; i++) {
          if (path[i].classList) {
            if (path[i].classList.contains('site-header__search-btn')) {
              break;
            }
  
            if (path[i].classList.contains('site-header__search-container')) {
              return;
            }
          }
        }
      }
  
      // deselect any focused form elements
      document.activeElement.blur();
  
      document.documentElement.classList.add('js-drawer-closing');
      document.documentElement.classList.remove('js-drawer-open', 'js-drawer-open--search');
  
      window.setTimeout(function() {
        document.documentElement.classList.remove('js-drawer-closing');
      }.bind(this), 500);
  
      var container = document.querySelector(selectors.searchContainer);
      theme.utils.prepareTransition(container, function() {
        container.classList.remove('is-active');
      }.bind(this));
  
      theme.a11y.removeTrapFocus({
        container: container,
        namespace: 'header_search'
      });
  
      theme.a11y.unlockMobileScrolling(config.namespace);
  
      unbindSearchEvents();
    }
  
    function bindSearchEvents() {
      window.on('keyup' + config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          closeSearchDrawer();
        }
      }.bind(this));
  
      // Clicking out of container closes it
      document.documentElement.on('click' + config.namespace, function(evt) {
        closeSearchDrawer(evt);
      }.bind(this));
    }
  
    function unbindSearchEvents() {
      window.off('keyup' + config.namespace);
      document.documentElement.off('click' + config.namespace);
    }
  
    function resizeLogo(evt) {
      document.querySelectorAll(selectors.logo).forEach(logo => {
        var logoWidthOnScreen = logo.clientWidth;
        var containerWidth = logo.closest('.header-item').clientWidth;
  
        // If image exceeds container, let's make it smaller
        if (logoWidthOnScreen > containerWidth) {
          logo.style.maxWidth = containerWidth;
        }
        else {
          logo.removeAttribute('style')
        }
      });
    }
    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader
    };
  })();
  
  window.onpageshow = function(evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      document.body.classList.remove('unloading');
      document.querySelectorAll('.cart__checkout').forEach(el => {
        el.classList.remove('btn--loading');
      });
    }
  };
  
  theme.predictiveSearch = (function() {
    var currentString = '';
    var isLoading = false;
    var searchTimeout;
    var namespace = '.predictive';
  
    var selectors = {
      form: '#HeaderSearchForm',
      input: 'input[type="search"]',
      wrapper: '#PredictiveWrapper',
      resultDiv: '#PredictiveResults',
      searchButton: '[data-predictive-search-button]'
    };
  
    var cache = {};
    var config = {
      imageSize: 'square'
    }
  
    var classes = {
      isActive: 'predicitive-active'
    };
  
    var keys = {
      up_arrow: 38,
      down_arrow: 40,
      tab: 9
    };
  
    function init() {
      // Only some languages support predictive search
      if (document.getElementById('shopify-features')) {
        var supportedShopifyFeatures = JSON.parse(document.getElementById('shopify-features').innerHTML);
        if (!supportedShopifyFeatures.predictiveSearch) {
          return;
        }
      }
  
      cache.wrapper = document.querySelector(selectors.wrapper);
  
      if (!cache.wrapper) {
        return;
      }
  
      config.imageSize = cache.wrapper.dataset.imageSize;
  
      cache.form = document.querySelector(selectors.form);
      cache.form.setAttribute('autocomplete', 'off');
      cache.form.on('submit' + namespace, submitSearch);
  
      cache.input = cache.form.querySelector(selectors.input);
      cache.input.on('keyup' + namespace, handleKeyup);
  
      cache.submit = cache.wrapper.querySelector(selectors.searchButton);
      cache.submit.on('click' + namespace, triggerSearch);
  
      cache.results = document.querySelector(selectors.resultDiv);
    }
  
    function reset() {
      cache.wrapper.classList.add('hide');
      cache.results.innerHTML = '';
      clearTimeout(searchTimeout);
    }
  
    function triggerSearch() {
      cache.form.submit();
    }
  
    // Append * wildcard to search
    function submitSearch(evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
  
      var obj = {};
      var formData = new FormData(evt.target);
      for (var key of formData.keys()) {
        obj[key] = formData.get(key);
      }
  
      if (obj.q) {
        obj.q += '*';
      }
  
      var params = paramUrl(obj);
  
      window.location.href = `${theme.routes.search}?${params}`;
      return false;
    }
  
    function handleKeyup(evt) {
      if (evt.keyCode === keys.up_arrow) {
        return;
      }
  
      if (evt.keyCode === keys.down_arrow) {
        return;
      }
  
      if (evt.keyCode === keys.tab) {
        return;
      }
  
      search();
    }
  
    function search() {
      var keyword = cache.input.value;
  
      if (keyword === '') {
        reset();
        return;
      }
  
      var q = _normalizeQuery(keyword);
  
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(
        function () {
          predictQuery(q);
        }.bind(this),
        500
      );
    }
  
    function predictQuery(q) {
      if (isLoading) {
        return;
      }
  
      // Do not re-search the same thing
      if (currentString === q) {
        return;
      }
  
      currentString = q;
      isLoading = true;
  
      var searchObj = {
        'q': q,
        'resources[type]': theme.settings.predictiveSearchType,
        'resources[limit]': 4,
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,variants.title,vendor'
      };
  
      var params = paramUrl(searchObj);
  
      fetch('/search/suggest.json?' + params)
      .then(response => response.json())
      .then(suggestions => {
        isLoading = false;
        var data = {};
        var resultCount = 0;
  
        cache.wrapper.classList.remove('hide');
        var resultTypes = Object.entries(suggestions.resources.results);
  
        Object.keys(resultTypes).forEach(function (i) {
          var obj = resultTypes[i];
          var type = obj[0];
          var results = obj[1];
          resultCount += results.length;
  
          switch(type) {
            case 'products':
              data[type] = buildProducts(results);
              break;
            case 'collections':
              data[type] = buildCollections(results);
              break;
            case 'pages':
              data[type] = buildPages(results);
              break;
            case 'articles':
              data[type] = buildArticles(results);
              break;
          }
        });
  
        if (resultCount === 0) {
          reset();
          return;
        }
  
        // Build and append result markup
        var output = buildOutput(data);
        cache.results.innerHTML = '';
        cache.results.innerHTML = output;
      });
    }
  
    function buildProducts(results) {
      var output = '';
      var products = [];
  
      results.forEach(product => {
        var new_product = {
          title: product.title,
          url: product.url,
          image_responsive_url: theme.Images.lazyloadImagePath(product.image),
          image_aspect_ratio: product.featured_image.aspect_ratio
        };
  
        products.push(new_product);
      });
  
      if (products.length) {
        var markup = theme.buildProductGridItem(products, 'small--one-half medium-up--one-quarter', 4, config.imageSize);
  
        output = `
          <div data-type-products>
            <div class="grid grid--uniform">
              ${markup}
            </div>
          </div>
        `;
      }
  
      return output;
    }
  
    function buildCollections(collections) {
      var output = '';
  
      if (collections.length) {
        var markup = theme.buildCollectionItem(collections);
  
        output = `
          <div data-type-collections>
            <p class="h6 predictive__label">${theme.strings.searchCollections}</p>
            <ul class="no-bullets">
              ${markup}
            </ul>
          </div>
        `;
      }
  
      return output;
    }
  
    function buildPages(pages) {
      var output = '';
  
      if (pages.length) {
        var markup = theme.buildPageItem(pages);
  
        output = `
          <div data-type-pages>
            <p class="h6 predictive__label">${theme.strings.searchPages}</p>
            <ul class="no-bullets">
              ${markup}
            </ul>
          </div>
        `;
      }
  
      return output;
    }
  
    // Overwrite full sized image returned form API
    // with lazyloading-friendly path
    function buildArticles(articles) {
      var output = '';
  
      articles.forEach(article => {
        if (article.image) {
          article.image = theme.Images.getSizedImageUrl(article.image, '200x200_crop_center');
        }
      });
  
      if (articles.length) {
        var markup = theme.buildArticleItem(articles, config.imageSize);
  
        output = `
          <div data-type-articles>
            <p class="h6 predictive__label">${theme.strings.searchArticles}</p>
            <div class="grid grid--uniform">
              ${markup}
            </div>
          </div>
        `;
      }
  
      return output;
    }
  
    // Combine all search result markup and print to page
    function buildOutput(data) {
      var output = '';
  
      if (data.products && data.products !== '') {
        output += data.products;
      }
  
      if (data.collections && data.collections !== '') {
        output += data.collections;
      }
  
      if (data.pages && data.pages !== '') {
        output += data.pages;
      }
  
      if (data.articles && data.articles !== '') {
        output += data.articles;
      }
  
      return output;
    }
  
    function _normalizeQuery(string) {
      if (typeof string !== 'string') {
        return null;
      }
  
      return string
        .trim()
        .replace(/\ /g, '-')
        .toLowerCase();
    }
  
    function paramUrl(obj) {
      return Object.keys(obj).map(function(key) {
        return key + '=' + encodeURIComponent(obj[key]);
      }).join('&')
    }
  
    return {
      init: init
    };
  })();
  
  theme.buildProductGridItem = function(items, gridWidth, rowOf, imageSize) {
    var output = '';
  
    items.forEach(product => {
      var image = theme.buildProductImage(product, imageSize);
      var markup = `
        <div class="grid__item grid-product ${gridWidth} aos-animate" data-aos="row-of-${rowOf}">
          <div class="grid-product__content">
            <a href="${product.url}" class="grid-product__link">
              <div class="grid-product__image-mask">
                ${image}
              </div>
              <div class="grid-product__meta">
                <div class="grid-product__title">${product.title}</div>
              </div>
            </a>
          </div>
        </div>
      `;
  
      output += markup;
    });
  
    return output;
  }
  
  theme.buildProductImage = function(product, imageSize) {
    var size = imageSize ? imageSize : theme.settings.productImageSize;
    var output = '';
  
    if (size === 'natural') {
      output = `
        <div class="image-wrap" style="height: 0; padding-bottom: ${product.image_aspect_ratio}%;">
          <img class="grid-product__image lazyload"
            data-src="${product.image_responsive_url}"
            data-widths="[180, 360, 540, 720, 900]"
            data-aspectratio="${product.image_aspect_ratio}"
            data-sizes="auto"
            alt="${product.title}">
        </div>`;
    } else {
      var classes = 'lazyload';
      if (!theme.settings.productImageCover) {
        classes += ' grid__image-contain';
      }
      output = `
        <div class="grid__image-ratio grid__image-ratio--${size}">
          <img class="${classes}"
              data-src="${product.image_responsive_url}"
              data-widths="[360, 540, 720, 900, 1080]"
              data-aspectratio="${product.aspect_ratio}"
              data-sizes="auto"
              alt="${product.title}">
        </div>
      `;
    }
  
    return output;
  }
  
  theme.buildCollectionItem = function(items) {
    var output = '';
  
    items.forEach(collection => {
      var markup = `
        <li>
          <a href="${collection.url}">
            ${collection.title}
          </a>
        </li>
      `;
  
      output += markup;
    });
  
    return output;
  }
  
  theme.buildPageItem = function(items) {
    var output = '';
  
    items.forEach(page => {
      var markup = `
        <li>
          <a href="${page.url}">
            ${page.title}
          </a>
        </li>
      `;
  
      output += markup;
    });
  
    return output;
  }
  
  theme.buildArticleItem = function(items, imageSize) {
    var output = '';
  
    items.forEach(article => {
      var image = theme.buildPredictiveImage(article);
      var markup = `
        <div class="grid__item grid-product small--one-half medium-up--one-quarter" data-aos="row-of-4">
          <a href="${article.url}" class="grid-product__link grid-product__link--inline">
            <div class="grid-product__image-mask">
              <div
                class="grid__image-ratio grid__image-ratio--object grid__image-ratio--${imageSize}">
                <div class="predictive__image-wrap">
                  ${image}
                </div>
              </div>
            </div>
            <div class="grid-product__meta">
              ${article.title}
            </div>
          </a>
        </div>
      `;
  
      output += markup;
    });
  
    return output;
  }
  
  theme.buildPredictiveImage = function(obj) {
    var imageMarkup = '';
    if (obj.image) {
      imageMarkup = `<img class="lazyload"
            data-src="${obj.image}"
            data-widths="[360, 540, 720]"
            data-sizes="auto">`;
    }
    return imageMarkup;
  }
  

  theme.Maps = (function() {
    var config = {
      zoom: 14
    };
    var apiStatus = null;
    var mapsToLoad = [];
  
    var errors = {};
  
    var selectors = {
      section: '[data-section-type="map"]',
      map: '[data-map]',
      mapOverlay: '.map-section__overlay'
    };
  
    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function() {
      if (!Shopify.designMode) {
        return;
      }
  
      document.querySelectorAll(selectors.section).forEach(section => {
        section.classList.add('map-section--load-error');
      });
  
      document.querySelectorAll(selectors.map).forEach(map => {
        map.parentNode.removeChild(map);
      });
  
      window.mapError(theme.strings.authError);
    };
  
    window.mapError = function(error) {
      var message = document.createElement('div');
      message.classList.add('map-section__error', 'errors', 'text-center');
      message.innerHTML = error;
      document.querySelectorAll(selectors.mapOverlay).forEach(overlay => {
        overlay.parentNode.prepend(message);
      });
      document.querySelectorAll('.map-section__link').forEach(link => {
        link.classList.add('hide');
      });
    };
  
    function Map(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.map-' + this.sectionId;
      this.map = container.querySelector(selectors.map);
      this.key = this.map.dataset.apiKey;
  
      errors = {
        addressNoResults: theme.strings.addressNoResults,
        addressQueryLimit: theme.strings.addressQueryLimit,
        addressError: theme.strings.addressError,
        authError: theme.strings.authError
      };
  
      if (!this.key) {
        return;
      }
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.prepMapApi.bind(this),
        threshold: 20
      });
    }
  
    // API has loaded, load all Map instances in queue
    function initAllMaps() {
      mapsToLoad.forEach(instance => {
        instance.createMap();
      });
    }
  
    function geolocate(map) {
      var geocoder = new google.maps.Geocoder();
  
      if (!map) {
        return;
      }
  
      var address = map.dataset.addressSetting;
  
      var deferred = new Promise((resolve, reject) => {
        geocoder.geocode({ address: address }, function(results, status) {
          if (status !== google.maps.GeocoderStatus.OK) {
            reject(status);
          }
          resolve(results);
        });
      });
  
      return deferred;
    }
  
    Map.prototype = Object.assign({}, Map.prototype, {
      prepMapApi: function() {
        if (apiStatus === 'loaded') {
          this.createMap();
        } else {
          mapsToLoad.push(this);
  
          if (apiStatus !== 'loading') {
            apiStatus = 'loading';
            if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined' ) {
  
              var script = document.createElement('script');
              script.onload = function () {
                apiStatus = 'loaded';
                initAllMaps();
              };
              script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.key;
              document.head.appendChild(script);
            }
          }
        }
      },
  
      createMap: function() {
        var mapDiv = this.map;
  
        return geolocate(mapDiv)
          .then(
            function(results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: 'none',
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true
              };
  
              var map = (this.map = new google.maps.Map(mapDiv, mapOptions));
              var center = (this.center = map.getCenter());
  
              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter()
              });
  
              google.maps.event.addDomListener(
                window,
                'resize',
                theme.utils.debounce(250, function() {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  mapDiv.removeAttribute('style');
                })
              );
  
              if (Shopify.designMode) {
                if (window.AOS) { AOS.refreshHard() }
              }
            }.bind(this)
          )
          .catch(function(status) {
            var errorMessage;
  
            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }
  
            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              window.mapError(errorMessage);
            }
          });
      },
  
      onUnload: function() {
        if (this.map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        if (google && google.maps && google.maps.event) {
          google.maps.event.clearListeners(this.map, 'resize');
        }
      }
    });
  
    return Map;
  })();
  
  theme.NewsletterPopup = (function() {
    function NewsletterPopup(container) {
      this.container = container;
      var sectionId = this.container.getAttribute('data-section-id');
      this.cookieName = 'newsletter-' + sectionId;
  
      if (!container) {
        return;
      }
  
      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === '/challenge') {
        return;
      }
  
      // Prevent popup on password page
      if (window.location.pathname === '/password') {
        return;
      }
  
      this.data = {
        secondsBeforeShow: container.dataset.delaySeconds,
        daysBeforeReappear: container.dataset.delayDays,
        cookie: Cookies.get(this.cookieName),
        testMode: container.dataset.testMode
      };
  
      this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');
  
      // Set cookie if optional button is clicked
      var btn = container.querySelector('.popup-cta a');
      if (btn) {
        btn.addEventListener('click', function(){
          this.closePopup(true);
        }.bind(this));
      }
  
      // Open modal if errors or success message exist
      if (container.querySelector('.errors') || container.querySelector('.note--success')) {
        this.modal.open();
      }
  
      // Set cookie as opened if success message
      if (container.querySelector('.note--success')) {
        this.closePopup(true);
        return;
      }
  
      document.addEventListener('modalClose.' + container.id, this.closePopup.bind(this));
  
      if (!this.data.cookie || this.data.testMode === 'true') {
        this.initPopupDelay();
      }
    }
  
    NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
      initPopupDelay: function() {
        if (Shopify && Shopify.designMode) {
          return;
        }
        setTimeout(function() {
          this.modal.open();
        }.bind(this), this.data.secondsBeforeShow * 1000);
      },
  
      closePopup: function(success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode === 'true') {
          Cookies.remove(this.cookieName, { path: '/' });
          return;
        }
  
        var expiry = success ? 200 : this.data.daysBeforeReappear;
        Cookies.set(this.cookieName, 'opened', { path: '/', expires: expiry });
      },
  
      onLoad: function() {
        this.modal.open();
      },
  
      onSelect: function() {
        this.modal.open();
      },
  
      onDeselect: function() {
        this.modal.close();
      }
    });
  
    return NewsletterPopup;
  })();
  
  theme.PasswordHeader = (function() {
    function PasswordHeader() {
      this.init();
    }
  
    PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
      init: function() {
        if (!document.querySelector('#LoginModal')) {
          return;
        }
  
        var passwordModal = new theme.Modals('LoginModal', 'login-modal', {
          focusIdOnOpen: 'password',
          solid: true
        });
  
        // Open modal if errors exist
        if (document.querySelectorAll('.errors').length) {
          passwordModal.open();
        }
      }
    });
  
    return PasswordHeader;
  })();
  
  theme.Photoswipe = (function() {
    var selectors = {
      trigger: '.js-photoswipe__zoom',
      images: '.photoswipe__image',
      slideshowTrack: '.flickity-viewport ',
      activeImage: '.is-selected'
    };
  
    function Photoswipe(container, sectionId) {
      this.container = container;
      this.sectionId = sectionId;
      this.namespace = '.photoswipe-' + this.sectionId;
      this.gallery;
      this.images;
      this.items;
      this.inSlideshow = false;
  
      if (!container || container.dataset.zoom === 'false') {
        return;
      }
  
      this.init();
    }
  
    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      init: function() {
        this.container.querySelectorAll(selectors.trigger).forEach(trigger => {
          trigger.on('click' + this.namespace, this.triggerClick.bind(this));
        });
      },
  
      triggerClick: function(evt) {
        // Streamline changes between a slideshow and
        // stacked images, so recheck if we are still
        // working with a slideshow when initializing zoom
        if (this.container.dataset && this.container.dataset.hasSlideshow === 'true') {
          this.inSlideshow = true;
        } else {
          this.inSlideshow = false;
        }
  
        this.items = this.getImageData();
  
        var image = this.inSlideshow ? this.container.querySelector(selectors.activeImage) : evt.currentTarget;
  
        var index = this.inSlideshow ? this.getChildIndex(image) : image.dataset.index;
  
        this.initGallery(this.items, index);
      },
  
      // Because of image set feature, need to get index based on location in parent
      getChildIndex: function(el) {
        var i = 0;
        while( (el = el.previousSibling) != null ) {
          i++;
        }
  
        // 1-based index required
        return i + 1;
      },
  
      getImageData: function() {
        this.images = this.inSlideshow
                        ? this.container.querySelectorAll(selectors.slideshowTrack + selectors.images)
                        : this.container.querySelectorAll(selectors.images);
  
        var items = [];
        var options = {};
  
        this.images.forEach(el => {
          var item = {
            msrc: el.currentSrc || el.src,
            src: el.getAttribute('data-photoswipe-src'),
            w: el.getAttribute('data-photoswipe-width'),
            h: el.getAttribute('data-photoswipe-height'),
            el: el,
            initialZoomLevel: 0.5
          }
  
          items.push(item);
        });
  
        return items;
      },
  
      initGallery: function(items, index) {
        var pswpElement = document.querySelectorAll('.pswp')[0];
  
        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: 'zoom',
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function(index) {
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
          }
        }
  
        this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        this.gallery.listen('afterChange', this.afterChange.bind(this));
        this.gallery.init();
  
        this.preventiOS15Scrolling();
      },
  
      afterChange: function() {
        var index = this.gallery.getCurrentIndex();
        this.container.dispatchEvent(new CustomEvent('photoswipe:afterChange', {
          detail: {
            index: index
          }
        }));
      },
  
      syncHeight: function() {
        document.documentElement.style.setProperty(
          "--window-inner-height", 
          `${window.innerHeight}px`
        );
      },
  
      // Fix poached from https://gist.github.com/dimsemenov/0b8c255c0d87f2989e8ab876073534ea
      preventiOS15Scrolling: function() {
        let initialScrollPos;
  
        if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return; 
        
        this.syncHeight();
              
        // Store scroll position to restore it later
        initialScrollPos = window.scrollY;
        
        // Add class to root element when PhotoSwipe opens
        document.documentElement.classList.add('pswp-open-in-ios');
  
        window.addEventListener('resize', this.syncHeight);
      
        this.gallery.listen('destroy', () => {
          document.documentElement.classList.remove('pswp-open-in-ios');
          window.scrollTo(0, initialScrollPos);
        });
      }
    });
  
    return Photoswipe;
  })();
  
  
  theme.Recommendations = (function() {
    var selectors = {
      placeholder: '.product-recommendations-placeholder',
      sectionClass: ' .product-recommendations',
      productResults: '.grid-product'
    }
  
    function Recommendations(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.url = container.dataset.url;
  
      selectors.recommendations = 'Recommendations-' + this.sectionId;
  
      theme.initWhenVisible({
        element: container,
        callback: this.init.bind(this),
        threshold: 500
      });
    }
  
    Recommendations.prototype = Object.assign({}, Recommendations.prototype, {
      init: function() {
        var section = document.getElementById(selectors.recommendations);
  
        if (!section || section.dataset.enable === 'false') {
          return;
        }
  
        var id = section.dataset.productId;
        var limit = section.dataset.limit;
  
        var url = this.url + '?section_id=product-recommendations&limit='+ limit +'&product_id=' + id;
  
        // When section his hidden and shown, make sure it starts empty
        if (Shopify.designMode) {
          var wrapper = section.querySelector(selectors.sectionClass)
          if (wrapper) {
            wrapper.innerHTML = '';
          }
        }
  
        fetch(url).then(function(response) {
          return response.text();
        }).then(function(html) {
          // Convert the HTML string into a document object
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var div = doc.querySelector(selectors.sectionClass);
          var placeholder = section.querySelector(selectors.placeholder);
          if (!placeholder) {
            return;
          }
  
          placeholder.innerHTML = '';
  
          if (!div) {
            this.container.classList.add('hide');
            if (AOS) { AOS.refreshHard() }
            return;
          }
  
          placeholder.appendChild(div);
  
          theme.reinitProductGridItem(section);
  
          document.dispatchEvent(new CustomEvent('recommendations:loaded', {
            detail: {
              section: section
            }
          }));
  
          // If no results, hide the entire section
          var results = div.querySelectorAll(selectors.productResults);
          if (results.length === 0) {
            this.container.classList.add('hide');
          }
        }.bind(this));
      }
    });
  
    return Recommendations;
  })();
  
  theme.SlideshowSection = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function SlideshowSection(container) {
      this.container = container;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Slideshow-' + sectionId);
      this.namespace = '.' + sectionId;
  
      this.initialIndex = 0;
  
      if (!this.slideshow) { return }
  
      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
  
      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this)
        });
      }
  
    }
  
    SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
      init: function() {
        var slides = this.slideshow.querySelectorAll('.slideshow__slide');
  
        if (this.container.hasAttribute('data-immediate-load')) {
          this.slideshow.classList.remove('loading', 'loading--delayed');
          this.slideshow.classList.add('loaded');
        } else {
          // Wait for image to load before marking as done
          theme.loadImageSection(this.slideshow);
        }
  
        if (slides.length > 1) {
          var sliderArgs = {
            prevNextButtons: this.slideshow.hasAttribute('data-arrows'),
            pageDots: this.slideshow.hasAttribute('data-dots'),
            fade: true,
            setGallerySize: false,
            initialIndex: this.initialIndex,
            autoPlay: this.slideshow.dataset.autoplay === 'true'
              ? parseInt(this.slideshow.dataset.speed)
              : false
          };
  
          this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
        } else {
          // Add loaded class to first slide
          slides[0].classList.add('is-selected');
        }
  
        if (this.container.hasAttribute('data-parallax')) {
          // Create new parallax for each slideshow image
          this.container.querySelectorAll(selectors.parallaxContainer).forEach(function(el, i) {
            new theme.Parallax(el, {
              namespace: this.namespace + '-parallax-' + i
            });
          }.bind(this));
        }
      },
  
      forceReload: function() {
        this.onUnload();
        this.init();
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.slideshow__slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(function() {
            if (this.flickity && typeof this.flickity.pause === 'function') {
              this.flickity.pause();
            }
          }.bind(this), 1000);
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          if (this.flickity.args.autoPlay) {
            this.flickity.play();
          }
        }
      }
    });
  
    return SlideshowSection;
  })();
  
  theme.StoreAvailability = (function() {
    var selectors = {
      drawerOpenBtn: '.js-drawer-open-availability',
      modalOpenBtn: '.js-modal-open-availability',
      productTitle: '[data-availability-product-title]'
    };
  
    function StoreAvailability(container) {
      this.container = container;
      this.baseUrl = container.dataset.baseUrl;
      this.productTitle = container.dataset.productName;
    }
  
    StoreAvailability.prototype = Object.assign({}, StoreAvailability.prototype, {
      updateContent: function(variantId) {
        var variantSectionUrl =
          this.baseUrl +
          '/variants/' +
          variantId +
          '/?section_id=store-availability';
  
        var self = this;
  
        fetch(variantSectionUrl)
          .then(function(response) {
            return response.text();
          })
          .then(function(html) {
            if (html.trim() === '') {
              this.container.innerHTML = '';
              return;
            }
  
            self.container.innerHTML = html;
            self.container.innerHTML = self.container.firstElementChild.innerHTML;
  
            // Setup drawer if have open button
            if (self.container.querySelector(selectors.drawerOpenBtn)) {
              self.drawer = new theme.Drawers('StoreAvailabilityDrawer', 'availability');
            }
  
            // Setup modal if have open button
            if (self.container.querySelector(selectors.modalOpenBtn)) {
              self.modal = new theme.Modals('StoreAvailabilityModal', 'availability');
            }
  
            var title = self.container.querySelector(selectors.productTitle);
            if (title) {
              title.textContent = self.productTitle;
            }
          });
      }
    });
  
    return StoreAvailability;
  })();
  
  theme.VideoSection = (function() {
    var selectors = {
      videoParent: '.video-parent-section'
    };
  
    function videoSection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.video-' + this.sectionId;
      this.videoObject;
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 500
      });
    }
  
    videoSection.prototype = Object.assign({}, videoSection.prototype, {
      init: function() {
        var dataDiv = this.container.querySelector('.video-div');
        if (!dataDiv) {
          return;
        }
        var type = dataDiv.dataset.type;
  
        switch(type) {
          case 'youtube':
            var videoId = dataDiv.dataset.videoId;
            this.initYoutubeVideo(videoId);
            break;
          case 'vimeo':
            var videoId = dataDiv.dataset.videoId;
            this.initVimeoVideo(videoId);
            break;
          case 'mp4':
            this.initMp4Video();
            break;
        }
      },
  
      initYoutubeVideo: function(videoId) {
        this.videoObject = new theme.YouTube(
          'YouTubeVideo-' + this.sectionId,
          {
            videoId: videoId,
            videoParent: selectors.videoParent
          }
        );
      },
  
      initVimeoVideo: function(videoId) {
        this.videoObject = new theme.VimeoPlayer(
          'Vimeo-' + this.sectionId,
          videoId,
          {
            videoParent: selectors.videoParent
          }
        );
      },
  
      initMp4Video: function() {
        var mp4Video = 'Mp4Video-' + this.sectionId;
        var mp4Div = document.getElementById(mp4Video);
        var parent = mp4Div.closest(selectors.videoParent);
  
        if (mp4Div) {
          parent.classList.add('loaded');
  
          var playPromise = document.querySelector('#' + mp4Video).play();
  
          // Edge does not return a promise (video still plays)
          if (playPromise !== undefined) {
            playPromise.then(function() {
                // playback normal
              }).catch(function() {
                mp4Div.setAttribute('controls', '');
                parent.classList.add('video-interactable');
              });
          }
        }
      },
  
      onUnload: function(evt) {
        var sectionId = evt.target.id.replace('shopify-section-', '');
        if (this.videoObject && typeof this.videoObject.destroy === 'function') {
          this.videoObject.destroy();
        }
      }
    });
  
    return videoSection;
  })();
  

  theme.BackgroundImage = (function() {
  
    var selectors = {
      parallaxContainer: '.parallax-container'
    };
  
    function backgroundImage(container) {
      this.container = container;
      if (!container) {
        return;
      }
  
      var sectionId = container.getAttribute('data-section-id');
      this.namespace = '.' + sectionId;
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this)
      });
    }
  
    backgroundImage.prototype = Object.assign({}, backgroundImage.prototype, {
      init: function() {
        if (this.container.dataset && this.container.dataset.parallax) {
          var parallaxContainer = this.container.querySelector(selectors.parallaxContainer);
          var args = {
            namespace: this.namespace + '-parallax',
            desktopOnly: true
          };
  
          theme.parallaxSections[this.namespace] = new theme.Parallax(parallaxContainer, args);
        }
      },
  
      onUnload: function(evt) {
        if (!this.container) { return }
        if (theme.parallaxSections[this.namespace] && typeof theme.parallaxSections[this.namespace].destroy === 'function') {
          theme.parallaxSections[this.namespace].destroy();
        }
        delete theme.parallaxSections[this.namespace];
      }
    });
  
    return backgroundImage;
  })();
  
  theme.Blog = (function() {
  
    function Blog(container) {
      this.tagFilters();
    }
  
    Blog.prototype = Object.assign({}, Blog.prototype, {
      tagFilters: function() {
        var filterBy = document.getElementById('BlogTagFilter');
  
        if (!filterBy) {
          return;
        }
  
        filterBy.addEventListener('change', function() {
          location.href = filterBy.value;
        });
      }
    });
  
    return Blog;
  })();
  
  theme.CollectionHeader = (function() {
    var hasLoadedBefore = false;
  
    function CollectionHeader(container) {
      this.namespace = '.collection-header';
  
      var heroImageContainer = container.querySelector('.collection-hero');
      if (heroImageContainer) {
        if (hasLoadedBefore) {
          this.checkIfNeedReload();
        }
        theme.loadImageSection(heroImageContainer);
  
        if (container.dataset && container.dataset.parallax) {
          var parallaxContainer = container.querySelector('.parallax-container');
          var args = {
            namespace: this.namespace + '-parallax'
          };
          theme.parallaxSections[this.namespace] = new theme.Parallax(parallaxContainer, args);
        }
      } else if (theme.settings.overlayHeader) {
        theme.headerNav.disableOverlayHeader();
      }
  
      hasLoadedBefore = true;
    }
  
    CollectionHeader.prototype = Object.assign({}, CollectionHeader.prototype, {
      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function() {
        if (!Shopify.designMode) {
          return;
        }
  
        if (theme.settings.overlayHeader) {
          var header = document.querySelector('.header-wrapper');
          if (!header.classList.contains('header-wrapper--overlay')) {
            location.reload();
          }
        }
      },
  
      onUnload: function() {
        if (theme.parallaxSections[this.namespace]) {
          theme.parallaxSections[this.namespace].destroy();
          delete theme.parallaxSections[this.namespace];
        }
      }
    });
  
    return CollectionHeader;
  })();
  
  theme.CollectionSidebar = (function() {
    var drawerStyle = false;
    var selectors = {
      sidebar: '#CollectionSidebar',
    };
  
    function CollectionSidebar(container) {
      this.container = container.querySelector(selectors.sidebar);
    }
  
    CollectionSidebar.prototype = Object.assign({}, CollectionSidebar.prototype, {
      init: function() {
        // Do not load when no sidebar exists
        if(!this.container) {
          return;
        }
  
        this.onUnload();
  
        drawerStyle = this.container.dataset.style === 'drawer';
        theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'collection-filters', true);
      },
  
      forceReload: function() {
        this.init();
      },
  
      onSelect: function() {
        if (theme.FilterDrawer) {
          if (!drawerStyle) {
            theme.FilterDrawer.close();
            return;
          }
  
          if (drawerStyle || theme.config.bpSmall) {
            theme.FilterDrawer.open();
          }
        }
      },
  
      onDeselect: function() {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      },
  
      onUnload: function() {
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
      }
    });
  
    return CollectionSidebar;
  })();
  
  theme.Collection = (function() {
    var isAnimating = false;
  
    var selectors = {
      sortSelect: '#SortBy',
  
      colorSwatchImage: '.grid-product__color-image',
      colorSwatch: '.color-swatch--with-image',
  
      collectionGrid: '.collection-grid__wrapper',
      trigger: '.collapsible-trigger',
      sidebar: '#CollectionSidebar',
      filterSidebar: '.collapsible-content--sidebar',
      activeTagList: '.tag-list--active-tags',
      tags: '.tag-list input',
      activeTags: '.tag-list a',
      tagsForm: '.filter-form',
      filters: '.collection-filter',
      priceRange: '.price-range',
    };
  
    var classes = {
      activeTag: 'tag--active',
      removeTagParent: 'tag--remove',
      filterSidebar: 'collapsible-content--sidebar',
      isOpen: 'is-open',
    };
  
    function Collection(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.namespace = '.collection-' + this.sectionId;
      this.sidebar = new theme.CollectionSidebar(container);
      this.ajaxRenderer = new theme.AjaxRenderer({
        sections: [
          {
            sectionId: this.sectionId,
            nodeId: 'CollectionAjaxContent',
          },
        ],
        onReplace: this.onReplaceAjaxContent.bind(this),
      });
  
      this.init();
    }
  
    Collection.prototype = Object.assign({}, Collection.prototype, {
      init: function() {
        this.initSort();
        this.colorSwatchHovering();
        this.initFilters();
        this.initPriceRange();
        this.sidebar.init();
      },
  
      initSort: function() {
        this.sortSelect = document.querySelector(selectors.sortSelect);
  
        if (this.sortSelect) {
          this.defaultSort = this.getDefaultSortValue();
          this.sortSelect.on('change' + this.namespace, this.onSortChange.bind(this));
        }
      },
  
      getSortValue: function() {
        return this.sortSelect.value || this.defaultSort;
      },
  
      getDefaultSortValue: function() {
        return this.sortSelect.getAttribute('data-default-sortby');
      },
  
      onSortChange: function() {
        this.queryParams = new URLSearchParams(window.location.search);
  
        this.queryParams.set('sort_by', this.getSortValue());
        this.queryParams.delete('page'); // Delete if it exists
  
        window.location.search = this.queryParams.toString();
      },
  
      colorSwatchHovering: function() {
        var colorImages = this.container.querySelectorAll(selectors.colorSwatchImage);
        if (!colorImages.length) {
          return;
        }
  
        this.container.querySelectorAll(selectors.colorSwatch).forEach(swatch => {
          swatch.addEventListener('mouseenter', function() {
            var id = swatch.dataset.variantId;
            var image = swatch.dataset.variantImage;
            var el = document.querySelector('.grid-product__color-image--' + id);
            el.style.backgroundImage = 'url(' + image + ')';
            el.classList.add('is-active');
          });
          swatch.addEventListener('mouseleave', function() {
            var id = swatch.dataset.variantId;
            document.querySelector('.grid-product__color-image--' + id).classList.remove('is-active');
          });
        });
      },
  
      /*====================
        Collection filters
      ====================*/
      initFilters: function() {
        var tags = document.querySelectorAll(selectors.tags);
  
        if (!tags.length) {
          return;
        }
  
        this.bindBackButton();
  
        // Set mobile top value for filters if sticky header enabled
        if (theme.config.stickyHeader) {
          this.setFilterStickyPosition();
  
          window.on('resize', theme.utils.debounce(500, this.setFilterStickyPosition));
        }
  
        document.querySelectorAll(selectors.activeTags).forEach(tag => {
          tag.addEventListener('click', this.tagClick.bind(this));
        });
  
        document.querySelectorAll(selectors.tagsForm).forEach(form => {
          form.addEventListener('input', this.onFormSubmit.bind(this));
        });
      },
  
      initPriceRange: function() {
        const priceRangeEls = document.querySelectorAll(selectors.priceRange);
        priceRangeEls.forEach((el) => new theme.PriceRange(el, {
          // onChange passes in formData
          onChange: this.renderFromFormData.bind(this),
        }));
      },
  
      tagClick: function(evt) {
        var el = evt.currentTarget;
  
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
  
        // Do not ajax-load collection links
        if (el.classList.contains('no-ajax')) {
          return;
        }
  
        evt.preventDefault();
  
        if (isAnimating) {
          return;
        }
  
        isAnimating = true;
  
        const parent = el.parentNode;
        const newUrl = new URL(el.href);
  
        this.renderActiveTag(parent, el);
        this.updateScroll(true);
        this.startLoading();
        this.renderCollectionPage(newUrl.searchParams);
      },
  
      onFormSubmit: function(evt) {
        var el = evt.target;
  
        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }
  
        // Do not ajax-load collection links
        if (el.classList.contains('no-ajax')) {
          return;
        }
  
        evt.preventDefault();
        if (isAnimating) {
          return;
        }
  
        isAnimating = true;
  
        const parent = el.closest('li');
        const formEl = el.closest('form');
        const formData = new FormData(formEl);
  
        this.renderActiveTag(parent, el);
        this.updateScroll(true);
        this.startLoading();
        this.renderFromFormData(formData);
      },
  
      fetchOpenCollasibleFilters: function() {
        return Array.from(
          document.querySelectorAll(
            `${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`,
          ),
        ).map(trigger => trigger.dataset.collapsibleId);
      },
  
      renderActiveTag: function(parent, el) {
        const textEl = parent.querySelector('.tag__text');
  
        if (parent.classList.contains(classes.activeTag)) {
          parent.classList.remove(classes.activeTag);
        } else {
          parent.classList.add(classes.activeTag);
  
          // If adding a tag, show new tag right away.
          // Otherwise, remove it before ajax finishes
          if (el.closest('li').classList.contains(classes.removeTagParent)) {
            parent.remove();
          } else {
            // Append new tag in both drawer and sidebar
            document.querySelectorAll(selectors.activeTagList).forEach(list => {
              const newTag = document.createElement('li');
              const newTagLink = document.createElement('a');
              newTag.classList.add('tag', 'tag--remove');
              newTagLink.classList.add('btn', 'btn--small');
              newTagLink.innerText = textEl.innerText;
              newTag.appendChild(newTagLink);
  
              list.appendChild(newTag);
            });
          }
        }
      },
  
      renderFromFormData: function(formData) {
        const searchParams = new URLSearchParams(formData);
        this.renderCollectionPage(searchParams);
      },
  
      onReplaceAjaxContent: function(newDom, section) {
        const openCollapsibleIds = this.fetchOpenCollasibleFilters();
  
        openCollapsibleIds.forEach(selector => {
          newDom
            .querySelectorAll(`[data-collapsible-id=${selector}]`)
            .forEach(this.openCollapsible);
        });
  
        var newContentEl = newDom.getElementById(section.nodeId);
        if (!newContentEl) {
          return;
        }
  
        document.getElementById(section.nodeId).innerHTML = newContentEl.innerHTML;
      },
  
      openCollapsible: function(el) {
        if (el.classList.contains(classes.filterSidebar)) {
          el.style.height = 'auto';
        }
  
        el.classList.add(classes.isOpen);
      },
  
      renderCollectionPage: function(searchParams, updateURLHash = true) {
        this.ajaxRenderer
          .renderPage(window.location.pathname, searchParams, updateURLHash)
          .then(() => {
            theme.sections.reinit('collection-grid');
            this.updateScroll(false);
            this.initPriceRange();
            theme.reinitProductGridItem();
  
            document.dispatchEvent(new CustomEvent('collection:reloaded'));
  
            isAnimating = false;
          });
      },
  
      bindBackButton: function() {
        // Ajax page on back button
        window.off('popstate' + this.namespace);
        window.on('popstate' + this.namespace, function(state) {
          if (state) {
            const newUrl = new URL(window.location.href);
            this.renderCollectionPage(newUrl.searchParams, false);
          }
        }.bind(this));
      },
  
      updateScroll: function(animate) {
        var scrollToElement = document.querySelector('[data-scroll-to]');
        var scrollTo = scrollToElement && scrollToElement.offsetTop;
  
        if (!theme.config.bpSmall) {
          scrollTo -= 15;
        }
  
        if (theme.config.stickyHeader) {
          var headerHeight = document.querySelector('.site-header').offsetHeight;
          scrollTo = scrollTo - headerHeight;
        }
  
        if (animate) {
          window.scrollTo({top: scrollTo, behavior: 'smooth'});
        } else {
          window.scrollTo({top: scrollTo});
        }
      },
  
      setFilterStickyPosition: function() {
        var headerHeight = document.querySelector('.site-header').offsetHeight;
        document.querySelector(selectors.filters).style.top = headerHeight + 10 + 'px';
  
        // Also update top position of sticky sidebar
        var stickySidebar = document.querySelector('.grid__item--sidebar');
        if (stickySidebar) {
          stickySidebar.style.top = headerHeight + 10 + 'px';
        }
      },
  
      forceReload: function() {
        this.init();
      },
  
      startLoading: function() {
        document.querySelector(selectors.collectionGrid).classList.add('unload');
      },
    });
  
    return Collection;
  })();
  
  theme.FooterSection = (function() {
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };
  
    function FooterSection(container) {
      this.container = container;
      this.localeDisclosure = null;
      this.currencyDisclosure = null;
  
      this.init();
    }
  
    FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
      init: function() {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);
  
        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }
  
        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
  
        // Change email icon to submit text
        var newsletterInput = document.querySelector('.footer__newsletter-input');
        if (newsletterInput) {
          newsletterInput.addEventListener('keyup', function() {
            newsletterInput.classList.add('footer__newsletter-input--active');
          });
        }
  
        // Re-hook up collapsible box triggers
        theme.collapsibles.init(this.container);
      },
  
      onUnload: function() {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }
  
        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });
  
    return FooterSection;
  })();
  
  theme.HeaderSection = (function() {
  
    var selectors = {
      locale: '[data-disclosure-locale]',
      currency: '[data-disclosure-currency]'
    };
  
    function HeaderSection(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
  
      this.init();
    }
  
    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      init: function() {
        // Reload any slideshow if header is reloaded to make sure
        // sticky header works as expected
        // (can be anywhere in sections.instance array)
        if (Shopify && Shopify.designMode) {
          theme.sections.reinit('slideshow-section');
  
          // Set a timer to resize the header in case the logo changes size
          setTimeout(function() {
            window.dispatchEvent(new Event('resize'));
          }, 500);
        }
  
        this.initDrawers();
        this.initDisclosures();
        theme.headerNav.init();
        theme.announcementBar.init();
      },
  
      initDisclosures: function() {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);
  
        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }
  
        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
      },
  
      initDrawers: function() {
        theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
        if (theme.settings.cartType === 'drawer') {
          if (!document.body.classList.contains('template-cart')) {
            new theme.CartDrawer();
          }
        }
  
        theme.collapsibles.init(document.getElementById('NavDrawer'));
      },
  
      onBlockSelect: function(evt) {
        theme.announcementBar.onBlockSelect(evt.detail.blockId);
      },
  
      onBlockDeselect: function() {
        theme.announcementBar.onBlockDeselect();
      },
  
      onUnload: function() {
        theme.NavDrawer.close();
        theme.announcementBar.unload();
  
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }
  
        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      }
    });
  
    return HeaderSection;
  })();
  
  theme.Product = (function() {
    var videoObjects = {};
  
    var classes = {
      onSale: 'on-sale',
      disabled: 'disabled',
      isModal: 'is-modal',
      loading: 'loading',
      loaded: 'loaded',
      hidden: 'hide',
      interactable: 'video-interactable',
      visuallyHide: 'visually-invisible'
    };
  
    var selectors = {
      productVideo: '.product__video',
      videoParent: '.product__video-wrapper',
      slide: '.product-main-slide',
      currentSlide: '.is-selected',
      startingSlide: '.starting-slide',
      variantType: '.variant-wrapper',
      blocks: '[data-product-blocks]',
      blocksHolder: '[data-blocks-holder]'
    };
  
    function Product(container) {
      this.container = container;
      var sectionId = this.sectionId = container.getAttribute('data-section-id');
      var productId = this.productId = container.getAttribute('data-product-id');
  
      this.inModal = (container.dataset.modal === 'true');
      this.modal;
  
      this.settings = {
        enableHistoryState: container.dataset.history || false,
        namespace: '.product-' + sectionId,
        inventory: false,
        inventoryThreshold: 10,
        modalInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        imageSize: '620x',
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping
      };
  
      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = '.product-' + sectionId + '-modal';
        this.modal = document.getElementById('QuickShopModal-' + productId);
      }
  
      this.selectors = {
        variantsJson: '[data-variant-json]',
        currentVariantJson: '[data-current-variant-json]',
        form: '.product-single__form',
  
        media: '[data-product-media-type-model]',
        closeMedia: '.product-single__close-media',
        photoThumbs: '[data-product-thumb]',
        thumbSlider: '[data-product-thumbs]',
        thumbScroller: '.product__thumbs--scroller',
        mainSlider: '[data-product-photos]',
        imageContainer: '[data-product-images]',
        productImageMain: '[data-product-image-main]',
  
        priceWrapper: '[data-product-price-wrap]',
        price: '[data-product-price]',
        comparePrice: '[data-compare-price]',
        savePrice: '[data-save-price]',
        priceA11y: '[data-a11y-price]',
        comparePriceA11y: '[data-compare-price-a11y]',
        unitWrapper: '[data-unit-price-wrapper]',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-base]',
        sku: '[data-sku]',
        inventory: '[data-product-inventory]',
        incomingInventory: '[data-incoming-inventory]',
        colorLabel: '[data-variant-color-label]',
  
        addToCart: '[data-add-to-cart]',
        addToCartText: '[data-add-to-cart-text]',
  
        originalSelectorId: '[data-product-select]',
        singleOptionSelector: '[data-variant-input]',
        variantColorSwatch: '.variant__input--color-swatch',
  
        availabilityContainer: '[data-store-availability-holder]'
      };
  
      this.cacheElements();
  
      this.firstProductImage = this.cache.mainSlider.querySelector('img');
  
      if (!this.firstProductImage) {
        this.settings.hasImages = false;
      }
  
      var dataSetEl = this.cache.mainSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.settings.imageSetName = dataSetEl.dataset.setName;
      }
  
      this.init();
    }
  
    Product.prototype = Object.assign({}, Product.prototype, {
      init: function() {
        if (this.inModal) {
          this.container.classList.add(classes.isModal);
          document.addEventListener('modalOpen.QuickShopModal-' + this.productId, this.openModalProduct.bind(this));
          document.addEventListener('modalClose.QuickShopModal-' + this.productId, this.closeModalProduct.bind(this));
        }
  
        if (!this.inModal) {
          this.formSetup();
          this.productSetup();
          this.videoSetup();
          this.initProductSlider();
          this.customMediaListners();
          this.addIdToRecentlyViewed();
        }
      },
  
      cacheElements: function() {
        this.cache = {
          form: this.container.querySelector(this.selectors.form),
          mainSlider: this.container.querySelector(this.selectors.mainSlider),
          thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
          thumbScroller: this.container.querySelector(this.selectors.thumbScroller),
          productImageMain: this.container.querySelector(this.selectors.productImageMain),
  
          // Price-related
          priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
          comparePriceA11y: this.container.querySelector(this.selectors.comparePriceA11y),
          comparePrice: this.container.querySelector(this.selectors.comparePrice),
          price: this.container.querySelector(this.selectors.price),
          savePrice: this.container.querySelector(this.selectors.savePrice),
          priceA11y: this.container.querySelector(this.selectors.priceA11y)
        };
      },
  
      formSetup: function() {
        this.initQtySelector();
        this.initAjaxProductForm();
        this.availabilitySetup();
        this.initVariants();
  
        // We know the current variant now so setup image sets
        if (this.settings.imageSetName) {
          this.updateImageSet();
        }
      },
  
      availabilitySetup: function() {
        var container = this.container.querySelector(this.selectors.availabilityContainer);
        if (container) {
          this.storeAvailability = new theme.StoreAvailability(container);
        }
      },
  
      productSetup: function() {
        this.setImageSizes();
        this.initImageZoom();
        this.initModelViewerLibraries();
        this.initShopifyXrLaunch();
  
        if (window.SPR) {SPR.initDomEls();SPR.loadBadges()}
      },
  
      setImageSizes: function() {
        if (!this.settings.hasImages) {
          return;
        }
  
        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        var currentImage = this.firstProductImage.currentSrc;
  
        if (currentImage) {
          this.settings.imageSize = theme.Images.imageSize(currentImage);
        }
      },
  
      addIdToRecentlyViewed: function() {
        var handle = this.container.getAttribute('data-product-handle');
        var url = this.container.getAttribute('data-product-url');
        var aspectRatio = this.container.getAttribute('data-aspect-ratio');
        var featuredImage = this.container.getAttribute('data-img-url');
  
        // Remove current product if already in set of recent
        if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent[handle];
        }
  
        // Add it back to the end
        theme.recentlyViewed.recent[handle] = {
          url: url,
          aspectRatio: aspectRatio,
          featuredImage: featuredImage
        };
  
        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
        }
      },
  
      initVariants: function() {
        var variantJson = this.container.querySelector(this.selectors.variantsJson);
  
        if (!variantJson) {
          return;
        }
  
        this.variantsObject = JSON.parse(variantJson.innerHTML);
  
        var options = {
          container: this.container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject
        };
  
        var swatches = this.container.querySelectorAll(this.selectors.variantColorSwatch);
        if (swatches.length) {
          swatches.forEach(swatch => {
            swatch.addEventListener('change', function(evt) {
              var color = swatch.dataset.colorName;
              var index = swatch.dataset.colorIndex;
              this.updateColorName(color, index);
            }.bind(this))
          });
        }
  
        this.variants = new theme.Variants(options);
  
        // Product availability on page load
        if (this.storeAvailability) {
          var variant_id = this.variants.currentVariant ? this.variants.currentVariant.id : this.variants.variants[0].id;
  
          this.storeAvailability.updateContent(variant_id);
          this.container.on('variantChange' + this.settings.namespace, this.updateAvailability.bind(this));
        }
  
        this.container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
        this.container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
        this.container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
        this.container.on('variantUnitPriceChange' + this.settings.namespace, this.updateUnitPrice.bind(this));
  
        if (this.container.querySelector(this.selectors.sku)) {
          this.container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
        }
  
        var inventoryEl = this.container.querySelector(this.selectors.inventory);
        if (inventoryEl) {
          this.settings.inventory = true;
          this.settings.inventoryThreshold = inventoryEl.dataset.threshold;
          this.container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
        }
  
        // Update individual variant availability on each selection
        if (theme.settings.dynamicVariantsEnable) {
          var currentVariantJson = this.container.querySelector(this.selectors.currentVariantJson);
  
          if (currentVariantJson) {
            var variantType = this.container.querySelector(selectors.variantType);
  
            if (variantType) {
              new theme.VariantAvailability({
                container: this.container,
                namespace: this.settings.namespace,
                type: variantType.dataset.type,
                variantsObject: this.variantsObject,
                currentVariantObject: JSON.parse(currentVariantJson.innerHTML)
              });
            }
          }
        }
  
        // image set names variant change listeners
        if (this.settings.imageSetName) {
          var variantWrapper = this.container.querySelector('.variant-input-wrap[data-handle="'+this.settings.imageSetName+'"]');
          if (variantWrapper) {
            this.settings.imageSetIndex = variantWrapper.dataset.index;
            this.container.on('variantChange' + this.settings.namespace, this.updateImageSet.bind(this))
          } else {
            this.settings.imageSetName = null;
          }
        }
      },
  
      initQtySelector: function() {
        this.container.querySelectorAll('.js-qty__wrapper').forEach(el => {
          new theme.QtySelector(el, {
            namespace: '.product'
          });
        });
      },
  
      initAjaxProductForm: function() {
        if (theme.settings.cartType === 'drawer') {
          new theme.AjaxProduct(this.cache.form);
        }
      },
  
      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateColorName: function(color, index) {
        // Updates on radio button change, not variant.js
        console.log("updateColorName");
        console.log(color);
        console.log(index);
        this.container.querySelector(this.selectors.colorLabel + `[data-index="${index}"`).textContent = color;
      },
  
      updateCartButton: function(evt) {
        var variant = evt.detail.variant;
        var cartBtn = this.container.querySelector(this.selectors.addToCart);
        var cartBtnText = this.container.querySelector(this.selectors.addToCartText);
  
        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text
            cartBtn.classList.remove(classes.disabled);
            cartBtn.disabled = false;
            var defaultText = cartBtnText.dataset.defaultText;
            cartBtnText.textContent = defaultText;
          } else {
            // Sold out, disable the submit button and change text
            cartBtn.classList.add(classes.disabled);
            cartBtn.disabled = true;
            cartBtnText.textContent = theme.strings.soldOut;
          }
        } else {
          // The variant doesn't exist, disable submit button
          cartBtn.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnText.textContent = theme.strings.unavailable;
        }
      },
  
      updatePrice: function(evt) {
        var variant = evt.detail.variant;
        console.log("--this.cache--");
        console.log(this.cache);
        if (variant) {
          // Regular price
          this.cache.price.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
  
          // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
            this.cache.priceWrapper.classList.remove(classes.hidden);
            this.cache.price.classList.add(classes.onSale);
            this.cache.comparePriceA11y.setAttribute('aria-hidden', 'false');
            this.cache.priceA11y.setAttribute('aria-hidden', 'false');
  
            var savings = variant.compare_at_price - variant.price;
  
            if (theme.settings.saveType == 'percent') {
              savings = Math.round(((savings) * 100) / variant.compare_at_price) + '%';
            } else {
              savings = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
            }
            if (this.cache.savePrice) {
              this.cache.savePrice.classList.remove(classes.hidden);
              this.cache.savePrice.innerHTML = theme.strings.savePrice.replace('[saved_amount]', savings);
            }
          } else {
            if (this.cache.priceWrapper) {
              this.cache.priceWrapper.classList.add(classes.hidden);
            }
            if (this.cache.savePrice) {
              this.cache.savePrice.classList.add(classes.hidden);
            }
            this.cache.price.classList.remove(classes.onSale);
            if (this.cache.comparePriceA11y) {
              this.cache.comparePriceA11y.setAttribute('aria-hidden', 'true');
            }
            this.cache.priceA11y.setAttribute('aria-hidden', 'true');
          }
        }
      },
  
      updateUnitPrice: function(evt) {
        var variant = evt.detail.variant;
  
        if (variant && variant.unit_price) {
          this.container.querySelector(this.selectors.unitPrice).innerHTML = theme.Currency.formatMoney(variant.unit_price, theme.settings.moneyFormat);
          this.container.querySelector(this.selectors.unitPriceBaseUnit).innerHTML = theme.Currency.getBaseUnit(variant);
          this.container.querySelector(this.selectors.unitWrapper).classList.remove(classes.hidden);
        } else {
          this.container.querySelector(this.selectors.unitWrapper).classList.add(classes.hidden);
        }
      },
  
      imageSetArguments: function(variant) {
        var variant = variant ? variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) return;
  
        var setValue = this.settings.currentImageSet = this.getImageSetName(variant[this.settings.imageSetIndex]);
        var set = this.settings.imageSetName + '_' + setValue;
        console.log("thomy===============================");
        console.log(setValue);
        console.log(set);
  
        // Always start on index 0
        this.settings.currentSlideIndex = 0;
  
        // Return object that adds cellSelector to mainSliderArgs
        return {
          cellSelector: '[data-group="'+set+'"]',
          imageSet: set,
          initialIndex: this.settings.currentSlideIndex
        }
      },
  
      updateImageSet: function(evt) {
        console.log("updateImageSet===============================");
        console.log(evt);
        // If called directly, use current variant
        var variant = evt ? evt.detail.variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) {
          return;
        }
  
        var setValue = this.getImageSetName(variant[this.settings.imageSetIndex]);
  
        // Already on the current image group
        if (this.settings.currentImageSet === setValue) {
          return;
        }
  
        this.initProductSlider(variant);
      },
  
      // Show/hide thumbnails based on current image set
      //Thomy: agregamos thumbnails de todos los colores
      updateImageSetThumbs: function(set) {
        this.cache.thumbSlider.querySelectorAll('.product__thumb-item').forEach(thumb => {
          let groupname = thumb.dataset.group;
          if(Boolean(groupname)){

            if(groupname.includes(',')){
             
              let arraycolors = groupname.split(',');
              thumb.classList.toggle(classes.hidden, !arraycolors.includes(set));
            }else{
              thumb.classList.toggle(classes.hidden, thumb.dataset.group !== set);
            }
            
          }else{
            
            thumb.classList.remove(classes.hidden);
          }
          
        });
      },
  
      getImageSetName: function(string) {
        return string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      },
  
      updateSku: function(evt) {
        var variant = evt.detail.variant;
        var newSku = '';
  
        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }
  
          this.container.querySelector(this.selectors.sku).textContent = newSku;
        }
      },
  
      updateInventory: function(evt) {
        var variant = evt.detail.variant;
  
        // Hide stock if no inventory management or policy is continue
        if (!variant || !variant.inventory_management || variant.inventory_policy === 'continue') {
          this.toggleInventoryQuantity(variant, false);
          this.toggleIncomingInventory(false);
          return;
        }
  
        if (variant.inventory_management === 'shopify' && window.inventories && window.inventories[this.productId]) {
          var variantInventoryObject = window.inventories[this.productId][variant.id];
  
          // Hide stock if policy is continue
          if (variantInventoryObject.policy === 'continue') {
            this.toggleInventoryQuantity(variant, false);
            this.toggleIncomingInventory(false);
            return;
          }
  
          var quantity = variantInventoryObject.quantity;
          var showInventory = true;
          var showIncomingInventory = false;
  
          if (quantity <= 0 || quantity > this.settings.inventoryThreshold) {
            showInventory = false;
          }
  
          this.toggleInventoryQuantity(variant, showInventory, quantity);
  
          // Only show incoming inventory when:
          // - inventory notice itself is hidden
          // - have incoming inventory
          // - current quantity is below theme setting threshold
          if (!showInventory && variantInventoryObject.incoming === 'true' && quantity <= this.settings.inventoryThreshold) {
            showIncomingInventory = true;
          }
  
          this.toggleIncomingInventory(showIncomingInventory, variant.available, variantInventoryObject.next_incoming_date);
        }
      },
  
      updateAvailability: function(evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }
  
        this.storeAvailability.updateContent(variant.id);
      },
  
      toggleInventoryQuantity: function(variant, show, qty) {
        if (!this.settings.inventory) {
          show = false;
        }
  
        var el = this.container.querySelector(this.selectors.inventory);
        var salesPoint = el.closest('.product-block');
  
        if (parseInt(qty) <= parseInt(this.settings.inventoryThreshold)) {
          el.parentNode.classList.add('inventory--low')
          el.textContent = theme.strings.stockLabel.replace('[count]', qty);
        } else {
          el.parentNode.classList.remove('inventory--low')
          el.textContent = theme.strings.inStockLabel;
        }
  
        if (variant && variant.available) {
          el.parentNode.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
        } else {
          el.parentNode.classList.add(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.add(classes.hidden);
          }
        }
      },
  
      toggleIncomingInventory: function(show, available, date) {
        var el = this.container.querySelector(this.selectors.incomingInventory);
        var salesPoint = el.closest('.product-block');
  
        if (!el) {
          return;
        }
  
        var textEl = el.querySelector('.js-incoming-text');
  
        if (show) {
          var string = available ?
                       theme.strings.willNotShipUntil.replace('[date]', date) :
                       theme.strings.willBeInStockAfter.replace('[date]', date);
  
          if (!date) {
            string = theme.strings.waitingForStock;
          }
  
          el.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
          textEl.textContent = string;
        } else {
          el.classList.add(classes.hidden);
        }
      },
  
      /*============================================================================
        Product videos
      ==============================================================================*/
      videoSetup: function() {
        var productVideos = this.cache.mainSlider.querySelectorAll(selectors.productVideo);
  
        if (!productVideos.length) {
          return false;
        }
  
        productVideos.forEach(vid => {
          var type = vid.dataset.videoType;
          if (type === 'youtube') {
            this.initYoutubeVideo(vid);
          } else if (type === 'mp4') {
            this.initMp4Video(vid);
          }
        });
      },
  
      initYoutubeVideo: function(div) {
        videoObjects[div.id] = new theme.YouTube(
          div.id,
          {
            videoId: div.dataset.youtubeId,
            videoParent: selectors.videoParent,
            autoplay: false, // will handle this in callback
            style: div.dataset.videoStyle,
            loop: div.dataset.videoLoop,
            events: {
              onReady: this.youtubePlayerReady.bind(this),
              onStateChange: this.youtubePlayerStateChange.bind(this)
            }
          }
        );
      },
  
      // Comes from YouTube SDK
      // Get iframe ID with evt.target.getIframe().id
      // Then access product video players with videoObjects[id]
      youtubePlayerReady: function(evt) {
        var iframeId = evt.target.getIframe().id;
  
        if (!videoObjects[iframeId]) {
          // No youtube player data
          return;
        }
  
        var obj = videoObjects[iframeId];
        var player = obj.videoPlayer;
  
        if (obj.options.style !== 'sound') {
          player.mute();
        }
  
        obj.parent.classList.remove('loading');
        obj.parent.classList.add('loaded');
  
        // If we have an element, it is in the visible/first slide,
        // and is muted, play it
        if (this._isFirstSlide(iframeId) && obj.options.style !== 'sound') {
          player.playVideo();
        }
      },
  
      _isFirstSlide: function(id) {
        return this.cache.mainSlider.querySelector(selectors.startingSlide + ' ' + '#' + id);
      },
  
      youtubePlayerStateChange: function(evt) {
        var iframeId = evt.target.getIframe().id;
        var obj = videoObjects[iframeId];
  
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (obj.attemptedToPlay) {
              obj.parent.classList.add('video-interactable');
            }
            break;
          case 0: // ended
            if (obj && obj.options.loop === 'true') {
              obj.videoPlayer.playVideo();
            }
            break;
          case 3: // buffering
            obj.attemptedToPlay = true;
            break;
        }
      },
  
      initMp4Video: function(div) {
        videoObjects[div.id] = {
          id: div.id,
          type: 'mp4'
        };
  
        if (this._isFirstSlide(div.id)) {
          this.playMp4Video(div.id);
        }
      },
  
      stopVideos: function() {
        for (var [id, vid] of Object.entries(videoObjects)) {
          if (vid.videoPlayer) {
            if (typeof vid.videoPlayer.stopVideo === 'function') {
              vid.videoPlayer.stopVideo(); // YouTube player
            }
          } else if (vid.type === 'mp4') {
            this.stopMp4Video(vid.id); // MP4 player
          }
        }
      },
  
      _getVideoType: function(video) {
        return video.getAttribute('data-video-type');
      },
  
      _getVideoDivId: function(video) {
        return video.id;
      },
  
      playMp4Video: function(id) {
        var player = this.container.querySelector('#' + id);
        var playPromise = player.play();
  
        if (playPromise !== undefined) {
          playPromise.then(function() {
            // Playing as expected
          })
          .catch(function(error) {
            // Likely low power mode on iOS, show controls
            player.setAttribute('controls', '');
            player.closest(selectors.videoParent).setAttribute('data-video-style', 'unmuted');
          });
        }
      },
  
      stopMp4Video: function(id) {
        var player = this.container.querySelector('#' + id);
        if (player && typeof player.pause === 'function') {
          player.pause();
        }
      },
  
      /*============================================================================
        Product images
      ==============================================================================*/
      initImageZoom: function() {
        var container = this.container.querySelector(this.selectors.imageContainer);
        if (!container) {
          return;
        }
        var imageZoom = new theme.Photoswipe(container, this.sectionId);
        container.addEventListener('photoswipe:afterChange', function(evt) {
          if (this.flickity) {
            this.flickity.goToSlide(evt.detail.index);
          }
        }.bind(this));
      },
  
      getThumbIndex: function(target) {
        console.log("getThumbIndex");
        console.log(target);
        return target.dataset.index;
      },
  
      updateVariantImage: function(evt) {
        var variant = evt.detail.variant;
        var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_media.preview_image.src, this.settings.imageSize);
  
        var newImage = this.container.querySelector('.product__thumb[data-id="' + variant.featured_media.id + '"]');
        var imageIndex = this.getThumbIndex(newImage);
  
        console.log("updateVariantImage");
        console.log(evt);
        // If there is no index, slider is not initalized
        if (typeof imageIndex === 'undefined') {
          return;
        }
  
        // Go to that variant image's slide
        if (this.flickity) {
          this.flickity.goToSlide(imageIndex);
        }
      },
  
      initProductSlider: function(variant) {
        // Stop if only a single image, but add active class to first slide
        if (this.cache.mainSlider.querySelectorAll(selectors.slide).length <= 1) {
          var slide = this.cache.mainSlider.querySelector(selectors.slide);
          if (slide) {
            slide.classList.add('is-selected');
          }
          return;
        }
  
        // Destroy slider in preparation of new initialization
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
  
        // If variant argument exists, slideshow is reinitializing because of the
        // image set feature enabled and switching to a new group.
        // currentSlideIndex
        if (!variant) {
          //var imageSetArgs = this.imageSetArguments(variant);
          console.log("activeSlide*********");
          console.log(selectors.startingSlide);

          var activeSlide = this.cache.mainSlider.querySelector(selectors.startingSlide);
          console.log("activeSlide*********");
          console.log(activeSlide);
          this.settings.currentSlideIndex = this._slideIndex(activeSlide);
        }
  
        var mainSliderArgs = {
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider,
          childNavScroller: this.cache.thumbScroller,
          childVertical: this.cache.thumbSlider.dataset.position === 'beside',
          pageDots: true, // mobile only with CSS
          wrapAround: true,
          callbacks: {
            onInit: this.onSliderInit.bind(this),
            onChange: this.onSlideChange.bind(this)
          }
        };
  
        // Override default settings if image set feature enabled
        if (this.settings.imageSetName) {
          var imageSetArgs = this.imageSetArguments(variant);
          console.log("imageSetArgs===========");
          console.log(mainSliderArgs);
          console.log(imageSetArgs);
          mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
          this.updateImageSetThumbs(mainSliderArgs.imageSet);
          console.log("imageSetArgs=========== Despues");
          console.log(mainSliderArgs);
        }
  
        this.flickity = new theme.Slideshow(this.cache.mainSlider, mainSliderArgs);
      },
  
      onSliderInit: function(slide) {
        // If slider is initialized with image set feature active,
        // initialize any videos/media when they are first slide
        if (this.settings.imageSetName) {
          this.prepMediaOnSlide(slide);
        }
      },
  
      onSlideChange: function(index) {
        if (!this.flickity) return;
  
        var prevSlide = this.cache.mainSlider.querySelector('.product-main-slide[data-index="'+this.settings.currentSlideIndex+'"]');
  
        // If imageSetName exists, use a more specific selector
        var nextSlide = this.settings.imageSetName ?
                        this.cache.mainSlider.querySelectorAll('.flickity-slider .product-main-slide')[index] :
                        this.cache.mainSlider.querySelector('.product-main-slide[data-index="'+index+'"]');
  
        prevSlide.setAttribute('tabindex', '-1');
        nextSlide.setAttribute('tabindex', 0);
  
        // Pause any existing slide video/media
        this.stopMediaOnSlide(prevSlide);
  
        // Prep next slide video/media
        this.prepMediaOnSlide(nextSlide);
  
        // Update current slider index
        this.settings.currentSlideIndex = index;
      },
  
      stopMediaOnSlide(slide) {
        // Stop existing video
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer) {
              videoObjects[videoId].videoPlayer.stopVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.stopMp4Video(videoId);
            return;
          }
        }
  
        // Stop existing media
        var currentMedia = slide.querySelector(this.selectors.media);
        if (currentMedia) {
          currentMedia.dispatchEvent(
            new CustomEvent('mediaHidden', {
              bubbles: true,
              cancelable: true
            })
          );
        }
      },
  
      prepMediaOnSlide(slide) {
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          this.flickity.reposition();
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === 'youtube') {
            if (videoObjects[videoId].videoPlayer && videoObjects[videoId].options.style !== 'sound') {
              videoObjects[videoId].videoPlayer.playVideo();
              return;
            }
          } else if (videoType === 'mp4') {
            this.playMp4Video(videoId);
          }
        }
  
        var nextMedia = slide.querySelector(this.selectors.media);
        if (nextMedia) {
          nextMedia.dispatchEvent(
            new CustomEvent('mediaVisible', {
              bubbles: true,
              cancelable: true
            })
          );
          slide.querySelector('.shopify-model-viewer-ui__button').setAttribute('tabindex', 0);
          slide.querySelector('.product-single__close-media').setAttribute('tabindex', 0);
        }
      },
  
      _slideIndex: function(el) {
        return el.getAttribute('data-index');
      },
  
      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function() {
        var initialized = false;
  
        if (!this.settings.modalInit) {
          this.blocksHolder = this.container.querySelector(selectors.blocksHolder);
          var url = this.blocksHolder.dataset.url;
  
          fetch(url).then(function(response) {
            return response.text();
          }).then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var blocks = doc.querySelector(selectors.blocks);
  
            // Because the same product could be opened in quick view
            // on the page we load the form elements from, we need to
            // update any `id`, `for`, and `form` attributes
            blocks.querySelectorAll('[id]').forEach(el => {
              // Update input `id`
              var val = el.getAttribute('id');
              el.setAttribute('id', val + '-modal');
  
              // Update related label if it exists
              var label = blocks.querySelector(`[for="${val}"]`);
              if (label) {
                label.setAttribute('for', val + '-modal');
              }
  
              // Update any collapsible elements
              var collapsibleTrigger = blocks.querySelector(`[aria-controls="${val}"]`);
              if (collapsibleTrigger) {
                collapsibleTrigger.setAttribute('aria-controls', val + '-modal');
              }
            });
  
            // Update any elements with `form` attribute.
            // Form element already has `-modal` appended
            var form = blocks.querySelector(this.selectors.form);
            var formId = form.getAttribute('id');
            blocks.querySelectorAll('[form]').forEach(el => {
              el.setAttribute('form', formId);
            });
  
            this.blocksHolder.innerHTML = '';
            this.blocksHolder.append(blocks);
            this.blocksHolder.classList.add('product-form-holder--loaded');
  
            this.cacheElements();
  
            this.formSetup();
            this.updateModalProductInventory();
  
            if (Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
  
            // Re-hook up collapsible box triggers
            theme.collapsibles.init(this.container);
  
            document.dispatchEvent(new CustomEvent('quickview:loaded', {
              detail: {
                productId: this.sectionId
              }
            }));
          }.bind(this));
  
          this.productSetup();
          this.videoSetup();
  
          // Enable product slider in quick view
          // 1. with image sets enabled, make sure we have this.variants before initializing
          // 2. initialize normally, form data not required
          if (this.settings.imageSetName) {
            if (this.variants) {
              this.initProductSlider();
            } else {
              document.addEventListener('quickview:loaded', function(evt) {
                if (evt.detail.productId === this.sectionId) {
                  this.initProductSlider();
                }
              }.bind(this));
            }
          } else {
            this.initProductSlider();
          }
          this.customMediaListners();
          this.addIdToRecentlyViewed();
          this.settings.modalInit = true;
        } else {
          initialized = true;
        }
  
        AOS.refreshHard();
  
        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            initialized: initialized,
            productId: this.sectionId
          }
        }));
      },
  
      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateModalProductInventory: function() {
        window.inventories = window.inventories || {};
        this.container.querySelectorAll('.js-product-inventory-data').forEach(el => {
          var productId = el.dataset.productId;
          window.inventories[productId] = {};
  
          el.querySelectorAll('.js-variant-inventory-data').forEach(el => {
            window.inventories[productId][el.dataset.id] = {
              'quantity': el.dataset.quantity,
              'policy': el.dataset.policy,
              'incoming': el.dataset.incoming,
              'next_incoming_date': el.dataset.date
            }
          });
        });
      },
  
      closeModalProduct: function() {
        this.stopVideos();
      },
  
      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function() {
        var modelViewerElements = this.container.querySelectorAll(this.selectors.media);
        if (modelViewerElements.length < 1) return;
  
        theme.ProductMedia.init(modelViewerElements, this.sectionId);
      },
  
      initShopifyXrLaunch: function() {
        document.addEventListener(
          'shopify_xr_launch',
          function() {
            var currentMedia = this.container.querySelector(
              this.selectors.productMediaWrapper +
                ':not(.' +
                self.classes.hidden +
                ')'
            );
            currentMedia.dispatchEvent(
              new CustomEvent('xrLaunch', {
                bubbles: true,
                cancelable: true
              })
            );
          }.bind(this)
        );
      },
  
      customMediaListners: function() {
        document.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.addEventListener('click', function() {
            var slide = this.cache.mainSlider.querySelector(selectors.currentSlide);
            var media = slide.querySelector(this.selectors.media);
            if (media) {
              media.dispatchEvent(
                new CustomEvent('mediaHidden', {
                  bubbles: true,
                  cancelable: true
                })
              );
            }
          }.bind(this))
        });
  
        var modelViewers = this.container.querySelectorAll('model-viewer');
        if (modelViewers.length) {
          modelViewers.forEach(el => {
            el.addEventListener('shopify_model_viewer_ui_toggle_play', function(evt) {
              this.mediaLoaded(evt);
            }.bind(this));
  
            el.addEventListener('shopify_model_viewer_ui_toggle_pause', function(evt) {
              this.mediaUnloaded(evt);
            }.bind(this));
          });
        }
      },
  
      mediaLoaded: function(evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.remove(classes.hidden);
        });
  
        if (this.flickity) {
          this.flickity.setDraggable(false);
        }
      },
  
      mediaUnloaded: function(evt) {
        this.container.querySelectorAll(this.selectors.closeMedia).forEach(el => {
          el.classList.add(classes.hidden);
        });
  
        if (this.flickity) {
          this.flickity.setDraggable(true);
        }
      },
  
      onUnload: function() {
        theme.ProductMedia.removeSectionModels(this.sectionId);
  
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      }
    });
  
    return Product;
  })();
  
  theme.RecentlyViewed = (function() {
    var init = false;
  
    function RecentlyViewed(container) {
      if (!container) {
        return;
      }
  
      this.container = container;
      this.sectionId = this.container.getAttribute('data-section-id');
      this.namespace = '.recently-viewed' + this.sectionId;
      this.gridItemWidth = this.container.getAttribute('data-grid-item-class');
      this.rowOf = this.container.getAttribute('data-row-of');
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    };
  
    RecentlyViewed.prototype = Object.assign({}, RecentlyViewed.prototype, {
      init: function() {
        if (init) {
          return;
        }
  
        init = true;
  
        if (Object.keys(theme.recentlyViewed.recent).length === 0 && theme.recentlyViewed.recent.constructor === Object) {
          // No previous history on page load, so bail
          this.container.classList.add('hide');
          return;
        }
  
        this.outputContainer = document.getElementById('RecentlyViewed-' + this.sectionId);
        this.handle = this.container.getAttribute('data-product-handle');
  
        // Request new product info via JS API
        var promises = [];
        Object.keys(theme.recentlyViewed.recent).forEach(function (handle) {
          if (handle !== 'undefined') {
            promises.push(this.getProductInfo(handle));
          }
        }.bind(this));
  
        Promise.all(promises).then(function(result) {
          this.setupOutput(result);
          this.captureProductDetails(result);
        }.bind(this));
      },
  
      getProductInfo: function(handle) {
        return new Promise(function(resolve, reject) {
          if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
            resolve(theme.recentlyViewed.productInfo[handle]);
          } else {
            fetch('/products/'+ handle +'.js').then(function(response) {
              return response.text();
            }).then(function(product) {
              resolve(product);
            });
          }
        });
      },
  
      setupOutput: function(products) {
        var allProducts = [];
        var data = {};
        var limit = this.container.getAttribute('data-recent-count');
  
        var i = 0;
  
        Object.keys(products).forEach(function (key) {
          if (!products[key]) {
            return;
          }
          var product = JSON.parse(products[key]);
  
          // Ignore current product
          if (product.handle === this.handle) {
            return;
          }
  
          // Ignore undefined key
          if (typeof product.handle == 'undefined') {
            return;
          }
  
          i++;
  
          // New or formatted properties
          product.url = theme.recentlyViewed.recent[product.handle] ? theme.recentlyViewed.recent[product.handle].url : product.url;
          product.image_responsive_url = theme.recentlyViewed.recent[product.handle].featuredImage;
          product.image_aspect_ratio = theme.recentlyViewed.recent[product.handle].aspectRatio;
  
          // Unit pricing checks first variant
          var firstVariant = product.variants[0];
          if (firstVariant && firstVariant.unit_price) {
            var baseUnit = '';
  
            if (firstVariant.unit_price_measurement) {
              if (firstVariant.unit_price_measurement.reference_value != 1) {
                baseUnit += firstVariant.unit_price_measurement.reference_value + ' ';
              }
              baseUnit += firstVariant.unit_price_measurement.reference_unit;
            }
  
            product.unit_price = theme.Currency.formatMoney(firstVariant.unit_price);
            if (baseUnit != '') {
              product.unit_price += '/' + baseUnit;
            }
          }
  
          allProducts.unshift(product);
        }.bind(this));
  
        if (allProducts.length === 0) {
          this.container.classList.add('hide');
          return;
        }
  
        var productMarkup = theme.buildProductGridItem(allProducts.slice(0, limit), this.gridItemWidth, this.rowOf);
  
        this.outputContainer.innerHTML = productMarkup;
  
        if (AOS) {
          AOS.refreshHard();
        }
      },
  
      captureProductDetails: function(products) {
        for (var i = 0; i < products.length; i++) {
          var product = products[i];
          theme.recentlyViewed.productInfo[product.handle] = product;
        }
  
        // Add data to session storage to reduce API requests later
        if (theme.config.hasSessionStorage) {
          sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo));
        }
      },
  
      onUnload: function() {
        init = false;
      }
    });
  
    return RecentlyViewed;
  })();
  
  theme.Testimonials = (function() {
    var defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: true,
      prevNextButtons: false
    };
  
    function Testimonials(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute('data-section-id');
      this.slideshow = container.querySelector('#Testimonials-' + sectionId);
      this.namespace = '.testimonial-' + sectionId;
  
      if (!this.slideshow) { return }
  
      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600
      });
    }
  
    Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
      init: function() {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }
  
        this.flickity = new theme.Slideshow(this.slideshow, defaults);
  
        // Autoscroll to next slide on load to indicate more blocks
        if (this.slideshow.dataset.count > 2) {
          this.timeout = setTimeout(function() {
            this.flickity.goToSlide(1);
          }.bind(this), 1000);
        }
      },
  
      onUnload: function() {
        if (this.flickity && typeof this.flickity.destroy === 'function') {
          this.flickity.destroy();
        }
      },
  
      onDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      },
  
      onBlockSelect: function(evt) {
        var slide = this.slideshow.querySelector('.testimonials-slide--' + evt.detail.blockId)
        var index = parseInt(slide.dataset.index);
  
        clearTimeout(this.timeout);
  
        if (this.flickity && typeof this.flickity.pause === 'function') {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },
  
      onBlockDeselect: function() {
        if (this.flickity && typeof this.flickity.play === 'function') {
          this.flickity.play();
        }
      }
    });
  
    return Testimonials;
  })();
  

  theme.isStorageSupported = function(type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = 'test';
    var storage;
    if (type === 'session') {
      storage = window.sessionStorage;
    }
    if (type === 'local') {
      storage = window.localStorage;
    }

    try {
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.reinitProductGridItem = function(scope) {
    if (AOS) {AOS.refreshHard()}

    theme.initQuickShop();

    // Refresh reviews app
    if (window.SPR) {SPR.initDomEls();SPR.loadBadges()}

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();
  };

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/
  theme.config.hasSessionStorage = theme.isStorageSupported('session');
  theme.config.hasLocalStorage = theme.isStorageSupported('local');
  AOS.init({
    easing: 'ease-out-quad',
    once: true,
    offset: 60,
    disableMutationObserver: true
  });

  if (theme.config.hasLocalStorage) {
    theme.recentlyViewed.localStorage = window.localStorage.getItem('theme-recent');

    if (theme.recentlyViewed.localStorage) {
      theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage);
    }
  }

  theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage['recent-products'] ? JSON.parse(sessionStorage['recent-products']) : {};

  // Trigger events when going between breakpoints
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
  matchMedia(theme.config.mediaQuerySmall).addListener(function(mql) {
    if (mql.matches) {
      theme.config.bpSmall = true;
      document.dispatchEvent(new CustomEvent('matchSmall'));
    }
    else {
      theme.config.bpSmall = false;
      document.dispatchEvent(new CustomEvent('unmatchSmall'));
    }
  });

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
  }

  // Load generic JS. Also reinitializes when sections are
  // added, edited, or removed in Shopify's editor
  theme.initGlobals = function() {
    theme.collapsibles.init();
    theme.videoModal();
  }

  DOMready(function(){
    theme.sections = new theme.Sections();

    theme.sections.register('slideshow-section', theme.SlideshowSection);
    theme.sections.register('header', theme.HeaderSection);
    theme.sections.register('product', theme.Product);
    theme.sections.register('blog', theme.Blog);
    theme.sections.register('password-header', theme.PasswordHeader);
    theme.sections.register('photoswipe', theme.Photoswipe);
    theme.sections.register('product-recommendations', theme.Recommendations);
    theme.sections.register('background-image', theme.BackgroundImage);
    theme.sections.register('testimonials', theme.Testimonials);
    theme.sections.register('video-section', theme.VideoSection);
    theme.sections.register('map', theme.Maps);
    theme.sections.register('footer-section', theme.FooterSection);
    theme.sections.register('store-availability', theme.StoreAvailability);
    theme.sections.register('recently-viewed', theme.RecentlyViewed);
    theme.sections.register('newsletter-popup', theme.NewsletterPopup);
    theme.sections.register('collection-header', theme.CollectionHeader);
    theme.sections.register('collection-grid', theme.Collection);

    theme.initGlobals();
    theme.initQuickShop();
    theme.rteInit();

    if (document.body.classList.contains('template-cart')) {
      var cartPageForm = document.getElementById('CartPageForm');
      if (cartPageForm) {
        new theme.CartForm(cartPageForm);
      }
    }

    if (theme.settings.predictiveSearch) {
      theme.predictiveSearch.init();
    }

    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    document.dispatchEvent(new CustomEvent('page:loaded'));
  });

})();

//Cambiar iconos del menú de Buddha por los SVG
  
function runAfterElementExists(jquery_selector,callback){
    var checker = window.setInterval(function() {
     if (jQuery(jquery_selector).length) {
        clearInterval(checker);
        callback();
        }}, 10);
}

runAfterElementExists('.drawer__scrollable ul.mobile-nav--heading-style.vertical-mega-menu', function() {
  //Mobile
  console.log("creadoMovil");
$("ul.mobile-nav.vertical-mega-menu li:nth-child(1) a i.mm-icon" ).replaceWith('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 358.78 386.28"><g fill="#000f9f"><path d="M303.74 337.98c-.65-38.36-2.79-164.13-2.79-172 0-3.38-1.17-6.19-3.5-8.31-4.29-3.89-11.05-3.59-12.25-3.55H175.88c-.6-.08-6.71-.04-10.65 3.8-2.15 2.1-3.24 4.81-3.24 8.05 0 7.59-3.45 121.83-4.93 170.58l-.1 3.2c-.23 2.14-1.92 21.21 9.25 33.72 6.06 6.82 14.64 10.26 25.48 10.26h77.33c10.85 0 19.42-3.44 25.48-10.26 11.25-12.58 9.5-31.46 9.28-33.44l-.03-2.07Zm-15.81 29.66c-4.33 4.85-10.7 7.3-18.91 7.3h-77.33c-8.21 0-14.57-2.45-18.9-7.3-8.42-9.41-7.23-25.38-7.06-27.32.05-1.63 5.05-164.83 5.05-174.34 0-1.03.3-1.46.59-1.74.97-.97 3.12-1.31 4.32-1.31h109.96c.23-.03.49-.04.78-.04 1.7 0 4.06.36 5.09 1.31.3.27.62.71.62 1.79 0 7.22 1.76 111.1 2.8 172.39l.06 2.31c.08.7 1.61 17.23-7.07 26.95"/><path d="M241.37 314.32v1.53l2.26-1.14v5.21h1.64v-5.22l2.3 1.11v-1.52l-3.12-1.46zm-6.57 5.6h1.63v-5.22l2.3 1.11v-1.51l-3.12-1.47-3.08 1.49v1.53l2.27-1.14zm-17.81 3.32h-1.56v6.98h5.8v-1.54h-4.24zm1.57-14.92c-1.19 0-1.96-.79-1.96-1.98-.01-1.2.76-2.01 1.94-2.01.68 0 1.26.3 1.56.82l1.33-.78c-.59-.95-1.67-1.54-2.89-1.54-2.03.01-3.48 1.54-3.47 3.52 0 1.98 1.48 3.49 3.51 3.47 1.23 0 2.3-.62 2.88-1.57l-1.33-.76c-.29.51-.87.83-1.55.83m.11 4.66h-3.26v7.06h3.5c1.23 0 2.22-.8 2.22-2.03 0-.69-.34-1.23-.85-1.55.37-.32.59-.78.59-1.35 0-1.19-.99-2.14-2.19-2.14m-1.71 1.66h1.72c.36-.01.6.24.6.6s-.24.61-.6.61h-1.69zm1.94 3.93h-1.86v-1.31h1.85c.39-.01.65.26.65.65 0 .38-.25.67-.65.67m7.84-8.73c1.95 0 3.52-1.55 3.52-3.55-.01-2-1.6-3.52-3.55-3.51s-3.53 1.55-3.52 3.55c0 2 1.6 3.53 3.55 3.52m-.03-5.49c1.08 0 1.96.84 1.97 1.95 0 1.11-.87 1.97-1.95 1.97s-1.97-.84-1.97-1.95.87-1.96 1.95-1.97m.05 8.63c-1.92 0-3.47 1.52-3.47 3.5.01 1.97 1.58 3.47 3.5 3.46 1.92 0 3.47-1.52 3.47-3.49 0-1.98-1.58-3.47-3.5-3.47m.03 5.42c-1.07 0-1.94-.83-1.94-1.92 0-1.1.86-1.94 1.92-1.94 1.07 0 1.94.82 1.94 1.92 0 1.09-.85 1.94-1.92 1.94m8.78-8.65a3.464 3.464 0 0 0 3.47-3.52c0-1.98-1.58-3.48-3.51-3.47-1.93 0-3.49 1.53-3.47 3.51 0 1.98 1.58 3.49 3.51 3.48m-.03-5.44c1.07 0 1.94.83 1.95 1.93 0 1.1-.86 1.95-1.93 1.95s-1.94-.83-1.95-1.93c0-1.1.86-1.94 1.93-1.95m2.45 22.73a1.4 1.4 0 0 0-.31-.35c-.13-.11-.25-.2-.34-.26-.1-.07-.25-.13-.43-.21s-.32-.12-.43-.16-.25-.09-.45-.15c-.47-.14-.8-.27-.96-.39-.14-.1-.21-.24-.21-.41s.05-.29.19-.39c.13-.11.32-.16.56-.17.54 0 .91.25 1.16.78l.05.1 1.27-.74-.05-.08c-.23-.47-.56-.85-.98-1.12s-.91-.4-1.46-.4c-.61 0-1.15.19-1.58.56-.45.37-.67.88-.67 1.5 0 .32.06.6.17.83.12.24.28.44.5.59q.315.225.63.36c.21.08.45.17.76.26.51.14.88.27 1.08.4.18.11.26.25.26.45 0 .17-.07.3-.21.41-.14.12-.39.18-.73.18-.71 0-1.17-.3-1.41-.93l-.05-.11-1.28.76.03.08c.19.51.52.93.98 1.23s1.03.45 1.7.45c.73 0 1.33-.2 1.78-.57.46-.37.69-.89.69-1.52 0-.19-.03-.38-.08-.55-.05-.16-.11-.31-.18-.43m1.29-3.98h-.86l-.06.01v.24h.34l.01.94v.05h.24v-1h.33zm1.32 0h-.23l-.33.55-.34-.54h-.23v1.22h.25v-.73l.26.45h.11l.27-.45v.73h.25l-.01-1.18z"/><path d="M231.2 286.98c-16.27.08-29.41 12.93-29.33 29.62.08 16.68 13.34 29.42 29.62 29.34s29.42-12.93 29.34-29.62c-.08-16.68-13.34-29.42-29.62-29.34m.27 55.71c-14.49.07-26.29-11.27-26.36-26.11-.08-14.84 11.62-26.29 26.11-26.36s26.29 11.26 26.36 26.11-11.62 26.29-26.11 26.36"/><path d="M247.32 308.19h-4.25v-5.31h-1.56v6.84h5.81zm-23.19 22h2.76l2.63-.02v-1.5h-3.8v-1.17h3.11l-.02-1.5h-3.09v-1.17h3.8v-1.65h-5.39zM349.2 73.74c-1.01-1.89-2.57-3.34-4.39-4.04-1.63-.65-2.27-1.26-2.38-1.46l-.3-.54c-1.22-2.24-3.76-6.88-11.75-3.47-5.21 2.23-34.25 15.18-43.03 19.09-.72.29-1.55 0-1.91-.67l-7.62-14.7c-1.11-2.16-3.23-3.57-5.66-3.78l-100.35-8.3c-1.11-.16-2.23.12-3.25.67-1.82 1.02-3 2.37-3.43 3.93-.23.93-.32 2.37.67 3.99 1.07 1.76 4.4 4.05 9.84 7.7 2.6 1.76 6.17 4.15 7.81 5.59.12.1.15.25.08.41-.94 2.25-3.12 6.55-4.68 9.42-1.8 3.32-3.81 4.65-5.57 5.8-4.81 3.16-5.84 3.99-5.72 5.71.23 3.27-1.11 5.18-2.53 7.19-1.31 1.87-2.66 3.8-2.66 6.73v.98l.05 5.25c.02 1.11.35 2.19.95 3.11.4.61.41 1.38.41 2.37l.02 1.64c.03 2.86.07 6.77-.02 11.47v6.52c0 2.98 2.14 4.85 5.7 5 .88.03 116.63-.04 123.73 0 1.42 0 4.01-.94 4.38-4.37h.05v-5.34c-.01-7.92-.02-19.84-.03-24.7 0-.97.53-1.83 1.41-2.25l49.6-24.76c.25-.12.5-.27.73-.43 1.59-1.11 3.47-2.91 3.47-5.17 0-.67 0-1.81-3.6-8.59m-179.46 52.45h78.62c8.93 0 23.32-4.13 42.74-12.28l.44-.19v27.26c.03 1.28-.31 1.8-1.13 1.89-17.88 0-109.94-.04-118.95-.11-.32 0-.56-.09-.77-.3-.96-.96-.94-4.02-.93-5.32 0-1.61-.01-3.31-.03-4.82-.01-1.13-.03-2.17-.02-2.95 0-1.2.01-2.27.01-3.19m121.92-15.99-.16.07c-19.94 8.48-34.46 12.78-43.14 12.78H169.7l-.02-.73c-.01-.25-.12-.58-.51-1.62-.52-1.38-1.48-3.95-1.43-5.05.03-.51.45-.91.97-.91h84.73c17.62 0 79.91-33.6 90.17-39.2a653 653 0 0 1 2.64 4.96c.2.38.24.82.11 1.23-.12.41-.41.75-.79.95-9.92 5.18-51.2 26.18-53.91 27.54M209.85 65.3c-.16-.03-4.01-.47-8.43.49-5.94 1.27-11.82 5.83-12.35 10.15.23-1.86-4.04-3.7-10.44-8.42-2.89-2.13-7.11-5.91-7.31-6.11m12.43 28.76c2.66-5.11 4.59-8.89 5.33-11.03.01-.03.04-.13.26-.21 1.35-.53 2.46-1.67 3.08-2.6l.14-.31c1.2-3.91 4.37-6.43 9.41-7.52 2.04-.43 4-.54 5.42-.54 1.3 0 2.16.09 2.22.1.32.02 33.54 2.21 51.24 3.21 4.85.28 7.59-.72 9.1-1.69l1.72.14c.51.03.95.34 1.19.78l8.19 15.8c1.4 2.7 4.63 3.82 7.4 2.59 7.44-3.32 38.69-17.25 44.07-19.55 3.38-1.46 3.7-.82 4.7 1 .12.25.26.48.38.7.5.84 1.25 1.62 2.24 2.28.15.11.16.25.16.33s-.03.26-.22.36c-11.65 6.28-70.54 37.58-86.35 37.58h-83.27c-.27 0-.39-.19-.43-.27-.04-.1-.09-.29.06-.46 2.74-3.21 3.82-6.55 3.21-9.91-.08-.41.36-.93.79-1.22 1.06-.77 3.86-2.69 5.75-3.99l.29-.21a8.3 8.3 0 0 0 2.73-3.09l1.17-2.28Z"/></g><g fill="#000f9f"><path d="M137.4 345.39V168c0-23.13-13.46-38.28-21.5-47.33-2.05-2.31-4.16-4.69-4.46-5.05l.15-22.01c.01-3-3.04-5.44-6.84-5.44H38.71c-3.79 0-6.87 2.45-6.84 5.46l.24 21.29c-.44 1.07-2.58 3.48-4.63 5.8-8.03 9.06-21.46 24.24-21.46 47.29v177.07c-.04.83-1.25 20.63 11.52 31.22 5.25 4.36 11.94 6.57 19.91 6.57h68.52c7.96 0 14.67-2.21 19.91-6.57 12.93-10.72 11.58-30.33 11.52-30.91m-18.95 25.33c-3.29 2.73-7.37 4.06-12.48 4.06H37.44c-5.1 0-9.18-1.33-12.47-4.06-9.75-8.1-8.69-25.03-8.68-25.42V168c0-20.5 12.27-34.37 19.6-42.65 2.95-3.33 5.07-5.72 5.96-7.88l.37-1.23-.08-14.55c-.01-3 3.06-5.43 6.86-5.43h45.42c3.79 0 6.87 2.43 6.84 5.43l-.09 13.9.37 1.86c.9 2.18 3.02 4.56 5.94 7.85 7.37 8.26 19.64 22.11 19.64 42.69v177.63c.03.17.97 17.08-8.68 25.08"/><path d="M81.31 298.11v1.46l2.16-1.08v4.98h1.57v-4.99l2.2 1.06v-1.45l-2.98-1.4zm-6.28 5.36h1.56v-5l2.19 1.08v-1.45l-2.98-1.4-2.94 1.42v1.45l2.17-1.09zm-17.04 3.17H56.5v6.67h5.56v-1.46h-4.07zm1.51-14.27c-1.14 0-1.88-.75-1.88-1.9-.01-1.15.72-1.91 1.86-1.91.66-.01 1.21.29 1.49.78l1.27-.75c-.56-.9-1.6-1.47-2.76-1.47-1.94.01-3.34 1.47-3.33 3.36s1.42 3.34 3.36 3.33c1.17-.01 2.2-.59 2.75-1.5l-1.28-.72c-.27.5-.83.79-1.48.79m.12 4.45H56.5v6.76h3.35c1.17 0 2.12-.78 2.12-1.94-.01-.68-.33-1.19-.82-1.5.35-.3.57-.73.57-1.28-.01-1.15-.95-2.05-2.1-2.05M58 298.41h1.64c.35-.01.57.23.58.57 0 .35-.24.59-.58.59h-1.6l-.03-1.16Zm1.84 3.76h-1.77v-1.26h1.76c.39-.01.63.24.63.61s-.24.64-.62.64m7.5-8.33a3.35 3.35 0 0 0 3.36-3.4 3.35 3.35 0 0 0-3.39-3.36c-1.86.01-3.38 1.48-3.36 3.4a3.357 3.357 0 0 0 3.4 3.36m-.02-5.25c1.03 0 1.88.8 1.88 1.86.01 1.07-.82 1.88-1.86 1.88-1.04.01-1.88-.79-1.89-1.87 0-1.06.83-1.87 1.87-1.87m.03 8.25c-1.85.01-3.33 1.47-3.31 3.35.01 1.88 1.5 3.33 3.35 3.31 1.84-.01 3.31-1.46 3.31-3.35a3.297 3.297 0 0 0-3.35-3.31m.02 5.18c-1.02 0-1.86-.8-1.86-1.85-.01-1.05.82-1.85 1.83-1.86 1.02 0 1.86.8 1.87 1.85 0 1.05-.82 1.86-1.85 1.86m8.42-8.26a3.323 3.323 0 0 0 3.33-3.36 3.306 3.306 0 0 0-3.36-3.31 3.28 3.28 0 0 0-3.31 3.35c0 1.89 1.5 3.34 3.35 3.33m-.02-5.2c1.02 0 1.85.79 1.86 1.85 0 1.05-.82 1.85-1.84 1.87-1.03 0-1.87-.8-1.87-1.85-.01-1.07.82-1.87 1.85-1.87m2.32 21.73c-.07-.12-.17-.23-.3-.35-.12-.1-.24-.18-.33-.24-.11-.07-.23-.13-.41-.2-.17-.07-.31-.11-.41-.14-.09-.03-.24-.08-.43-.14-.46-.13-.77-.26-.91-.37a.48.48 0 0 1-.04-.78c.12-.1.31-.14.55-.16.5 0 .87.23 1.11.73l.04.1 1.21-.7-.03-.08c-.23-.46-.55-.82-.95-1.07-.4-.26-.87-.39-1.39-.38-.6 0-1.1.18-1.52.53-.42.36-.63.83-.63 1.44.01.3.06.56.17.79q.18.33.48.57c.19.14.4.26.61.33.19.09.43.18.72.26.5.13.85.27 1.03.39.16.1.25.23.25.42 0 .16-.07.29-.2.4-.14.11-.38.17-.69.17-.67 0-1.12-.29-1.36-.89l-.03-.11-1.23.72.03.09q.27.735.93 1.17c.45.29.98.43 1.62.42.69 0 1.26-.19 1.71-.53.43-.37.66-.86.66-1.46 0-.2-.04-.37-.08-.52-.04-.17-.1-.3-.17-.41m1.23-3.8h-.88v.23h.32v.95h.24v-.96h.32zm1.26-.01h-.22l-.32.53-.33-.53h-.22v1.14l.01.05h.23v-.71l.25.42h.11l.26-.42v.71h.24l-.01-1.15z"/><path d="M71.58 271.96c-15.56.08-28.12 12.38-28.05 28.33.08 15.96 12.77 28.13 28.33 28.05 15.57-.07 28.14-12.37 28.06-28.33-.08-15.94-12.76-28.12-28.33-28.05m.26 53.28c-13.85.08-25.14-10.76-25.21-24.96s11.11-25.14 24.97-25.21c13.85-.07 25.14 10.76 25.21 24.96.07 14.19-11.12 25.14-24.97 25.21"/><path d="M87 292.25h-4.07v-5.08h-1.48v6.54H87zm-22.18 21.03h2.65l2.5-.01v-1.43h-3.62v-1.12h2.97l-.01-1.44h-2.96v-1.12h3.62v-1.57h-5.15zm53.43-271.57c0-2.22-.81-4.18-2.31-5.54-1.41-1.27-3.33-1.94-5.4-1.88-1.33.07-6.04-.05-11.55-.15l5.9-5.9c2.59-2.59 2.59-6.81 0-9.41l-3.92-3.91a6.6 6.6 0 0 0-4.7-1.95c-1.78 0-3.45.69-4.71 1.94L72.79 33.68c-1.71-.03-3.37-.06-4.68-.08-3.22-5.22-6.5-10.4-9.8-15.59l-.45-.7c-2.24-3.54-4.48-7.08-6.7-10.63-1.35-2.17-3.1-3.5-5.22-3.95-3.13-.7-5.55.85-6.35 1.35-2.22 1.37-4.24 2.44-6.17 3.29-2.65 1.16-4.35 2.84-5.06 4.99-.74 2.24-.29 4.64 1.34 7.13 4.24 6.47 7.61 11.83 10.41 16.44.32 1.41.43 14.41.49 33.5l.02 4.48c.02 1.17 1.01 5.38 1.6 7.77.26 1.05 1.2 1.79 2.28 1.79h53.95c1.22 0 2.28-1.49 2.38-2.7l.19-2.28c.16-7.06.3-13.24.23-20.12 2.33-.15 4.66-.31 6.98-.54 8.26-.8 10.02-6.1 10.04-10.43l-.02-5.67ZM95.22 19.83c.55-.56 1.53-.55 2.08 0l2.66 2.66c.28.27.42.64.42 1.04s-.15.76-.42 1.04l-9.41 9.41c-3.12-.05-6.27-.11-9.32-.16zm12.27 30.3c-2.78.27-5.59.45-8.36.62-4.97.29-5.65 3.77-5.62 5.82.1 6.47 0 12.41-.15 19.02H48.69c-.18-.82.27-39.86-.76-41.53-2.99-5.05-7.44-12.17-11.79-18.81-.14-.23-.24-.4-.31-.5.14-.09.36-.21.69-.35 2.31-1.01 4.63-2.25 7.11-3.78.41-.25.61-.34.61-.39.06.06.18.19.37.5 2.23 3.57 4.48 7.13 6.73 10.67l.46.73c3.27 5.15 6.54 10.3 9.74 15.5 1.67 2.7 3.77 3.85 7.08 3.85 6.12-.1 18.87.15 28.17.31l3.13.05c5.35.09 9.5.17 10.64-.15v5.67c0 1.91-.13 2.47-3.05 2.75Z"/><path d="M73.13 52.68c-4.01 0-7.28 3.27-7.28 7.28s3.27 7.28 7.28 7.28 7.28-3.27 7.28-7.28-3.27-7.28-7.28-7.28m0 9.69c-1.46 0-2.64-1.08-2.64-2.41s1.18-2.41 2.64-2.41 2.64 1.08 2.64 2.41-1.18 2.41-2.64 2.41"/></g></svg>');
$("ul.mobile-nav.vertical-mega-menu li:nth-child(2) a i.mm-icon" ).replaceWith( '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384.31 456.97"><g fill="#000f9f"><path d="M111.25 414.05V231c0-23.86-10.96-39.5-17.5-48.84-1.67-2.39-3.39-4.84-3.63-5.21l.12-22.72c.01-3.1-2.48-5.61-5.57-5.61H30.9c-3.09 0-5.59 2.53-5.57 5.64l.2 21.97c-.36 1.1-2.1 3.59-3.77 5.98-6.54 9.35-17.48 25.01-17.48 48.79v182.72c-.03.86-1.02 21.29 9.38 32.22 4.28 4.5 9.72 6.78 16.21 6.78h55.8c6.48 0 11.94-2.28 16.21-6.78 10.53-11.06 9.43-31.3 9.38-31.9m-15.43 26.14c-2.68 2.81-6 4.19-10.16 4.19h-55.8c-4.15 0-7.47-1.38-10.15-4.19-7.94-8.36-7.08-25.83-7.06-26.23V231c0-21.15 9.99-35.47 15.96-44.01 2.4-3.43 4.13-5.9 4.86-8.13l.3-1.27-.07-15.01c-.01-3.1 2.49-5.6 5.58-5.6h36.98c3.09 0 5.59 2.5 5.57 5.6l-.07 14.35.3 1.92c.73 2.25 2.46 4.71 4.83 8.1 6 8.53 15.99 22.82 15.99 44.05v183.29c.03.17.79 17.62-7.07 25.88m-6.04-304.56.43-18.32a5.55 5.55 0 0 0-2.83-4.98l-14.76-8.35c-.84-.47-1.78-.71-2.74-.71H45.64c-.95 0-1.9.24-2.74.71l-14.76 8.35a5.59 5.59 0 0 0-2.83 4.98l.45 18.32a5.57 5.57 0 0 0 5.57 5.44h52.88c3.02 0 5.5-2.42 5.57-5.44m-43.4-24h22.77l12.67 7.16-.34 13.92H34.04l-.33-13.92z"/><path d="M68.21 361.99v1.49l2.21-1.1v5.07h1.59v-5.09l2.25 1.08v-1.47l-3.04-1.43zm-6.4 5.46h1.59v-5.1l2.24 1.1v-1.47l-3.04-1.43-2.99 1.45v1.48l2.2-1.12zm-17.35 3.23h-1.52v6.79h5.66v-1.48h-4.14zm1.53-14.54c-1.16 0-1.92-.76-1.92-1.94-.01-1.17.73-1.95 1.89-1.95.67-.01 1.23.29 1.52.79l1.29-.76c-.57-.92-1.63-1.5-2.81-1.5-1.97.01-3.4 1.5-3.39 3.42.01 1.93 1.45 3.4 3.42 3.39 1.2-.01 2.24-.6 2.8-1.53l-1.3-.74c-.28.51-.84.81-1.51.81m.14 4.56h-3.18v6.89h3.41c1.2 0 2.16-.79 2.16-1.97-.01-.69-.34-1.21-.83-1.53.36-.31.58-.75.58-1.3-.01-1.17-.96-2.09-2.14-2.09m-1.66 1.62h1.67c.35-.01.58.24.59.58 0 .35-.24.6-.59.6H44.5l-.03-1.18Zm1.88 3.83h-1.81v-1.28h1.8c.4-.01.64.25.64.62s-.24.66-.63.66m7.64-8.51c1.9-.01 3.43-1.52 3.42-3.47s-1.56-3.43-3.46-3.42a3.425 3.425 0 0 0-3.43 3.47c.01 1.95 1.57 3.43 3.46 3.42m-.02-5.35c1.05 0 1.92.82 1.92 1.89.01 1.09-.84 1.92-1.89 1.92-1.06.01-1.92-.81-1.93-1.9 0-1.08.84-1.9 1.9-1.9m.05 8.4a3.37 3.37 0 0 0-3.38 3.41 3.363 3.363 0 0 0 3.41 3.38 3.37 3.37 0 0 0 3.38-3.41 3.37 3.37 0 0 0-3.41-3.38m.02 5.28c-1.04 0-1.89-.82-1.89-1.88-.01-1.07.84-1.88 1.87-1.89 1.04 0 1.89.82 1.9 1.88 0 1.07-.84 1.89-1.88 1.89m8.57-8.42a3.38 3.38 0 0 0 3.39-3.42 3.38 3.38 0 0 0-3.42-3.38c-1.88 0-3.39 1.48-3.38 3.41 0 1.93 1.53 3.4 3.41 3.39m-.02-5.29c1.04 0 1.89.8 1.9 1.88 0 1.07-.83 1.88-1.88 1.9-1.05 0-1.9-.82-1.9-1.88-.01-1.09.83-1.9 1.88-1.9m2.38 22.14c-.07-.12-.17-.24-.3-.35-.12-.1-.24-.18-.33-.25a1.7 1.7 0 0 0-.42-.2c-.18-.07-.31-.11-.42-.15-.09-.03-.24-.08-.44-.15-.46-.14-.78-.26-.93-.37a.52.52 0 0 1-.22-.41c0-.17.07-.28.19-.39.13-.1.31-.15.56-.16.51 0 .88.24 1.13.75l.05.1 1.23-.71-.03-.08c-.23-.46-.56-.84-.96-1.09-.41-.26-.88-.4-1.42-.39-.61 0-1.12.18-1.55.54-.42.36-.65.85-.65 1.46.01.31.06.57.17.8.12.23.28.42.49.58.2.15.41.26.62.34.2.09.44.18.73.26.51.14.86.27 1.05.4.16.1.26.24.26.43 0 .16-.07.29-.2.41-.14.11-.39.17-.71.17-.69 0-1.14-.29-1.38-.91l-.03-.11-1.25.74.03.09c.19.5.5.89.95 1.19.45.29 1 .44 1.65.43.7 0 1.29-.19 1.74-.54.44-.37.67-.87.67-1.49 0-.2-.04-.37-.08-.53-.05-.17-.1-.31-.18-.42m1.23-3.86h-.89v.23h.33v.97h.24v-.98h.32zm1.29-.02h-.22l-.32.55-.35-.55h-.22v1.17l.02.05h.23V371l.25.43h.11l.27-.43v.73h.24l-.01-1.17z"/><path d="M58.3 335.34c-15.85.08-28.65 12.62-28.59 28.87.08 16.26 13.01 28.67 28.86 28.59 15.87-.07 28.67-12.61 28.59-28.87-.08-16.24-13-28.65-28.87-28.59m.27 54.29c-14.11.08-25.62-10.96-25.68-25.44-.07-14.47 11.32-25.62 25.44-25.68 14.12-.07 25.62 10.96 25.69 25.44.07 14.46-11.33 25.62-25.45 25.68"/><path d="M74.02 356.02h-4.15v-5.18h-1.51v6.66h5.66zm-22.6 21.43h2.69l2.55-.01v-1.46h-3.69v-1.15H56l-.02-1.46h-3.01v-1.14h3.69v-1.6h-5.24z"/></g><g fill="#000f9f"><path d="M239.06 408.14V197.17c0-27.51-12.63-45.52-20.17-56.29-1.93-2.75-3.9-5.58-4.19-6.01l.14-26.18c.01-3.57-2.86-6.47-6.42-6.47h-61.97c-3.56 0-6.44 2.91-6.42 6.5l.22 25.32c-.42 1.27-2.42 4.14-4.35 6.89-7.54 10.78-20.14 28.83-20.14 56.24v210.6c-.04.99-1.18 24.54 10.81 37.14 4.93 5.19 11.2 7.82 18.68 7.82h64.31c7.47 0 13.77-2.63 18.68-7.82 12.14-12.75 10.87-36.08 10.81-36.76m-17.79 30.12c-3.09 3.24-6.91 4.83-11.71 4.83h-64.31c-4.78 0-8.61-1.59-11.7-4.83-9.15-9.63-8.16-29.77-8.14-30.23V197.17c0-24.38 11.52-40.88 18.4-50.72 2.77-3.96 4.76-6.8 5.6-9.37l.35-1.47-.08-17.31a6.434 6.434 0 0 1 6.44-6.46h42.62c3.56 0 6.45 2.88 6.42 6.46l-.08 16.54.35 2.21c.84 2.59 2.83 5.42 5.57 9.34 6.91 9.83 18.44 26.3 18.44 50.78v211.27c.03.2.91 20.31-8.15 29.83m-6.96-351.06.5-21.11a6.39 6.39 0 0 0-3.26-5.74l-17.01-9.62c-.97-.54-2.05-.82-3.16-.82h-27.93c-1.09 0-2.19.28-3.16.82l-17.01 9.62a6.44 6.44 0 0 0-3.27 5.74l.52 21.11c.09 3.48 2.93 6.27 6.42 6.27h60.95c3.48 0 6.34-2.79 6.42-6.27m-50.02-27.66h26.24l14.61 8.26-.39 16.05h-54.68l-.38-16.05z"/><path d="M189.46 348.14v1.72l2.54-1.27v5.85h1.84v-5.86l2.59 1.24v-1.7l-3.5-1.65zm-7.38 6.3h1.83v-5.88l2.58 1.27v-1.7l-3.5-1.65-3.45 1.68v1.7l2.54-1.28zm-20 3.72h-1.75v7.83h6.52v-1.71h-4.77zm1.76-16.76c-1.34 0-2.21-.88-2.21-2.23-.01-1.35.84-2.25 2.18-2.25.78-.01 1.42.34 1.75.92l1.49-.88c-.66-1.06-1.87-1.72-3.24-1.72-2.27.01-3.92 1.72-3.91 3.95.01 2.22 1.67 3.92 3.95 3.91 1.38-.01 2.58-.69 3.23-1.76l-1.5-.85c-.32.59-.97.93-1.74.93m.15 5.22h-3.66v7.94h3.93c1.38 0 2.49-.91 2.49-2.27-.01-.8-.39-1.4-.96-1.76.41-.35.67-.86.67-1.5-.01-1.35-1.11-2.4-2.46-2.4m-1.91 1.87h1.92c.41-.01.67.27.68.67 0 .41-.28.69-.68.69h-1.88zm2.16 4.42h-2.08v-1.48h2.07c.46-.01.74.29.74.72s-.28.76-.73.76m8.81-9.83c2.2-.01 3.96-1.75 3.95-4s-1.8-3.96-3.99-3.95c-2.18.01-3.97 1.74-3.95 4 .01 2.25 1.81 3.96 3.99 3.95m-.03-6.17c1.21 0 2.21.94 2.21 2.18.01 1.25-.97 2.21-2.18 2.21-1.22.01-2.21-.93-2.22-2.2 0-1.24.97-2.19 2.2-2.19m.04 9.7c-2.17.01-3.91 1.72-3.89 3.93.01 2.21 1.76 3.91 3.93 3.89 2.16-.01 3.89-1.71 3.89-3.93a3.877 3.877 0 0 0-3.93-3.89m.03 6.09c-1.2 0-2.18-.94-2.18-2.17-.01-1.23.97-2.17 2.16-2.18 1.2 0 2.18.94 2.2 2.17 0 1.23-.97 2.18-2.17 2.18m9.85-9.71a3.9 3.9 0 0 0 3.91-3.95c-.01-2.21-1.78-3.91-3.95-3.89-2.17 0-3.91 1.71-3.89 3.93 0 2.22 1.76 3.92 3.93 3.91m-.03-6.1c1.2 0 2.18.93 2.19 2.17 0 1.23-.96 2.17-2.16 2.2-1.21 0-2.19-.94-2.19-2.17a2.15 2.15 0 0 1 2.17-2.2m2.74 25.53c-.08-.14-.2-.27-.35-.41-.14-.12-.28-.21-.39-.29-.12-.08-.27-.16-.48-.23-.2-.08-.36-.13-.48-.17-.1-.04-.28-.09-.5-.17-.54-.16-.9-.3-1.07-.43a.58.58 0 0 1-.25-.47c0-.2.08-.33.22-.44.14-.12.36-.17.64-.18.59 0 1.02.27 1.3.86l.05.12 1.42-.82-.04-.09c-.27-.54-.65-.97-1.11-1.25-.47-.3-1.02-.46-1.63-.44-.7 0-1.29.21-1.78.63s-.75.98-.75 1.69c.01.35.07.65.2.93.14.26.33.48.56.67.23.17.47.3.71.39q.345.165.84.3c.59.16.99.31 1.21.46.19.12.29.27.29.5 0 .18-.08.34-.24.47s-.44.2-.82.2c-.79 0-1.31-.34-1.59-1.04l-.04-.13-1.44.85.04.1c.22.58.58 1.03 1.1 1.37s1.15.51 1.9.5c.81 0 1.48-.22 2.01-.63.51-.43.78-1.01.78-1.71 0-.23-.05-.43-.1-.61-.05-.2-.12-.35-.2-.48m1.44-4.52h-1.03v.28h.38v1.11h.28v-1.13h.37zm1.48-.01h-.25l-.37.63-.4-.63h-.25v1.34l.01.06h.27v-.84l.29.5h.13l.31-.5v.84h.28l-.02-1.35z"/><path d="M178.03 317.43c-18.27.09-33.03 14.54-32.95 33.28.09 18.75 15 33.04 33.27 32.95 18.29-.08 33.05-14.53 32.96-33.28-.1-18.72-14.98-33.03-33.28-32.95m.31 62.58c-16.27.09-29.53-12.63-29.6-29.32-.08-16.68 13.04-29.53 29.32-29.6 16.27-.08 29.53 12.63 29.61 29.32.08 16.67-13.06 29.53-29.33 29.6"/><path d="M196.15 341.26h-4.78v-5.97h-1.74v7.68h6.52zm-26.05 24.7h3.1l2.94-.01v-1.69h-4.25v-1.31h3.49l-.02-1.69h-3.47v-1.32h4.25v-1.84h-6.04z"/></g><g fill="#000f9f"><path d="M379.35 403.09V168.18c0-30.62-14.06-50.69-22.46-62.68-2.14-3.06-4.35-6.22-4.66-6.69l.15-29.15c.02-3.98-3.18-7.2-7.15-7.2h-69c-3.96 0-7.17 3.24-7.14 7.23l.25 28.19c-.46 1.41-2.7 4.61-4.84 7.67-8.39 12-22.43 32.1-22.43 62.62l.02 234.49c-.06 1.11-1.33 27.32 12.02 41.35 5.49 5.77 12.48 8.71 20.8 8.71h71.6c8.31 0 15.33-2.93 20.8-8.71 13.51-14.2 12.1-40.17 12.04-40.93m-19.8 33.54c-3.44 3.61-7.7 5.38-13.04 5.38h-71.6c-5.32 0-9.59-1.77-13.03-5.38-10.19-10.72-9.08-33.14-9.07-33.66V168.18c0-27.15 12.82-45.52 20.48-56.47 3.08-4.4 5.29-7.57 6.23-10.43l.39-1.64-.09-19.27c-.02-3.98 3.2-7.19 7.17-7.19h47.45c3.96 0 7.18 3.21 7.14 7.19l-.09 18.41.39 2.46c.94 2.89 3.15 6.04 6.2 10.4 7.7 10.94 20.53 29.28 20.53 56.53l.02 235.23c.02.22 1 22.61-9.09 33.22m-7.75-390.86.55-23.51c.07-2.64-1.33-5.1-3.63-6.39L329.77 5.15c-1.08-.6-2.28-.91-3.52-.91h-31.1c-1.22 0-2.44.31-3.51.91L272.7 15.86a7.18 7.18 0 0 0-3.64 6.39l.57 23.51c.1 3.87 3.26 6.98 7.15 6.98h67.86c3.87 0 7.06-3.11 7.15-6.98m-55.69-30.8h29.22l16.26 9.19-.43 17.87h-60.88l-.42-17.87 16.26-9.19Z"/><path d="M324.11 336.28v1.91l2.83-1.41v6.51h2.05v-6.53l2.89 1.39v-1.9l-3.9-1.83zm-8.21 7.01h2.04v-6.54l2.87 1.41v-1.89l-3.9-1.83-3.84 1.86v1.89l2.83-1.43zm-22.27 4.15h-1.95v8.71h7.26v-1.9h-5.31zm1.96-18.66c-1.49 0-2.46-.98-2.46-2.49-.01-1.5.94-2.5 2.43-2.5.87-.01 1.58.38 1.95 1.02l1.66-.98c-.73-1.18-2.09-1.92-3.61-1.92-2.53.01-4.36 1.92-4.35 4.39s1.86 4.36 4.39 4.35c1.54-.01 2.87-.77 3.59-1.96l-1.67-.95c-.36.66-1.08 1.03-1.93 1.03m.17 5.84h-4.08v8.84h4.38c1.53 0 2.77-1.02 2.77-2.53-.01-.89-.43-1.56-1.07-1.96.46-.39.74-.96.74-1.67-.01-1.5-1.24-2.68-2.74-2.68m-2.12 2.08h2.14c.45-.01.75.31.76.74 0 .45-.31.77-.76.77h-2.09l-.04-1.51Zm2.41 4.92h-2.32v-1.64h2.31c.51-.01.82.32.82.8s-.31.84-.81.84m9.8-10.93a4.38 4.38 0 0 0 4.39-4.45c-.01-2.5-2-4.41-4.44-4.39a4.386 4.386 0 0 0-4.4 4.45c.01 2.5 2.01 4.41 4.44 4.39m-.03-6.87c1.35 0 2.46 1.05 2.46 2.43.01 1.4-1.08 2.46-2.43 2.46-1.36.01-2.46-1.03-2.47-2.44 0-1.38 1.08-2.44 2.44-2.44m.06 10.79c-2.41.01-4.35 1.92-4.33 4.38s1.96 4.35 4.38 4.33c2.4-.01 4.33-1.91 4.33-4.38a4.317 4.317 0 0 0-4.38-4.33m.03 6.78c-1.34 0-2.43-1.05-2.43-2.41-.01-1.37 1.08-2.41 2.4-2.43a2.42 2.42 0 0 1 2.44 2.42c0 1.37-1.08 2.43-2.41 2.43m10.99-10.82a4.337 4.337 0 0 0 4.35-4.39c-.01-2.46-1.99-4.35-4.39-4.33a4.3 4.3 0 0 0-4.33 4.38c0 2.47 1.96 4.36 4.38 4.35m-.03-6.79c1.34 0 2.42 1.03 2.44 2.41 0 1.37-1.07 2.41-2.41 2.44-1.35 0-2.44-1.05-2.44-2.41-.01-1.4 1.07-2.44 2.41-2.44m3.05 28.41q-.135-.24-.39-.45c-.16-.13-.31-.23-.43-.32-.14-.09-.3-.17-.54-.26-.23-.09-.4-.15-.54-.19-.12-.04-.31-.1-.56-.19-.6-.17-1-.34-1.19-.48a.64.64 0 0 1-.28-.52c0-.22.09-.36.24-.49.16-.13.4-.19.71-.2.65 0 1.13.31 1.45.96l.06.13 1.58-.92-.04-.1c-.3-.6-.72-1.08-1.24-1.4-.52-.34-1.14-.51-1.82-.49-.78 0-1.43.23-1.99.7-.55.47-.83 1.09-.83 1.88.01.39.07.73.22 1.03.15.29.36.54.63.74.25.19.52.34.79.44.25.12.57.23.94.34.65.17 1.11.35 1.35.51.21.13.33.31.33.55 0 .2-.09.38-.26.52-.18.15-.49.22-.91.22-.88 0-1.46-.38-1.78-1.16l-.04-.15-1.61.95.04.12c.24.64.64 1.15 1.22 1.53s1.28.57 2.12.55c.9 0 1.65-.25 2.23-.7.57-.48.87-1.12.87-1.91 0-.26-.05-.48-.11-.68-.06-.22-.13-.39-.22-.54m1.61-4.99h-1.14v.3h.42v1.24h.31v-1.25h.41zm1.65-.02h-.28l-.41.7-.44-.7h-.28v1.5l.01.06h.3v-.93l.33.55h.13l.35-.55v.93h.31l-.02-1.5z"/><path d="M311.39 302.09c-20.34.1-36.77 16.19-36.69 37.05.1 20.87 16.7 36.79 37.04 36.69 20.36-.09 36.79-16.18 36.69-37.05-.11-20.85-16.68-36.77-37.05-36.69m.34 69.68c-18.11.1-32.88-14.07-32.96-32.64-.09-18.58 14.52-32.87 32.65-32.96 18.12-.09 32.87 14.07 32.97 32.64.09 18.56-14.54 32.87-32.65 32.96"/><path d="M331.56 328.62h-5.32v-6.65h-1.94v8.55h7.26zm-29 27.5h3.45l3.28-.01v-1.88h-4.74v-1.47h3.88l-.01-1.87h-3.87v-1.47h4.74v-2.05h-6.73z"/></g></svg>' );
$("ul.mobile-nav.vertical-mega-menu li:nth-child(3) a i.mm-icon" ).replaceWith('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 195.15 436.02"><path fill="#000f9f" d="M32.18 117.29h130.78c4.64 0 8.42-3.86 8.42-8.59V72.49c0-3.09-1.51-5.97-4.01-7.71l-15.61-10.77c-3.54-9.17-6.06-12.18-7.65-13.23-.48-2-1.14-8.38-1.15-22.58 0-4.22-3.04-7.84-7.1-8.5-1.89-.5-17.27-4.38-38.29-4.38S61.17 9.2 59.28 9.7c-4.07.67-7.11 4.29-7.11 8.5 0 14.2-.66 20.58-1.15 22.58-1.58 1.05-4.1 4.06-7.65 13.23L27.76 64.78c-2.51 1.73-4 4.61-4 7.71v36.21c0 4.74 3.78 8.59 8.41 8.59m26.07-99.08c0-1.2.89-2.24 2.05-2.39l.2-.02.19-.06c.15-.04 15.76-4.22 36.9-4.22s36.74 4.17 36.89 4.22l.19.06.2.02c1.17.15 2.05 1.19 2.05 2.39 0 1.55 0 3.37.03 5.3l-78.73.55c.03-2.13.04-4.15.04-5.85m-4.14 27.96c2.68-.85 3.33-4.46 3.78-12.25.14-2.4.23-5 .28-7.54l78.81-.55c.06 2.7.15 5.52.29 8.09.46 7.79 1.11 11.39 3.78 12.25 1.03 1.07 3.17 5.31 4.93 9.75h-16.43v-2.51c0-.67-.22-1.33-.61-1.86l-14.69-19.97a3 3 0 0 0-2.43-1.24H81.74c-.99 0-1.93.5-2.49 1.33l-13.7 20.04a3.2 3.2 0 0 0-.55 1.77v2.44H49.17c1.77-4.44 3.91-8.68 4.93-9.75m52.77-1.67H89.61c-1.88 0-3.72.78-5.03 2.16-4.3 4.47-6.62 7.33-7.89 9.26h-5.62v-1.46l12.25-17.92h26.98l13.17 17.9v1.48h-5.51c-1.07-1.48-2.83-3.77-4.41-5.71-4.07-5-5.08-5.71-6.67-5.71m6.5 15.53v25.16c-.57 1.09-2.76 3.64-6.52 7.57-.07.08-.14.15-.21.22-9.59.18-17.16.21-19.52.08-.97-1.16-3.14-4.44-5.86-9.11V60.19c.42-.9 2.43-3.75 7.66-9.19.18-.19.42-.29.69-.29h16.27c1.68 1.71 5.92 7.07 7.5 9.33M29.85 72.5c0-1.03.5-1.99 1.33-2.57L48.1 58.26h16.91v15.13c0 1.72 1.36 3.1 3.04 3.1s3.04-1.38 3.04-3.1V58.26h4.38c-.26.74-.27 1.21-.27 1.6v24.5c0 .85.23 1.68.65 2.42 6.65 11.48 8.06 11.9 9.19 12.24.4.11 1.09.33 7.84.33 3.18 0 7.71-.05 14.19-.17.69.2 1.46.16 2.19-.16a3.25 3.25 0 0 0 1.57-1.51c.12-.12.25-.25.38-.4 6.4-6.69 8.25-9.27 8.25-11.51V59.75c0-.5-.07-1-.21-1.48h4.23v16.28c0 1.71 1.37 3.1 3.04 3.1s3.04-1.39 3.04-3.1V58.27h17.51l16.92 11.67c.84.58 1.33 1.54 1.33 2.57v36.21c0 1.32-1.05 2.39-2.34 2.39H32.18c-1.29 0-2.34-1.07-2.34-2.39V72.51Z"/><path fill="#000f9f" d="M83.99 80.44c0 .21.06.42.16.6.8 1.38 4.35 7.43 5.29 7.71s13.11.07 15.7 0c1.2-1.29 6.01-6.08 6.01-7.45v-7.17H83.98v6.29Z"/><g fill="#000f9f"><path d="M97.51 391.89c21.96 0 39.75-18.17 39.75-40.59s-17.8-40.58-39.75-40.58-39.75 18.17-39.75 40.58 17.79 40.59 39.75 40.59m0-74.45c18.31 0 33.15 15.16 33.15 33.85s-14.84 33.85-33.15 33.85-33.15-15.15-33.15-33.85 14.84-33.85 33.15-33.85"/><path d="M106.55 362.11h5.18v-13.94l7.29 3.6v-5.89l-9.88-5.4-9.79 5.48v5.92l7.2-3.67zm-23.36 0h5.18v-13.94l7.3 3.6v-5.89l-9.89-5.4-9.78 5.48v5.92l7.19-3.67zm32.57-1.18h.44v1.17h.4v-1.17h.44v-.32h-1.28zm2.35.53h-.01l-.34-.86h-.5v1.51h.39v-.88h.01l.33.86h.24l.32-.85h.01v.87h.39v-1.51h-.5z"/></g><path d="m170.97 121.82-.98-.66H25.16l-.98.66c-.15.1-15.17 10.36-16.57 28.97-1.3 17.23-.02 38.61 0 38.83l.1 1.56 1.2.88c.08.07.18.2.21.27.08 3.33 4.1 154.19 5.84 219.4v.22l.08.45.05.18c.05.17 5.22 17.31 25.06 17.81 14.77.37 47.66.12 57.44.03 5.6.05 20.04.16 33.72.16 10.51 0 18.5-.07 23.72-.2 19.83-.5 25.01-17.64 25.06-17.81l.11-.4.02-.41c1.18-49.85 4.94-209 5.18-219.21.06-.04.12-.07.18-.1l1.86-.76.13-2.08c0-.22 1.29-21.6 0-38.83-1.4-18.6-16.41-28.87-16.56-28.97m3.17 289.33c-.77 2.13-5.28 12.69-19.27 13.04-5.18.13-13.11.2-23.58.2-13.68 0-28.12-.11-33.69-.16h-.05c-9.73.09-42.58.33-57.27-.03-14.09-.35-18.56-11.06-19.28-13.06-.15-5.57-1.64-61.83-3.08-115.9h158.92c-1.28 54-2.6 110.13-2.74 115.93m2.8-118.25H17.86c-.27-10.07-.54-20.04-.79-29.56h160.57c-.23 9.52-.46 19.49-.7 29.56m1.52-64.52H16.59v2.32H178.4c-.21 9.13-.46 19.41-.72 30.31H17.01c-.85-31.81-1.55-58.27-1.77-66.29h164.02c-.12 5.18-.42 17.46-.8 33.66m3.1-40.65c-1.22.97-2.23 2.42-2.25 4.29v.37H15.19v-.15c0-1.86-.84-3.25-1.58-4.12-.24-4.57-1.03-22.28.07-36.86 1.01-13.43 10.69-21.82 13.23-23.8h141.34c2.56 2 12.22 10.38 13.23 23.8 1.07 14.18.34 31.36.08 36.47" style="fill:#000f9f;stroke:#000f9f;stroke-miterlimit:10;stroke-width:.5px"/></svg>');
$("ul.mobile-nav.vertical-mega-menu li:nth-child(6) a i.mm-icon" ).replaceWith( '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 153.26 540.75"><g fill="#000f9f"><path d="M145.25 485.56v-234.9c0-30.62-14.06-50.69-22.46-62.68-2.14-3.06-4.35-6.22-4.66-6.69l.15-29.15c.02-3.98-3.18-7.2-7.15-7.2H42.14c-3.96 0-7.17 3.24-7.14 7.23l.25 28.19c-.46 1.41-2.7 4.61-4.84 7.67-8.39 12-22.43 32.1-22.43 62.62L8 485.14c-.06 1.11-1.33 27.32 12.02 41.35 5.49 5.77 12.48 8.71 20.8 8.71h71.59c8.31 0 15.33-2.93 20.8-8.71 13.51-14.2 12.1-40.17 12.04-40.93m-19.8 33.54c-3.44 3.61-7.7 5.38-13.04 5.38h-71.6c-5.32 0-9.59-1.77-13.03-5.38-10.19-10.72-9.08-33.14-9.07-33.66V250.66c0-27.15 12.82-45.52 20.48-56.47 3.08-4.4 5.29-7.57 6.23-10.43l.39-1.64-.09-19.27c-.02-3.98 3.2-7.19 7.17-7.19h47.45c3.96 0 7.18 3.21 7.14 7.19l-.09 18.41.39 2.46c.94 2.89 3.15 6.04 6.2 10.4 7.7 10.94 20.53 29.28 20.53 56.53l.02 235.23c.02.22 1 22.61-9.09 33.22m-7.74-390.87.55-23.51c.07-2.64-1.33-5.1-3.63-6.39L95.68 87.62c-1.08-.6-2.28-.91-3.52-.91h-31.1c-1.22 0-2.44.31-3.51.91L38.61 98.33a7.18 7.18 0 0 0-3.64 6.39l.57 23.51c.1 3.87 3.26 6.98 7.15 6.98h67.86c3.87 0 7.06-3.11 7.15-6.98m-55.69-30.8h29.22l16.26 9.19-.43 17.87H46.17l-.42-17.87z"/><path d="M90.02 418.76v1.9l2.83-1.41v6.52h2.05v-6.54l2.88 1.39v-1.89l-3.89-1.84zm-8.21 7.01h2.04v-6.55l2.87 1.41v-1.89l-3.9-1.83-3.84 1.86v1.89l2.83-1.43zm-22.28 4.14h-1.94v8.72h7.26v-1.91h-5.32zm1.97-18.66c-1.49 0-2.46-.98-2.46-2.49-.01-1.5.94-2.5 2.43-2.5.87-.01 1.58.38 1.95 1.02l1.66-.98c-.73-1.18-2.09-1.92-3.61-1.92-2.53.01-4.36 1.92-4.35 4.39s1.86 4.36 4.39 4.35c1.54-.01 2.87-.77 3.59-1.96l-1.67-.95c-.36.66-1.08 1.03-1.93 1.03m.17 5.84h-4.08v8.84h4.38c1.53 0 2.77-1.02 2.77-2.53-.01-.89-.43-1.56-1.07-1.96.46-.39.74-.96.74-1.67-.01-1.5-1.24-2.68-2.74-2.68m-2.12 2.08h2.14c.45-.01.75.31.76.74 0 .45-.31.77-.76.77H59.6l-.04-1.51Zm2.41 4.92h-2.32v-1.64h2.31c.51-.01.82.32.82.8s-.31.84-.81.84m9.8-10.93a4.38 4.38 0 0 0 4.39-4.45c-.01-2.5-2-4.41-4.44-4.39a4.386 4.386 0 0 0-4.4 4.45c.01 2.5 2.01 4.41 4.44 4.39m-.03-6.87c1.35 0 2.46 1.05 2.46 2.43.01 1.4-1.08 2.46-2.43 2.46-1.36.01-2.46-1.03-2.47-2.44 0-1.38 1.08-2.44 2.44-2.44m.06 10.79c-2.41.01-4.35 1.92-4.33 4.38s1.96 4.35 4.38 4.33c2.4-.01 4.33-1.91 4.33-4.38a4.317 4.317 0 0 0-4.38-4.33m.03 6.78c-1.34 0-2.43-1.05-2.43-2.41-.01-1.37 1.08-2.41 2.4-2.43a2.42 2.42 0 0 1 2.44 2.42c0 1.37-1.08 2.43-2.41 2.43m10.99-10.82a4.337 4.337 0 0 0 4.35-4.39c-.01-2.46-1.99-4.35-4.39-4.33a4.3 4.3 0 0 0-4.33 4.38c0 2.47 1.96 4.36 4.38 4.35m-.03-6.79c1.34 0 2.42 1.03 2.44 2.41 0 1.37-1.07 2.41-2.41 2.44-1.35 0-2.44-1.05-2.44-2.41-.01-1.4 1.07-2.44 2.41-2.44m3.05 28.41q-.135-.24-.39-.45c-.16-.13-.31-.23-.43-.32-.14-.09-.3-.17-.54-.26-.23-.09-.4-.15-.54-.19-.12-.04-.31-.1-.56-.19-.6-.17-1-.34-1.19-.48a.64.64 0 0 1-.28-.52c0-.22.09-.36.24-.49.16-.13.4-.19.71-.2.65 0 1.13.31 1.45.96l.06.13 1.58-.92-.04-.1c-.3-.6-.72-1.08-1.24-1.4-.52-.34-1.14-.51-1.82-.49-.78 0-1.43.23-1.99.7-.55.47-.83 1.09-.83 1.88.01.39.07.73.22 1.03.15.29.36.54.63.74.25.19.52.34.79.44.25.12.57.23.94.34.65.17 1.11.35 1.35.51.21.13.33.31.33.55 0 .2-.09.38-.26.52-.18.15-.49.22-.91.22-.88 0-1.46-.38-1.78-1.16l-.04-.15-1.61.95.04.12c.24.64.64 1.15 1.22 1.53s1.28.57 2.12.55c.9 0 1.65-.25 2.23-.7.57-.48.87-1.12.87-1.91 0-.26-.05-.48-.11-.68-.06-.22-.13-.39-.22-.54m1.61-4.99H86.3v.3h.41v1.24h.32V430h.41zm1.65-.02h-.28l-.42.7-.43-.7h-.29v1.5l.02.06h.3v-.93l.33.55h.13l.35-.55v.93h.31l-.02-1.5z"/><path d="M77.3 384.56c-20.34.1-36.77 16.19-36.69 37.05.1 20.87 16.7 36.79 37.04 36.69 20.36-.09 36.79-16.18 36.69-37.05-.11-20.85-16.68-36.77-37.05-36.69m.34 69.68c-18.11.1-32.88-14.07-32.96-32.64-.09-18.58 14.52-32.87 32.65-32.96 18.12-.09 32.87 14.07 32.97 32.64.09 18.56-14.54 32.87-32.65 32.96"/><path d="M97.47 411.09h-5.32v-6.65h-1.94V413h7.26zm-29 27.51h3.45l3.27-.02v-1.88h-4.73v-1.46h3.88l-.01-1.88h-3.87v-1.47h4.73v-2.05h-6.72z"/></g><path fill="#000f9f" d="M82.94 15.13 84.52 20a6.65 6.65 0 0 0 6.31 4.59h5.12c6.43 0 9.1 8.23 3.9 12l-4.14 3.01a6.625 6.625 0 0 0-2.41 7.42l1.58 4.87c1.99 6.11-5.01 11.2-10.21 7.42l-4.14-3.01a6.63 6.63 0 0 0-7.8 0l-4.14 3.01c-5.2 3.78-12.2-1.31-10.21-7.42l1.58-4.87a6.63 6.63 0 0 0-2.41-7.42l-4.14-3.01c-5.2-3.78-2.53-12 3.9-12h5.12c2.87 0 5.42-1.85 6.31-4.59l1.58-4.87c1.99-6.11 10.64-6.11 12.62 0"/></svg>' );
$("ul.mobile-nav.vertical-mega-menu li:nth-child(4) a i.mm-icon" ).replaceWith( '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 338.08 318.47"><path fill="#000f9f" d="M86.25 218.94v1.26l1.89-.94v4.34h1.36v-4.35l1.91.93v-1.26l-2.59-1.22zm-5.47 4.66h1.36v-4.35l1.92.93v-1.26l-2.6-1.22-2.56 1.24v1.26l1.88-.94zm-14.81 2.76h-1.3v5.8h4.83v-1.27h-3.53zm1.31-12.41c-.99 0-1.63-.65-1.64-1.65 0-1 .63-1.66 1.62-1.67.57 0 1.05.25 1.3.68l1.1-.64c-.49-.79-1.39-1.29-2.4-1.28-1.68 0-2.9 1.28-2.89 2.92 0 1.65 1.24 2.9 2.92 2.89 1.02 0 1.91-.51 2.39-1.3l-1.11-.63c-.24.43-.72.69-1.29.69Zm.11 3.88h-2.72v5.88h2.91c1.02 0 1.85-.67 1.85-1.69 0-.58-.28-1.02-.71-1.29.31-.27.5-.65.49-1.12 0-.99-.82-1.78-1.82-1.77Zm-1.42 1.38h1.43c.3 0 .5.2.5.5s-.2.51-.5.51H66zm1.61 3.27h-1.55v-1.09h1.55c.33 0 .54.22.54.54s-.21.55-.54.55m6.52-7.27c1.62 0 2.93-1.29 2.92-2.95 0-1.66-1.33-2.93-2.95-2.92-1.62 0-2.93 1.29-2.92 2.95 0 1.66 1.33 2.93 2.95 2.92m-.02-4.57c.9 0 1.63.7 1.64 1.62 0 .92-.72 1.64-1.62 1.64s-1.64-.7-1.64-1.62.72-1.64 1.63-1.64Zm.04 7.19c-1.6 0-2.89 1.27-2.88 2.91 0 1.64 1.31 2.89 2.91 2.88 1.6 0 2.89-1.27 2.88-2.91 0-1.64-1.31-2.89-2.91-2.88m.02 4.51c-.89 0-1.61-.69-1.62-1.6 0-.91.71-1.61 1.6-1.62.89 0 1.61.69 1.62 1.6 0 .91-.71 1.61-1.6 1.62m7.31-7.2c1.6 0 2.9-1.27 2.89-2.92 0-1.64-1.32-2.9-2.92-2.89-1.6 0-2.9 1.28-2.89 2.92 0 1.64 1.32 2.9 2.92 2.89m-.02-4.52c.89 0 1.62.69 1.62 1.61 0 .91-.71 1.62-1.61 1.62-.89 0-1.62-.69-1.62-1.61 0-.91.71-1.62 1.61-1.62m2.03 18.91c-.06-.1-.15-.2-.26-.29s-.2-.16-.29-.22-.2-.11-.36-.17c-.15-.06-.27-.1-.36-.13-.08-.03-.21-.07-.38-.12-.39-.12-.66-.23-.79-.33a.4.4 0 0 1-.18-.34c0-.13.05-.24.16-.32.11-.09.27-.13.47-.13.45 0 .76.21.97.64l.04.09 1.05-.61-.04-.07c-.19-.39-.47-.71-.82-.93s-.76-.33-1.21-.33c-.51 0-.95.16-1.32.47s-.55.73-.55 1.25c0 .26.05.49.14.69s.23.36.42.49c.17.12.35.22.52.3.17.07.38.15.63.22q.645.18.9.33c.15.09.22.21.22.37 0 .14-.06.25-.18.34-.12.1-.33.15-.61.15-.58 0-.97-.25-1.17-.77l-.04-.1-1.07.63.03.07c.16.43.43.77.82 1.02.38.25.86.37 1.41.37.6 0 1.1-.16 1.48-.47s.58-.74.57-1.27c0-.16-.02-.32-.06-.46a1.5 1.5 0 0 0-.15-.36Zm1.07-3.31h-.76v.2h.28v.79l.01.04h.2v-.83h.28zm1.1 0h-.19l-.28.46-.28-.46h-.19v1.03h.21v-.62l.22.37h.09l.22-.37v.61h.21l-.01-.98z"/><path fill="#000f9f" d="M77.79 196.19c-13.54.06-24.47 10.76-24.4 24.64s11.1 24.47 24.64 24.4 24.47-10.76 24.4-24.64-11.1-24.47-24.64-24.4m.22 46.35c-12.05.06-21.87-9.37-21.93-21.72s9.67-21.87 21.72-21.93 21.87 9.37 21.93 21.72-9.67 21.87-21.72 21.93"/><path fill="#000f9f" d="M91.2 213.84h-3.53v-4.43h-1.3v5.7h4.83zm-19.29 18.3h2.3l2.18-.01v-1.25h-3.16v-.97h.01v-.01h2.58l-.01-1.25h-2.58v-.97h3.16v-1.37h-4.48z"/><path fill="#000f9f" d="M2.79 79.01c0 .33-.17 1.3-.32 2.11-.42 2.25-.79 4.21-.04 5.72l.23.54-.09.84h.92c.07.05.16.09.23.13h148.36c.29-.18.6-.33.84-.6l.59-.79.06-.33c.63-1.48.27-3.37-.13-5.54-.16-.83-.33-1.62-.32-2.09.05-2.76.4-4.67.65-6.07.15-.83.27-1.55.33-2.19v-.02c.23-3.19-2.01-5.14-4.64-5.45h-1.01c-4.06-.03-19.83-.1-39.37-.15v-2.13a3.99 3.99 0 0 0-3.98-3.98H50.42a3.99 3.99 0 0 0-3.98 3.98v2.12l-8.98.04c-5.44.02-30.93.11-31.33.15-2.32.28-4.54 2.23-4.31 5.42.04.62.17 1.32.33 2.21.26 1.39.6 3.31.65 6.07Zm106.29 1.69V70.66c19.27.05 34.86.12 39.15.14h.3c-.05.34-.12.72-.2 1.14v.02c-.29 1.58-.68 3.75-.74 6.94-.02.92.2 2.05.43 3.27.07.36.17.92.25 1.45l-40.35.05c.72-.74 1.16-1.78 1.16-2.97m-71.6-10.01 8.96-.04v10.24c0 1.12.46 2.13 1.21 2.86l-37.1.04h-.41c-.41 0-1.17-.03-2.06-.17h-.43c.08-.53.19-1.1.26-1.48.24-1.26.43-2.45.42-3.24-.06-3.19-.45-5.36-.75-7.01-.07-.39-.14-.75-.19-1.09 3.24-.02 14.83-.07 30.09-.12Zm113.56 23.17c.24-.36.42-.76.53-1.2.16-.07.29-1.74.44-1.84H3.65c.17.11.34 1.74.52 1.82.11.48.32.93.6 1.32-1.17 2.32-1.27 4.83-1.25 4.83-.54 3.11-1.27 25.78 12.19 186.7l.03.86c.14 4.57.41 10.17 1.28 12.94 2.12 6.79 10.79 13.78 59.06 14.1h3.73c48.26-.32 56.93-7.31 59.05-14.1.86-2.75 1.14-8.34 1.28-12.94l.02-.8c13.46-160.94 12.74-183.64 12.23-186.45-.02-.41-.17-2.97-1.35-5.25Zm-17.4 192.31c-.19 5.93-.52 9.7-.98 11.2-.65 2.09-3.76 3.99-8.98 5.49-8.91 2.56-23.69 3.93-43.92 4.06h-3.65c-20.23-.13-35.01-1.5-43.92-4.06-5.22-1.5-8.33-3.4-8.98-5.49-.33-1.05-.76-3.84-.98-11.21l-.49-6.44c7.47 2.47 24.32 6.38 55.25 5.87 34.37-.57 50.02-3.33 57.13-5.68l-.47 6.25Zm1.07-13.46c-2.2 1.23-13.18 5.66-57.84 6.4-34.99.64-51.35-4.77-55.73-6.53C8.09 114.67 9.76 100.57 9.78 100.3l.19-.9c.07-1.12.47-2.59.42-2.77l134.71-.13c.26.25.57 1.21.72 2.16l.2 1.61c.21 2.47.99 23.66-11.31 172.44m129.26-51.86v1.48l2.22-1.1v5.09h1.59v-5.12l2.25 1.09v-1.47l-3.05-1.43zm-6.42 5.46h1.6v-5.1l2.24 1.09v-1.47l-3.04-1.44-3.02 1.46v1.47l2.22-1.1zm-17.39 3.24h-1.53v6.82h5.66v-1.5h-4.13zm1.53-14.58c-1.17.01-1.93-.77-1.93-1.94s.75-1.94 1.9-1.94c.66-.01 1.23.28 1.54.8l1.28-.76c-.57-.94-1.63-1.52-2.83-1.52-1.96.03-3.39 1.51-3.38 3.44 0 1.93 1.43 3.4 3.43 3.39 1.19 0 2.23-.6 2.79-1.52l-1.29-.75c-.28.51-.85.81-1.51.81m.14 4.55h-3.2v6.91h3.42c1.21-.01 2.18-.8 2.17-1.98 0-.69-.33-1.21-.84-1.52.37-.32.58-.76.58-1.32-.01-1.16-.96-2.08-2.13-2.08m-1.68 1.63h1.68c.37-.01.58.23.6.58 0 .34-.24.6-.58.6h-1.65l-.04-1.18Zm1.89 3.83h-1.82v-1.28h1.8c.39 0 .63.25.65.63 0 .38-.25.64-.63.65m7.68-8.53a3.423 3.423 0 0 0 3.42-3.47c0-1.97-1.55-3.44-3.47-3.44a3.425 3.425 0 0 0-3.43 3.47c.01 1.96 1.56 3.44 3.48 3.44m-.04-5.37c1.07-.01 1.93.83 1.93 1.9s-.85 1.92-1.9 1.92c-1.05.01-1.93-.81-1.93-1.89s.85-1.93 1.9-1.93m.04 8.44c-1.88.01-3.39 1.49-3.38 3.4 0 1.93 1.52 3.41 3.42 3.4 1.88-.01 3.39-1.5 3.38-3.43-.01-1.92-1.54-3.39-3.42-3.38m.03 5.28c-1.04.01-1.89-.81-1.9-1.88 0-1.07.84-1.89 1.89-1.89 1.04-.01 1.89.8 1.89 1.87.01 1.08-.83 1.9-1.88 1.9m8.59-8.43a3.38 3.38 0 0 0 3.38-3.43c0-1.93-1.54-3.4-3.43-3.39-1.88.01-3.4 1.5-3.39 3.43s1.55 3.4 3.44 3.39m-.04-5.31c1.05 0 1.9.83 1.9 1.89s-.84 1.89-1.89 1.9c-1.04 0-1.89-.81-1.9-1.89 0-1.07.85-1.89 1.89-1.9m2.39 22.21c-.06-.11-.18-.23-.29-.34-.13-.1-.24-.19-.34-.25s-.23-.13-.42-.2c-.18-.08-.32-.11-.42-.15-.1-.03-.24-.09-.44-.14-.46-.15-.77-.27-.93-.39a.46.46 0 0 1-.22-.41c0-.15.05-.28.19-.38.13-.09.3-.15.53-.15.53 0 .9.24 1.14.76l.05.09 1.24-.72-.05-.08c-.23-.47-.56-.83-.96-1.09-.41-.27-.89-.39-1.43-.38-.58 0-1.1.18-1.52.53-.44.37-.65.85-.65 1.47 0 .3.05.58.17.8.11.24.28.43.48.58s.41.27.62.36c.19.09.44.18.72.25.51.14.88.28 1.05.38.18.11.25.27.25.44s-.06.29-.19.41c-.15.11-.38.18-.71.18-.69 0-1.14-.3-1.38-.91l-.04-.11-1.26.75.03.08c.19.51.51.91.96 1.21.44.29 1 .44 1.65.43.71 0 1.3-.19 1.74-.55.46-.38.69-.86.67-1.5 0-.19-.03-.37-.08-.52-.05-.18-.1-.3-.18-.43m1.29-3.91-.85.01h-.05v.23h.33v.98h.25l-.01-.98h.33zm1.28-.01-.22.01-.33.54-.34-.54h-.22l.02 1.16v.05h.24l-.02-.73.27.44h.1l.27-.44.01.73.23-.01-.01-1.15z"/><path fill="#000f9f" d="M254.05 194.12c-15.91.1-28.73 12.66-28.67 28.96.08 16.29 13.04 28.73 28.93 28.65 15.91-.09 28.74-12.64 28.65-28.95-.06-16.29-13.03-28.74-28.92-28.67m.25 54.44c-14.16.08-25.68-10.99-25.75-25.51-.08-14.5 11.35-25.68 25.51-25.76 14.16-.05 25.67 11.01 25.75 25.51.08 14.51-11.34 25.7-25.51 25.76"/><path fill="#000f9f" d="M269.78 214.85h-4.14v-5.21h-1.52v6.71h5.66zm-22.65 21.49h2.69l2.57-.02v-1.47h-3.7v-1.14l3.02.01v-1.48h-3.02v-1.13h3.7v-1.62h-5.26z"/><path fill="#000f9f" d="M172.14 67.51h164.07v-3.62l-.1-.46c.1-.44.16-.91.16-1.38 0-2.09-1.04-4.34-2.79-6.02-1.41-1.33-3.88-2.93-7.73-2.93-.96 0-1.26-.19-1.17-.57V25.39c0-5.59-5.85-8.09-11.65-8.09h-31.96v-3.14c0-5.03-4.38-9.1-9.78-9.1h-34.04c-5.4 0-9.78 4.08-9.78 9.1v3.14h-31.96c-5.8 0-11.67 2.5-11.67 8.09l.1 27.52s-.3.19-1.27.19c-3.88 0-6.35 1.61-7.72 2.93-1.51 1.43-2.49 3.29-2.73 5.12v.04c-.04.29-.06.57-.06.86s.03.55.05.81v4.65Zm17.98-8.98c1.92-2.16 2.16-4.71 2.07-6.02V26.24c.74-.27 2.09-.52 3.25-.52h31.96v3.3c0 5.01 4.38 9.1 9.78 9.1h34.04c5.4 0 9.78-4.09 9.78-9.1v-3.3h31.96c1.16 0 2.51.25 3.24.52l.03 25.81c-.09.88-.23 3.92 2.04 6.48l.22.24H189.9c.06-.08.14-.15.2-.23m146.1 13.7H172.12v36.93c-.1 1.19-.47 7.44 2.69 12.67.7 1.18 1.46 2.16 2.26 3.15 2.09 2.62 4.08 5.08 4.91 15.6.67 8.52 3.52 49.78 8.46 122.67l1.98 23.56c.09.93 1.04 9.24 8.1 13.22 15.1 8.49 35.63 13.36 56.31 13.36s40.12-4.99 51.48-13.7c5.78-4.44 7.3-11.26 7.58-12.86l1.51-16.52c.32-4.68 7.78-114.89 8.95-129.73.83-10.51 2.81-12.99 4.91-15.6.77-.98 1.54-1.96 2.25-3.12 3.26-5.43 2.81-12.09 2.69-12.32zM198.38 255.79c-1.61-23.75-4.89-71.97-6.77-98.65 3.53 1.46 6.77 7.01 6.77 25.6zm112.22-9.45v-63.61c0-17.48 2.86-23.4 6.09-25.25-1.64 23.56-4.37 63.52-6.09 88.86m15.71-128.83-.03.03c-.48.83-1.02 1.49-1.59 2.18-2.54 3.17-5.7 7.12-6.73 20.22l-.62 8.51c-15.16 2.26-15.16 24.5-15.16 34.28v111.04c-9.93 7.03-26.74 11.21-45.35 11.21s-36.39-4.05-50.04-11.16V182.73c0-9.81 0-32.15-15.79-34.3-.28-3.86-.5-6.81-.63-8.48-1.03-13.08-4.18-17.03-6.78-20.29-.55-.67-1.08-1.33-1.56-2.15-1.82-3.01-1.54-7.24-1.49-7.96V80.06h147.25l.03 29.9c.04.44.3 4.54-1.51 7.55"/></svg>');
$("ul.mobile-nav.vertical-mega-menu li:nth-child(5) a i.mm-icon" ).replaceWith('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 153.26 462.2"><path fill="#000f9f" d="M145.25 405.71V170.8c0-30.62-14.06-50.69-22.46-62.68-2.14-3.06-4.35-6.22-4.66-6.69l.15-29.15c.02-3.98-3.18-7.2-7.15-7.2H42.14c-3.96 0-7.17 3.24-7.14 7.23l.25 28.19c-.46 1.41-2.7 4.61-4.84 7.67-8.39 12-22.43 32.1-22.43 62.62L8 405.28c-.06 1.11-1.33 27.32 12.02 41.35 5.49 5.77 12.48 8.71 20.8 8.71h71.59c8.31 0 15.33-2.93 20.8-8.71 13.51-14.2 12.1-40.17 12.04-40.93m-19.8 33.54c-3.44 3.61-7.7 5.38-13.04 5.38h-71.6c-5.32 0-9.59-1.77-13.03-5.38-10.19-10.72-9.08-33.14-9.07-33.66V170.8c0-27.15 12.82-45.52 20.48-56.47 3.08-4.4 5.29-7.57 6.23-10.43l.39-1.64-.09-19.27c-.02-3.98 3.2-7.19 7.17-7.19h47.45c3.96 0 7.18 3.21 7.14 7.19l-.09 18.41.39 2.46c.94 2.89 3.15 6.04 6.2 10.4 7.7 10.94 20.53 29.28 20.53 56.53l.02 235.23c.02.22 1 22.61-9.09 33.22M117.7 48.38l.55-23.51c.07-2.64-1.33-5.1-3.63-6.39L95.68 7.77c-1.08-.6-2.28-.91-3.52-.91h-31.1c-1.22 0-2.44.31-3.51.91L38.61 18.48a7.18 7.18 0 0 0-3.64 6.39l.57 23.51c.1 3.87 3.26 6.98 7.15 6.98h67.86c3.87 0 7.06-3.11 7.15-6.98m-55.69-30.8h29.22l16.26 9.19-.43 17.87H46.17l-.42-17.87z"/><path d="M101.44 387.22H57.83V375.4H91.9v-17.62h9.54zm.58-52.41c0 3.96-.86 7.55-2.58 10.76s-4.24 5.75-7.57 7.62-7.4 2.81-12.22 2.81-8.96-.94-12.29-2.81-5.86-4.41-7.57-7.62-2.56-6.79-2.56-10.76.85-7.54 2.56-10.74 4.23-5.74 7.57-7.62 7.43-2.82 12.29-2.82 8.92.94 12.25 2.82 5.84 4.42 7.55 7.62 2.56 6.78 2.56 10.74Zm-10.3 0c0-1.97-.46-3.62-1.39-4.96q-1.395-2.01-4.08-3.03c-1.79-.68-3.99-1.02-6.58-1.02s-4.82.34-6.63 1.02c-1.8.68-3.17 1.69-4.1 3.03s-1.39 2.99-1.39 4.96.46 3.59 1.39 4.93 2.29 2.35 4.1 3.04 4.02 1.04 6.63 1.04 4.79-.35 6.58-1.04c1.8-.69 3.16-1.71 4.08-3.04.93-1.34 1.39-2.98 1.39-4.93m10.3-44.99c0 4.23-.9 7.96-2.71 11.17-1.8 3.21-4.38 5.71-7.71 7.51-3.34 1.79-7.3 2.69-11.88 2.69s-8.87-.96-12.22-2.88-5.89-4.49-7.64-7.71-2.62-6.79-2.62-10.71c0-2.58.37-4.97 1.1-7.19.73-2.21 1.77-4.18 3.12-5.9s2.93-3.1 4.76-4.14c1.82-1.04 3.83-1.68 6.01-1.92v11.94c-.74.18-1.4.46-1.99.86s-1.08.9-1.48 1.49-.7 1.28-.91 2.05-.31 1.62-.31 2.56c0 1.97.47 3.66 1.42 5.06q1.425 2.1 4.11 3.21c1.8.73 3.95 1.1 6.47 1.1s4.74-.35 6.56-1.05q2.715-1.05 4.17-3.12c.97-1.38 1.45-3.09 1.45-5.14 0-1.79-.26-3.29-.79-4.49s-1.27-2.1-2.24-2.69-2.1-.89-3.41-.89l.23-2.05v9.95h-8.43v-19.32h6.03q5.97 0 10.2 2.52c2.82 1.68 4.98 4 6.47 6.95s2.24 6.34 2.24 10.14m0-43.28c0 3.96-.86 7.55-2.58 10.76s-4.24 5.75-7.57 7.62-7.4 2.81-12.22 2.81-8.96-.94-12.29-2.81-5.86-4.41-7.57-7.62-2.56-6.79-2.56-10.76.85-7.54 2.56-10.74 4.23-5.74 7.57-7.62 7.43-2.82 12.29-2.82 8.92.94 12.25 2.82 5.84 4.42 7.55 7.62 2.56 6.78 2.56 10.74Zm-10.3 0c0-1.97-.46-3.62-1.39-4.96q-1.395-2.01-4.08-3.03c-1.79-.68-3.99-1.02-6.58-1.02s-4.82.34-6.63 1.02c-1.8.68-3.17 1.69-4.1 3.03s-1.39 2.99-1.39 4.96.46 3.59 1.39 4.93 2.29 2.35 4.1 3.04 4.02 1.04 6.63 1.04 4.79-.35 6.58-1.04c1.8-.69 3.16-1.71 4.08-3.04.93-1.34 1.39-2.98 1.39-4.93" fill="#000f9f"/></svg>');
});
runAfterElementExists('.header-item--navigation ul.site-navigation.horizontal-mega-menu', function() {
  //Desktop
  console.log('creadoPC');
$( ".header-item--navigation ul.site-navigation.horizontal-mega-menu li:nth-child(1) a i.mm-icon" ).replaceWith('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 358.78 386.28"><g fill="#000f9f"><path d="M303.74 337.98c-.65-38.36-2.79-164.13-2.79-172 0-3.38-1.17-6.19-3.5-8.31-4.29-3.89-11.05-3.59-12.25-3.55H175.88c-.6-.08-6.71-.04-10.65 3.8-2.15 2.1-3.24 4.81-3.24 8.05 0 7.59-3.45 121.83-4.93 170.58l-.1 3.2c-.23 2.14-1.92 21.21 9.25 33.72 6.06 6.82 14.64 10.26 25.48 10.26h77.33c10.85 0 19.42-3.44 25.48-10.26 11.25-12.58 9.5-31.46 9.28-33.44l-.03-2.07Zm-15.81 29.66c-4.33 4.85-10.7 7.3-18.91 7.3h-77.33c-8.21 0-14.57-2.45-18.9-7.3-8.42-9.41-7.23-25.38-7.06-27.32.05-1.63 5.05-164.83 5.05-174.34 0-1.03.3-1.46.59-1.74.97-.97 3.12-1.31 4.32-1.31h109.96c.23-.03.49-.04.78-.04 1.7 0 4.06.36 5.09 1.31.3.27.62.71.62 1.79 0 7.22 1.76 111.1 2.8 172.39l.06 2.31c.08.7 1.61 17.23-7.07 26.95"/><path d="M241.37 314.32v1.53l2.26-1.14v5.21h1.64v-5.22l2.3 1.11v-1.52l-3.12-1.46zm-6.57 5.6h1.63v-5.22l2.3 1.11v-1.51l-3.12-1.47-3.08 1.49v1.53l2.27-1.14zm-17.81 3.32h-1.56v6.98h5.8v-1.54h-4.24zm1.57-14.92c-1.19 0-1.96-.79-1.96-1.98-.01-1.2.76-2.01 1.94-2.01.68 0 1.26.3 1.56.82l1.33-.78c-.59-.95-1.67-1.54-2.89-1.54-2.03.01-3.48 1.54-3.47 3.52 0 1.98 1.48 3.49 3.51 3.47 1.23 0 2.3-.62 2.88-1.57l-1.33-.76c-.29.51-.87.83-1.55.83m.11 4.66h-3.26v7.06h3.5c1.23 0 2.22-.8 2.22-2.03 0-.69-.34-1.23-.85-1.55.37-.32.59-.78.59-1.35 0-1.19-.99-2.14-2.19-2.14m-1.71 1.66h1.72c.36-.01.6.24.6.6s-.24.61-.6.61h-1.69zm1.94 3.93h-1.86v-1.31h1.85c.39-.01.65.26.65.65 0 .38-.25.67-.65.67m7.84-8.73c1.95 0 3.52-1.55 3.52-3.55-.01-2-1.6-3.52-3.55-3.51s-3.53 1.55-3.52 3.55c0 2 1.6 3.53 3.55 3.52m-.03-5.49c1.08 0 1.96.84 1.97 1.95 0 1.11-.87 1.97-1.95 1.97s-1.97-.84-1.97-1.95.87-1.96 1.95-1.97m.05 8.63c-1.92 0-3.47 1.52-3.47 3.5.01 1.97 1.58 3.47 3.5 3.46 1.92 0 3.47-1.52 3.47-3.49 0-1.98-1.58-3.47-3.5-3.47m.03 5.42c-1.07 0-1.94-.83-1.94-1.92 0-1.1.86-1.94 1.92-1.94 1.07 0 1.94.82 1.94 1.92 0 1.09-.85 1.94-1.92 1.94m8.78-8.65a3.464 3.464 0 0 0 3.47-3.52c0-1.98-1.58-3.48-3.51-3.47-1.93 0-3.49 1.53-3.47 3.51 0 1.98 1.58 3.49 3.51 3.48m-.03-5.44c1.07 0 1.94.83 1.95 1.93 0 1.1-.86 1.95-1.93 1.95s-1.94-.83-1.95-1.93c0-1.1.86-1.94 1.93-1.95m2.45 22.73a1.4 1.4 0 0 0-.31-.35c-.13-.11-.25-.2-.34-.26-.1-.07-.25-.13-.43-.21s-.32-.12-.43-.16-.25-.09-.45-.15c-.47-.14-.8-.27-.96-.39-.14-.1-.21-.24-.21-.41s.05-.29.19-.39c.13-.11.32-.16.56-.17.54 0 .91.25 1.16.78l.05.1 1.27-.74-.05-.08c-.23-.47-.56-.85-.98-1.12s-.91-.4-1.46-.4c-.61 0-1.15.19-1.58.56-.45.37-.67.88-.67 1.5 0 .32.06.6.17.83.12.24.28.44.5.59q.315.225.63.36c.21.08.45.17.76.26.51.14.88.27 1.08.4.18.11.26.25.26.45 0 .17-.07.3-.21.41-.14.12-.39.18-.73.18-.71 0-1.17-.3-1.41-.93l-.05-.11-1.28.76.03.08c.19.51.52.93.98 1.23s1.03.45 1.7.45c.73 0 1.33-.2 1.78-.57.46-.37.69-.89.69-1.52 0-.19-.03-.38-.08-.55-.05-.16-.11-.31-.18-.43m1.29-3.98h-.86l-.06.01v.24h.34l.01.94v.05h.24v-1h.33zm1.32 0h-.23l-.33.55-.34-.54h-.23v1.22h.25v-.73l.26.45h.11l.27-.45v.73h.25l-.01-1.18z"/><path d="M231.2 286.98c-16.27.08-29.41 12.93-29.33 29.62.08 16.68 13.34 29.42 29.62 29.34s29.42-12.93 29.34-29.62c-.08-16.68-13.34-29.42-29.62-29.34m.27 55.71c-14.49.07-26.29-11.27-26.36-26.11-.08-14.84 11.62-26.29 26.11-26.36s26.29 11.26 26.36 26.11-11.62 26.29-26.11 26.36"/><path d="M247.32 308.19h-4.25v-5.31h-1.56v6.84h5.81zm-23.19 22h2.76l2.63-.02v-1.5h-3.8v-1.17h3.11l-.02-1.5h-3.09v-1.17h3.8v-1.65h-5.39zM349.2 73.74c-1.01-1.89-2.57-3.34-4.39-4.04-1.63-.65-2.27-1.26-2.38-1.46l-.3-.54c-1.22-2.24-3.76-6.88-11.75-3.47-5.21 2.23-34.25 15.18-43.03 19.09-.72.29-1.55 0-1.91-.67l-7.62-14.7c-1.11-2.16-3.23-3.57-5.66-3.78l-100.35-8.3c-1.11-.16-2.23.12-3.25.67-1.82 1.02-3 2.37-3.43 3.93-.23.93-.32 2.37.67 3.99 1.07 1.76 4.4 4.05 9.84 7.7 2.6 1.76 6.17 4.15 7.81 5.59.12.1.15.25.08.41-.94 2.25-3.12 6.55-4.68 9.42-1.8 3.32-3.81 4.65-5.57 5.8-4.81 3.16-5.84 3.99-5.72 5.71.23 3.27-1.11 5.18-2.53 7.19-1.31 1.87-2.66 3.8-2.66 6.73v.98l.05 5.25c.02 1.11.35 2.19.95 3.11.4.61.41 1.38.41 2.37l.02 1.64c.03 2.86.07 6.77-.02 11.47v6.52c0 2.98 2.14 4.85 5.7 5 .88.03 116.63-.04 123.73 0 1.42 0 4.01-.94 4.38-4.37h.05v-5.34c-.01-7.92-.02-19.84-.03-24.7 0-.97.53-1.83 1.41-2.25l49.6-24.76c.25-.12.5-.27.73-.43 1.59-1.11 3.47-2.91 3.47-5.17 0-.67 0-1.81-3.6-8.59m-179.46 52.45h78.62c8.93 0 23.32-4.13 42.74-12.28l.44-.19v27.26c.03 1.28-.31 1.8-1.13 1.89-17.88 0-109.94-.04-118.95-.11-.32 0-.56-.09-.77-.3-.96-.96-.94-4.02-.93-5.32 0-1.61-.01-3.31-.03-4.82-.01-1.13-.03-2.17-.02-2.95 0-1.2.01-2.27.01-3.19m121.92-15.99-.16.07c-19.94 8.48-34.46 12.78-43.14 12.78H169.7l-.02-.73c-.01-.25-.12-.58-.51-1.62-.52-1.38-1.48-3.95-1.43-5.05.03-.51.45-.91.97-.91h84.73c17.62 0 79.91-33.6 90.17-39.2a653 653 0 0 1 2.64 4.96c.2.38.24.82.11 1.23-.12.41-.41.75-.79.95-9.92 5.18-51.2 26.18-53.91 27.54M209.85 65.3c-.16-.03-4.01-.47-8.43.49-5.94 1.27-11.82 5.83-12.35 10.15.23-1.86-4.04-3.7-10.44-8.42-2.89-2.13-7.11-5.91-7.31-6.11m12.43 28.76c2.66-5.11 4.59-8.89 5.33-11.03.01-.03.04-.13.26-.21 1.35-.53 2.46-1.67 3.08-2.6l.14-.31c1.2-3.91 4.37-6.43 9.41-7.52 2.04-.43 4-.54 5.42-.54 1.3 0 2.16.09 2.22.1.32.02 33.54 2.21 51.24 3.21 4.85.28 7.59-.72 9.1-1.69l1.72.14c.51.03.95.34 1.19.78l8.19 15.8c1.4 2.7 4.63 3.82 7.4 2.59 7.44-3.32 38.69-17.25 44.07-19.55 3.38-1.46 3.7-.82 4.7 1 .12.25.26.48.38.7.5.84 1.25 1.62 2.24 2.28.15.11.16.25.16.33s-.03.26-.22.36c-11.65 6.28-70.54 37.58-86.35 37.58h-83.27c-.27 0-.39-.19-.43-.27-.04-.1-.09-.29.06-.46 2.74-3.21 3.82-6.55 3.21-9.91-.08-.41.36-.93.79-1.22 1.06-.77 3.86-2.69 5.75-3.99l.29-.21a8.3 8.3 0 0 0 2.73-3.09l1.17-2.28Z"/></g><g fill="#000f9f"><path d="M137.4 345.39V168c0-23.13-13.46-38.28-21.5-47.33-2.05-2.31-4.16-4.69-4.46-5.05l.15-22.01c.01-3-3.04-5.44-6.84-5.44H38.71c-3.79 0-6.87 2.45-6.84 5.46l.24 21.29c-.44 1.07-2.58 3.48-4.63 5.8-8.03 9.06-21.46 24.24-21.46 47.29v177.07c-.04.83-1.25 20.63 11.52 31.22 5.25 4.36 11.94 6.57 19.91 6.57h68.52c7.96 0 14.67-2.21 19.91-6.57 12.93-10.72 11.58-30.33 11.52-30.91m-18.95 25.33c-3.29 2.73-7.37 4.06-12.48 4.06H37.44c-5.1 0-9.18-1.33-12.47-4.06-9.75-8.1-8.69-25.03-8.68-25.42V168c0-20.5 12.27-34.37 19.6-42.65 2.95-3.33 5.07-5.72 5.96-7.88l.37-1.23-.08-14.55c-.01-3 3.06-5.43 6.86-5.43h45.42c3.79 0 6.87 2.43 6.84 5.43l-.09 13.9.37 1.86c.9 2.18 3.02 4.56 5.94 7.85 7.37 8.26 19.64 22.11 19.64 42.69v177.63c.03.17.97 17.08-8.68 25.08"/><path d="M81.31 298.11v1.46l2.16-1.08v4.98h1.57v-4.99l2.2 1.06v-1.45l-2.98-1.4zm-6.28 5.36h1.56v-5l2.19 1.08v-1.45l-2.98-1.4-2.94 1.42v1.45l2.17-1.09zm-17.04 3.17H56.5v6.67h5.56v-1.46h-4.07zm1.51-14.27c-1.14 0-1.88-.75-1.88-1.9-.01-1.15.72-1.91 1.86-1.91.66-.01 1.21.29 1.49.78l1.27-.75c-.56-.9-1.6-1.47-2.76-1.47-1.94.01-3.34 1.47-3.33 3.36s1.42 3.34 3.36 3.33c1.17-.01 2.2-.59 2.75-1.5l-1.28-.72c-.27.5-.83.79-1.48.79m.12 4.45H56.5v6.76h3.35c1.17 0 2.12-.78 2.12-1.94-.01-.68-.33-1.19-.82-1.5.35-.3.57-.73.57-1.28-.01-1.15-.95-2.05-2.1-2.05M58 298.41h1.64c.35-.01.57.23.58.57 0 .35-.24.59-.58.59h-1.6l-.03-1.16Zm1.84 3.76h-1.77v-1.26h1.76c.39-.01.63.24.63.61s-.24.64-.62.64m7.5-8.33a3.35 3.35 0 0 0 3.36-3.4 3.35 3.35 0 0 0-3.39-3.36c-1.86.01-3.38 1.48-3.36 3.4a3.357 3.357 0 0 0 3.4 3.36m-.02-5.25c1.03 0 1.88.8 1.88 1.86.01 1.07-.82 1.88-1.86 1.88-1.04.01-1.88-.79-1.89-1.87 0-1.06.83-1.87 1.87-1.87m.03 8.25c-1.85.01-3.33 1.47-3.31 3.35.01 1.88 1.5 3.33 3.35 3.31 1.84-.01 3.31-1.46 3.31-3.35a3.297 3.297 0 0 0-3.35-3.31m.02 5.18c-1.02 0-1.86-.8-1.86-1.85-.01-1.05.82-1.85 1.83-1.86 1.02 0 1.86.8 1.87 1.85 0 1.05-.82 1.86-1.85 1.86m8.42-8.26a3.323 3.323 0 0 0 3.33-3.36 3.306 3.306 0 0 0-3.36-3.31 3.28 3.28 0 0 0-3.31 3.35c0 1.89 1.5 3.34 3.35 3.33m-.02-5.2c1.02 0 1.85.79 1.86 1.85 0 1.05-.82 1.85-1.84 1.87-1.03 0-1.87-.8-1.87-1.85-.01-1.07.82-1.87 1.85-1.87m2.32 21.73c-.07-.12-.17-.23-.3-.35-.12-.1-.24-.18-.33-.24-.11-.07-.23-.13-.41-.2-.17-.07-.31-.11-.41-.14-.09-.03-.24-.08-.43-.14-.46-.13-.77-.26-.91-.37a.48.48 0 0 1-.04-.78c.12-.1.31-.14.55-.16.5 0 .87.23 1.11.73l.04.1 1.21-.7-.03-.08c-.23-.46-.55-.82-.95-1.07-.4-.26-.87-.39-1.39-.38-.6 0-1.1.18-1.52.53-.42.36-.63.83-.63 1.44.01.3.06.56.17.79q.18.33.48.57c.19.14.4.26.61.33.19.09.43.18.72.26.5.13.85.27 1.03.39.16.1.25.23.25.42 0 .16-.07.29-.2.4-.14.11-.38.17-.69.17-.67 0-1.12-.29-1.36-.89l-.03-.11-1.23.72.03.09q.27.735.93 1.17c.45.29.98.43 1.62.42.69 0 1.26-.19 1.71-.53.43-.37.66-.86.66-1.46 0-.2-.04-.37-.08-.52-.04-.17-.1-.3-.17-.41m1.23-3.8h-.88v.23h.32v.95h.24v-.96h.32zm1.26-.01h-.22l-.32.53-.33-.53h-.22v1.14l.01.05h.23v-.71l.25.42h.11l.26-.42v.71h.24l-.01-1.15z"/><path d="M71.58 271.96c-15.56.08-28.12 12.38-28.05 28.33.08 15.96 12.77 28.13 28.33 28.05 15.57-.07 28.14-12.37 28.06-28.33-.08-15.94-12.76-28.12-28.33-28.05m.26 53.28c-13.85.08-25.14-10.76-25.21-24.96s11.11-25.14 24.97-25.21c13.85-.07 25.14 10.76 25.21 24.96.07 14.19-11.12 25.14-24.97 25.21"/><path d="M87 292.25h-4.07v-5.08h-1.48v6.54H87zm-22.18 21.03h2.65l2.5-.01v-1.43h-3.62v-1.12h2.97l-.01-1.44h-2.96v-1.12h3.62v-1.57h-5.15zm53.43-271.57c0-2.22-.81-4.18-2.31-5.54-1.41-1.27-3.33-1.94-5.4-1.88-1.33.07-6.04-.05-11.55-.15l5.9-5.9c2.59-2.59 2.59-6.81 0-9.41l-3.92-3.91a6.6 6.6 0 0 0-4.7-1.95c-1.78 0-3.45.69-4.71 1.94L72.79 33.68c-1.71-.03-3.37-.06-4.68-.08-3.22-5.22-6.5-10.4-9.8-15.59l-.45-.7c-2.24-3.54-4.48-7.08-6.7-10.63-1.35-2.17-3.1-3.5-5.22-3.95-3.13-.7-5.55.85-6.35 1.35-2.22 1.37-4.24 2.44-6.17 3.29-2.65 1.16-4.35 2.84-5.06 4.99-.74 2.24-.29 4.64 1.34 7.13 4.24 6.47 7.61 11.83 10.41 16.44.32 1.41.43 14.41.49 33.5l.02 4.48c.02 1.17 1.01 5.38 1.6 7.77.26 1.05 1.2 1.79 2.28 1.79h53.95c1.22 0 2.28-1.49 2.38-2.7l.19-2.28c.16-7.06.3-13.24.23-20.12 2.33-.15 4.66-.31 6.98-.54 8.26-.8 10.02-6.1 10.04-10.43l-.02-5.67ZM95.22 19.83c.55-.56 1.53-.55 2.08 0l2.66 2.66c.28.27.42.64.42 1.04s-.15.76-.42 1.04l-9.41 9.41c-3.12-.05-6.27-.11-9.32-.16zm12.27 30.3c-2.78.27-5.59.45-8.36.62-4.97.29-5.65 3.77-5.62 5.82.1 6.47 0 12.41-.15 19.02H48.69c-.18-.82.27-39.86-.76-41.53-2.99-5.05-7.44-12.17-11.79-18.81-.14-.23-.24-.4-.31-.5.14-.09.36-.21.69-.35 2.31-1.01 4.63-2.25 7.11-3.78.41-.25.61-.34.61-.39.06.06.18.19.37.5 2.23 3.57 4.48 7.13 6.73 10.67l.46.73c3.27 5.15 6.54 10.3 9.74 15.5 1.67 2.7 3.77 3.85 7.08 3.85 6.12-.1 18.87.15 28.17.31l3.13.05c5.35.09 9.5.17 10.64-.15v5.67c0 1.91-.13 2.47-3.05 2.75Z"/><path d="M73.13 52.68c-4.01 0-7.28 3.27-7.28 7.28s3.27 7.28 7.28 7.28 7.28-3.27 7.28-7.28-3.27-7.28-7.28-7.28m0 9.69c-1.46 0-2.64-1.08-2.64-2.41s1.18-2.41 2.64-2.41 2.64 1.08 2.64 2.41-1.18 2.41-2.64 2.41"/></g></svg>');
$( ".header-item--navigation ul.site-navigation.horizontal-mega-menu li:nth-child(2) a i.mm-icon" ).replaceWith( '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384.31 456.97"><g fill="#000f9f"><path d="M111.25 414.05V231c0-23.86-10.96-39.5-17.5-48.84-1.67-2.39-3.39-4.84-3.63-5.21l.12-22.72c.01-3.1-2.48-5.61-5.57-5.61H30.9c-3.09 0-5.59 2.53-5.57 5.64l.2 21.97c-.36 1.1-2.1 3.59-3.77 5.98-6.54 9.35-17.48 25.01-17.48 48.79v182.72c-.03.86-1.02 21.29 9.38 32.22 4.28 4.5 9.72 6.78 16.21 6.78h55.8c6.48 0 11.94-2.28 16.21-6.78 10.53-11.06 9.43-31.3 9.38-31.9m-15.43 26.14c-2.68 2.81-6 4.19-10.16 4.19h-55.8c-4.15 0-7.47-1.38-10.15-4.19-7.94-8.36-7.08-25.83-7.06-26.23V231c0-21.15 9.99-35.47 15.96-44.01 2.4-3.43 4.13-5.9 4.86-8.13l.3-1.27-.07-15.01c-.01-3.1 2.49-5.6 5.58-5.6h36.98c3.09 0 5.59 2.5 5.57 5.6l-.07 14.35.3 1.92c.73 2.25 2.46 4.71 4.83 8.1 6 8.53 15.99 22.82 15.99 44.05v183.29c.03.17.79 17.62-7.07 25.88m-6.04-304.56.43-18.32a5.55 5.55 0 0 0-2.83-4.98l-14.76-8.35c-.84-.47-1.78-.71-2.74-.71H45.64c-.95 0-1.9.24-2.74.71l-14.76 8.35a5.59 5.59 0 0 0-2.83 4.98l.45 18.32a5.57 5.57 0 0 0 5.57 5.44h52.88c3.02 0 5.5-2.42 5.57-5.44m-43.4-24h22.77l12.67 7.16-.34 13.92H34.04l-.33-13.92z"/><path d="M68.21 361.99v1.49l2.21-1.1v5.07h1.59v-5.09l2.25 1.08v-1.47l-3.04-1.43zm-6.4 5.46h1.59v-5.1l2.24 1.1v-1.47l-3.04-1.43-2.99 1.45v1.48l2.2-1.12zm-17.35 3.23h-1.52v6.79h5.66v-1.48h-4.14zm1.53-14.54c-1.16 0-1.92-.76-1.92-1.94-.01-1.17.73-1.95 1.89-1.95.67-.01 1.23.29 1.52.79l1.29-.76c-.57-.92-1.63-1.5-2.81-1.5-1.97.01-3.4 1.5-3.39 3.42.01 1.93 1.45 3.4 3.42 3.39 1.2-.01 2.24-.6 2.8-1.53l-1.3-.74c-.28.51-.84.81-1.51.81m.14 4.56h-3.18v6.89h3.41c1.2 0 2.16-.79 2.16-1.97-.01-.69-.34-1.21-.83-1.53.36-.31.58-.75.58-1.3-.01-1.17-.96-2.09-2.14-2.09m-1.66 1.62h1.67c.35-.01.58.24.59.58 0 .35-.24.6-.59.6H44.5l-.03-1.18Zm1.88 3.83h-1.81v-1.28h1.8c.4-.01.64.25.64.62s-.24.66-.63.66m7.64-8.51c1.9-.01 3.43-1.52 3.42-3.47s-1.56-3.43-3.46-3.42a3.425 3.425 0 0 0-3.43 3.47c.01 1.95 1.57 3.43 3.46 3.42m-.02-5.35c1.05 0 1.92.82 1.92 1.89.01 1.09-.84 1.92-1.89 1.92-1.06.01-1.92-.81-1.93-1.9 0-1.08.84-1.9 1.9-1.9m.05 8.4a3.37 3.37 0 0 0-3.38 3.41 3.363 3.363 0 0 0 3.41 3.38 3.37 3.37 0 0 0 3.38-3.41 3.37 3.37 0 0 0-3.41-3.38m.02 5.28c-1.04 0-1.89-.82-1.89-1.88-.01-1.07.84-1.88 1.87-1.89 1.04 0 1.89.82 1.9 1.88 0 1.07-.84 1.89-1.88 1.89m8.57-8.42a3.38 3.38 0 0 0 3.39-3.42 3.38 3.38 0 0 0-3.42-3.38c-1.88 0-3.39 1.48-3.38 3.41 0 1.93 1.53 3.4 3.41 3.39m-.02-5.29c1.04 0 1.89.8 1.9 1.88 0 1.07-.83 1.88-1.88 1.9-1.05 0-1.9-.82-1.9-1.88-.01-1.09.83-1.9 1.88-1.9m2.38 22.14c-.07-.12-.17-.24-.3-.35-.12-.1-.24-.18-.33-.25a1.7 1.7 0 0 0-.42-.2c-.18-.07-.31-.11-.42-.15-.09-.03-.24-.08-.44-.15-.46-.14-.78-.26-.93-.37a.52.52 0 0 1-.22-.41c0-.17.07-.28.19-.39.13-.1.31-.15.56-.16.51 0 .88.24 1.13.75l.05.1 1.23-.71-.03-.08c-.23-.46-.56-.84-.96-1.09-.41-.26-.88-.4-1.42-.39-.61 0-1.12.18-1.55.54-.42.36-.65.85-.65 1.46.01.31.06.57.17.8.12.23.28.42.49.58.2.15.41.26.62.34.2.09.44.18.73.26.51.14.86.27 1.05.4.16.1.26.24.26.43 0 .16-.07.29-.2.41-.14.11-.39.17-.71.17-.69 0-1.14-.29-1.38-.91l-.03-.11-1.25.74.03.09c.19.5.5.89.95 1.19.45.29 1 .44 1.65.43.7 0 1.29-.19 1.74-.54.44-.37.67-.87.67-1.49 0-.2-.04-.37-.08-.53-.05-.17-.1-.31-.18-.42m1.23-3.86h-.89v.23h.33v.97h.24v-.98h.32zm1.29-.02h-.22l-.32.55-.35-.55h-.22v1.17l.02.05h.23V371l.25.43h.11l.27-.43v.73h.24l-.01-1.17z"/><path d="M58.3 335.34c-15.85.08-28.65 12.62-28.59 28.87.08 16.26 13.01 28.67 28.86 28.59 15.87-.07 28.67-12.61 28.59-28.87-.08-16.24-13-28.65-28.87-28.59m.27 54.29c-14.11.08-25.62-10.96-25.68-25.44-.07-14.47 11.32-25.62 25.44-25.68 14.12-.07 25.62 10.96 25.69 25.44.07 14.46-11.33 25.62-25.45 25.68"/><path d="M74.02 356.02h-4.15v-5.18h-1.51v6.66h5.66zm-22.6 21.43h2.69l2.55-.01v-1.46h-3.69v-1.15H56l-.02-1.46h-3.01v-1.14h3.69v-1.6h-5.24z"/></g><g fill="#000f9f"><path d="M239.06 408.14V197.17c0-27.51-12.63-45.52-20.17-56.29-1.93-2.75-3.9-5.58-4.19-6.01l.14-26.18c.01-3.57-2.86-6.47-6.42-6.47h-61.97c-3.56 0-6.44 2.91-6.42 6.5l.22 25.32c-.42 1.27-2.42 4.14-4.35 6.89-7.54 10.78-20.14 28.83-20.14 56.24v210.6c-.04.99-1.18 24.54 10.81 37.14 4.93 5.19 11.2 7.82 18.68 7.82h64.31c7.47 0 13.77-2.63 18.68-7.82 12.14-12.75 10.87-36.08 10.81-36.76m-17.79 30.12c-3.09 3.24-6.91 4.83-11.71 4.83h-64.31c-4.78 0-8.61-1.59-11.7-4.83-9.15-9.63-8.16-29.77-8.14-30.23V197.17c0-24.38 11.52-40.88 18.4-50.72 2.77-3.96 4.76-6.8 5.6-9.37l.35-1.47-.08-17.31a6.434 6.434 0 0 1 6.44-6.46h42.62c3.56 0 6.45 2.88 6.42 6.46l-.08 16.54.35 2.21c.84 2.59 2.83 5.42 5.57 9.34 6.91 9.83 18.44 26.3 18.44 50.78v211.27c.03.2.91 20.31-8.15 29.83m-6.96-351.06.5-21.11a6.39 6.39 0 0 0-3.26-5.74l-17.01-9.62c-.97-.54-2.05-.82-3.16-.82h-27.93c-1.09 0-2.19.28-3.16.82l-17.01 9.62a6.44 6.44 0 0 0-3.27 5.74l.52 21.11c.09 3.48 2.93 6.27 6.42 6.27h60.95c3.48 0 6.34-2.79 6.42-6.27m-50.02-27.66h26.24l14.61 8.26-.39 16.05h-54.68l-.38-16.05z"/><path d="M189.46 348.14v1.72l2.54-1.27v5.85h1.84v-5.86l2.59 1.24v-1.7l-3.5-1.65zm-7.38 6.3h1.83v-5.88l2.58 1.27v-1.7l-3.5-1.65-3.45 1.68v1.7l2.54-1.28zm-20 3.72h-1.75v7.83h6.52v-1.71h-4.77zm1.76-16.76c-1.34 0-2.21-.88-2.21-2.23-.01-1.35.84-2.25 2.18-2.25.78-.01 1.42.34 1.75.92l1.49-.88c-.66-1.06-1.87-1.72-3.24-1.72-2.27.01-3.92 1.72-3.91 3.95.01 2.22 1.67 3.92 3.95 3.91 1.38-.01 2.58-.69 3.23-1.76l-1.5-.85c-.32.59-.97.93-1.74.93m.15 5.22h-3.66v7.94h3.93c1.38 0 2.49-.91 2.49-2.27-.01-.8-.39-1.4-.96-1.76.41-.35.67-.86.67-1.5-.01-1.35-1.11-2.4-2.46-2.4m-1.91 1.87h1.92c.41-.01.67.27.68.67 0 .41-.28.69-.68.69h-1.88zm2.16 4.42h-2.08v-1.48h2.07c.46-.01.74.29.74.72s-.28.76-.73.76m8.81-9.83c2.2-.01 3.96-1.75 3.95-4s-1.8-3.96-3.99-3.95c-2.18.01-3.97 1.74-3.95 4 .01 2.25 1.81 3.96 3.99 3.95m-.03-6.17c1.21 0 2.21.94 2.21 2.18.01 1.25-.97 2.21-2.18 2.21-1.22.01-2.21-.93-2.22-2.2 0-1.24.97-2.19 2.2-2.19m.04 9.7c-2.17.01-3.91 1.72-3.89 3.93.01 2.21 1.76 3.91 3.93 3.89 2.16-.01 3.89-1.71 3.89-3.93a3.877 3.877 0 0 0-3.93-3.89m.03 6.09c-1.2 0-2.18-.94-2.18-2.17-.01-1.23.97-2.17 2.16-2.18 1.2 0 2.18.94 2.2 2.17 0 1.23-.97 2.18-2.17 2.18m9.85-9.71a3.9 3.9 0 0 0 3.91-3.95c-.01-2.21-1.78-3.91-3.95-3.89-2.17 0-3.91 1.71-3.89 3.93 0 2.22 1.76 3.92 3.93 3.91m-.03-6.1c1.2 0 2.18.93 2.19 2.17 0 1.23-.96 2.17-2.16 2.2-1.21 0-2.19-.94-2.19-2.17a2.15 2.15 0 0 1 2.17-2.2m2.74 25.53c-.08-.14-.2-.27-.35-.41-.14-.12-.28-.21-.39-.29-.12-.08-.27-.16-.48-.23-.2-.08-.36-.13-.48-.17-.1-.04-.28-.09-.5-.17-.54-.16-.9-.3-1.07-.43a.58.58 0 0 1-.25-.47c0-.2.08-.33.22-.44.14-.12.36-.17.64-.18.59 0 1.02.27 1.3.86l.05.12 1.42-.82-.04-.09c-.27-.54-.65-.97-1.11-1.25-.47-.3-1.02-.46-1.63-.44-.7 0-1.29.21-1.78.63s-.75.98-.75 1.69c.01.35.07.65.2.93.14.26.33.48.56.67.23.17.47.3.71.39q.345.165.84.3c.59.16.99.31 1.21.46.19.12.29.27.29.5 0 .18-.08.34-.24.47s-.44.2-.82.2c-.79 0-1.31-.34-1.59-1.04l-.04-.13-1.44.85.04.1c.22.58.58 1.03 1.1 1.37s1.15.51 1.9.5c.81 0 1.48-.22 2.01-.63.51-.43.78-1.01.78-1.71 0-.23-.05-.43-.1-.61-.05-.2-.12-.35-.2-.48m1.44-4.52h-1.03v.28h.38v1.11h.28v-1.13h.37zm1.48-.01h-.25l-.37.63-.4-.63h-.25v1.34l.01.06h.27v-.84l.29.5h.13l.31-.5v.84h.28l-.02-1.35z"/><path d="M178.03 317.43c-18.27.09-33.03 14.54-32.95 33.28.09 18.75 15 33.04 33.27 32.95 18.29-.08 33.05-14.53 32.96-33.28-.1-18.72-14.98-33.03-33.28-32.95m.31 62.58c-16.27.09-29.53-12.63-29.6-29.32-.08-16.68 13.04-29.53 29.32-29.6 16.27-.08 29.53 12.63 29.61 29.32.08 16.67-13.06 29.53-29.33 29.6"/><path d="M196.15 341.26h-4.78v-5.97h-1.74v7.68h6.52zm-26.05 24.7h3.1l2.94-.01v-1.69h-4.25v-1.31h3.49l-.02-1.69h-3.47v-1.32h4.25v-1.84h-6.04z"/></g><g fill="#000f9f"><path d="M379.35 403.09V168.18c0-30.62-14.06-50.69-22.46-62.68-2.14-3.06-4.35-6.22-4.66-6.69l.15-29.15c.02-3.98-3.18-7.2-7.15-7.2h-69c-3.96 0-7.17 3.24-7.14 7.23l.25 28.19c-.46 1.41-2.7 4.61-4.84 7.67-8.39 12-22.43 32.1-22.43 62.62l.02 234.49c-.06 1.11-1.33 27.32 12.02 41.35 5.49 5.77 12.48 8.71 20.8 8.71h71.6c8.31 0 15.33-2.93 20.8-8.71 13.51-14.2 12.1-40.17 12.04-40.93m-19.8 33.54c-3.44 3.61-7.7 5.38-13.04 5.38h-71.6c-5.32 0-9.59-1.77-13.03-5.38-10.19-10.72-9.08-33.14-9.07-33.66V168.18c0-27.15 12.82-45.52 20.48-56.47 3.08-4.4 5.29-7.57 6.23-10.43l.39-1.64-.09-19.27c-.02-3.98 3.2-7.19 7.17-7.19h47.45c3.96 0 7.18 3.21 7.14 7.19l-.09 18.41.39 2.46c.94 2.89 3.15 6.04 6.2 10.4 7.7 10.94 20.53 29.28 20.53 56.53l.02 235.23c.02.22 1 22.61-9.09 33.22m-7.75-390.86.55-23.51c.07-2.64-1.33-5.1-3.63-6.39L329.77 5.15c-1.08-.6-2.28-.91-3.52-.91h-31.1c-1.22 0-2.44.31-3.51.91L272.7 15.86a7.18 7.18 0 0 0-3.64 6.39l.57 23.51c.1 3.87 3.26 6.98 7.15 6.98h67.86c3.87 0 7.06-3.11 7.15-6.98m-55.69-30.8h29.22l16.26 9.19-.43 17.87h-60.88l-.42-17.87 16.26-9.19Z"/><path d="M324.11 336.28v1.91l2.83-1.41v6.51h2.05v-6.53l2.89 1.39v-1.9l-3.9-1.83zm-8.21 7.01h2.04v-6.54l2.87 1.41v-1.89l-3.9-1.83-3.84 1.86v1.89l2.83-1.43zm-22.27 4.15h-1.95v8.71h7.26v-1.9h-5.31zm1.96-18.66c-1.49 0-2.46-.98-2.46-2.49-.01-1.5.94-2.5 2.43-2.5.87-.01 1.58.38 1.95 1.02l1.66-.98c-.73-1.18-2.09-1.92-3.61-1.92-2.53.01-4.36 1.92-4.35 4.39s1.86 4.36 4.39 4.35c1.54-.01 2.87-.77 3.59-1.96l-1.67-.95c-.36.66-1.08 1.03-1.93 1.03m.17 5.84h-4.08v8.84h4.38c1.53 0 2.77-1.02 2.77-2.53-.01-.89-.43-1.56-1.07-1.96.46-.39.74-.96.74-1.67-.01-1.5-1.24-2.68-2.74-2.68m-2.12 2.08h2.14c.45-.01.75.31.76.74 0 .45-.31.77-.76.77h-2.09l-.04-1.51Zm2.41 4.92h-2.32v-1.64h2.31c.51-.01.82.32.82.8s-.31.84-.81.84m9.8-10.93a4.38 4.38 0 0 0 4.39-4.45c-.01-2.5-2-4.41-4.44-4.39a4.386 4.386 0 0 0-4.4 4.45c.01 2.5 2.01 4.41 4.44 4.39m-.03-6.87c1.35 0 2.46 1.05 2.46 2.43.01 1.4-1.08 2.46-2.43 2.46-1.36.01-2.46-1.03-2.47-2.44 0-1.38 1.08-2.44 2.44-2.44m.06 10.79c-2.41.01-4.35 1.92-4.33 4.38s1.96 4.35 4.38 4.33c2.4-.01 4.33-1.91 4.33-4.38a4.317 4.317 0 0 0-4.38-4.33m.03 6.78c-1.34 0-2.43-1.05-2.43-2.41-.01-1.37 1.08-2.41 2.4-2.43a2.42 2.42 0 0 1 2.44 2.42c0 1.37-1.08 2.43-2.41 2.43m10.99-10.82a4.337 4.337 0 0 0 4.35-4.39c-.01-2.46-1.99-4.35-4.39-4.33a4.3 4.3 0 0 0-4.33 4.38c0 2.47 1.96 4.36 4.38 4.35m-.03-6.79c1.34 0 2.42 1.03 2.44 2.41 0 1.37-1.07 2.41-2.41 2.44-1.35 0-2.44-1.05-2.44-2.41-.01-1.4 1.07-2.44 2.41-2.44m3.05 28.41q-.135-.24-.39-.45c-.16-.13-.31-.23-.43-.32-.14-.09-.3-.17-.54-.26-.23-.09-.4-.15-.54-.19-.12-.04-.31-.1-.56-.19-.6-.17-1-.34-1.19-.48a.64.64 0 0 1-.28-.52c0-.22.09-.36.24-.49.16-.13.4-.19.71-.2.65 0 1.13.31 1.45.96l.06.13 1.58-.92-.04-.1c-.3-.6-.72-1.08-1.24-1.4-.52-.34-1.14-.51-1.82-.49-.78 0-1.43.23-1.99.7-.55.47-.83 1.09-.83 1.88.01.39.07.73.22 1.03.15.29.36.54.63.74.25.19.52.34.79.44.25.12.57.23.94.34.65.17 1.11.35 1.35.51.21.13.33.31.33.55 0 .2-.09.38-.26.52-.18.15-.49.22-.91.22-.88 0-1.46-.38-1.78-1.16l-.04-.15-1.61.95.04.12c.24.64.64 1.15 1.22 1.53s1.28.57 2.12.55c.9 0 1.65-.25 2.23-.7.57-.48.87-1.12.87-1.91 0-.26-.05-.48-.11-.68-.06-.22-.13-.39-.22-.54m1.61-4.99h-1.14v.3h.42v1.24h.31v-1.25h.41zm1.65-.02h-.28l-.41.7-.44-.7h-.28v1.5l.01.06h.3v-.93l.33.55h.13l.35-.55v.93h.31l-.02-1.5z"/><path d="M311.39 302.09c-20.34.1-36.77 16.19-36.69 37.05.1 20.87 16.7 36.79 37.04 36.69 20.36-.09 36.79-16.18 36.69-37.05-.11-20.85-16.68-36.77-37.05-36.69m.34 69.68c-18.11.1-32.88-14.07-32.96-32.64-.09-18.58 14.52-32.87 32.65-32.96 18.12-.09 32.87 14.07 32.97 32.64.09 18.56-14.54 32.87-32.65 32.96"/><path d="M331.56 328.62h-5.32v-6.65h-1.94v8.55h7.26zm-29 27.5h3.45l3.28-.01v-1.88h-4.74v-1.47h3.88l-.01-1.87h-3.87v-1.47h4.74v-2.05h-6.73z"/></g></svg>' );
$( ".header-item--navigation ul.site-navigation.horizontal-mega-menu li:nth-child(3) a i.mm-icon" ).replaceWith('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 195.15 436.02"><path fill="#000f9f" d="M32.18 117.29h130.78c4.64 0 8.42-3.86 8.42-8.59V72.49c0-3.09-1.51-5.97-4.01-7.71l-15.61-10.77c-3.54-9.17-6.06-12.18-7.65-13.23-.48-2-1.14-8.38-1.15-22.58 0-4.22-3.04-7.84-7.1-8.5-1.89-.5-17.27-4.38-38.29-4.38S61.17 9.2 59.28 9.7c-4.07.67-7.11 4.29-7.11 8.5 0 14.2-.66 20.58-1.15 22.58-1.58 1.05-4.1 4.06-7.65 13.23L27.76 64.78c-2.51 1.73-4 4.61-4 7.71v36.21c0 4.74 3.78 8.59 8.41 8.59m26.07-99.08c0-1.2.89-2.24 2.05-2.39l.2-.02.19-.06c.15-.04 15.76-4.22 36.9-4.22s36.74 4.17 36.89 4.22l.19.06.2.02c1.17.15 2.05 1.19 2.05 2.39 0 1.55 0 3.37.03 5.3l-78.73.55c.03-2.13.04-4.15.04-5.85m-4.14 27.96c2.68-.85 3.33-4.46 3.78-12.25.14-2.4.23-5 .28-7.54l78.81-.55c.06 2.7.15 5.52.29 8.09.46 7.79 1.11 11.39 3.78 12.25 1.03 1.07 3.17 5.31 4.93 9.75h-16.43v-2.51c0-.67-.22-1.33-.61-1.86l-14.69-19.97a3 3 0 0 0-2.43-1.24H81.74c-.99 0-1.93.5-2.49 1.33l-13.7 20.04a3.2 3.2 0 0 0-.55 1.77v2.44H49.17c1.77-4.44 3.91-8.68 4.93-9.75m52.77-1.67H89.61c-1.88 0-3.72.78-5.03 2.16-4.3 4.47-6.62 7.33-7.89 9.26h-5.62v-1.46l12.25-17.92h26.98l13.17 17.9v1.48h-5.51c-1.07-1.48-2.83-3.77-4.41-5.71-4.07-5-5.08-5.71-6.67-5.71m6.5 15.53v25.16c-.57 1.09-2.76 3.64-6.52 7.57-.07.08-.14.15-.21.22-9.59.18-17.16.21-19.52.08-.97-1.16-3.14-4.44-5.86-9.11V60.19c.42-.9 2.43-3.75 7.66-9.19.18-.19.42-.29.69-.29h16.27c1.68 1.71 5.92 7.07 7.5 9.33M29.85 72.5c0-1.03.5-1.99 1.33-2.57L48.1 58.26h16.91v15.13c0 1.72 1.36 3.1 3.04 3.1s3.04-1.38 3.04-3.1V58.26h4.38c-.26.74-.27 1.21-.27 1.6v24.5c0 .85.23 1.68.65 2.42 6.65 11.48 8.06 11.9 9.19 12.24.4.11 1.09.33 7.84.33 3.18 0 7.71-.05 14.19-.17.69.2 1.46.16 2.19-.16a3.25 3.25 0 0 0 1.57-1.51c.12-.12.25-.25.38-.4 6.4-6.69 8.25-9.27 8.25-11.51V59.75c0-.5-.07-1-.21-1.48h4.23v16.28c0 1.71 1.37 3.1 3.04 3.1s3.04-1.39 3.04-3.1V58.27h17.51l16.92 11.67c.84.58 1.33 1.54 1.33 2.57v36.21c0 1.32-1.05 2.39-2.34 2.39H32.18c-1.29 0-2.34-1.07-2.34-2.39V72.51Z"/><path fill="#000f9f" d="M83.99 80.44c0 .21.06.42.16.6.8 1.38 4.35 7.43 5.29 7.71s13.11.07 15.7 0c1.2-1.29 6.01-6.08 6.01-7.45v-7.17H83.98v6.29Z"/><g fill="#000f9f"><path d="M97.51 391.89c21.96 0 39.75-18.17 39.75-40.59s-17.8-40.58-39.75-40.58-39.75 18.17-39.75 40.58 17.79 40.59 39.75 40.59m0-74.45c18.31 0 33.15 15.16 33.15 33.85s-14.84 33.85-33.15 33.85-33.15-15.15-33.15-33.85 14.84-33.85 33.15-33.85"/><path d="M106.55 362.11h5.18v-13.94l7.29 3.6v-5.89l-9.88-5.4-9.79 5.48v5.92l7.2-3.67zm-23.36 0h5.18v-13.94l7.3 3.6v-5.89l-9.89-5.4-9.78 5.48v5.92l7.19-3.67zm32.57-1.18h.44v1.17h.4v-1.17h.44v-.32h-1.28zm2.35.53h-.01l-.34-.86h-.5v1.51h.39v-.88h.01l.33.86h.24l.32-.85h.01v.87h.39v-1.51h-.5z"/></g><path d="m170.97 121.82-.98-.66H25.16l-.98.66c-.15.1-15.17 10.36-16.57 28.97-1.3 17.23-.02 38.61 0 38.83l.1 1.56 1.2.88c.08.07.18.2.21.27.08 3.33 4.1 154.19 5.84 219.4v.22l.08.45.05.18c.05.17 5.22 17.31 25.06 17.81 14.77.37 47.66.12 57.44.03 5.6.05 20.04.16 33.72.16 10.51 0 18.5-.07 23.72-.2 19.83-.5 25.01-17.64 25.06-17.81l.11-.4.02-.41c1.18-49.85 4.94-209 5.18-219.21.06-.04.12-.07.18-.1l1.86-.76.13-2.08c0-.22 1.29-21.6 0-38.83-1.4-18.6-16.41-28.87-16.56-28.97m3.17 289.33c-.77 2.13-5.28 12.69-19.27 13.04-5.18.13-13.11.2-23.58.2-13.68 0-28.12-.11-33.69-.16h-.05c-9.73.09-42.58.33-57.27-.03-14.09-.35-18.56-11.06-19.28-13.06-.15-5.57-1.64-61.83-3.08-115.9h158.92c-1.28 54-2.6 110.13-2.74 115.93m2.8-118.25H17.86c-.27-10.07-.54-20.04-.79-29.56h160.57c-.23 9.52-.46 19.49-.7 29.56m1.52-64.52H16.59v2.32H178.4c-.21 9.13-.46 19.41-.72 30.31H17.01c-.85-31.81-1.55-58.27-1.77-66.29h164.02c-.12 5.18-.42 17.46-.8 33.66m3.1-40.65c-1.22.97-2.23 2.42-2.25 4.29v.37H15.19v-.15c0-1.86-.84-3.25-1.58-4.12-.24-4.57-1.03-22.28.07-36.86 1.01-13.43 10.69-21.82 13.23-23.8h141.34c2.56 2 12.22 10.38 13.23 23.8 1.07 14.18.34 31.36.08 36.47" style="fill:#000f9f;stroke:#000f9f;stroke-miterlimit:10;stroke-width:.5px"/></svg>');
$( ".header-item--navigation ul.site-navigation.horizontal-mega-menu li:nth-child(6) a i.mm-icon" ).replaceWith( '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 153.26 540.75"><g fill="#000f9f"><path d="M145.25 485.56v-234.9c0-30.62-14.06-50.69-22.46-62.68-2.14-3.06-4.35-6.22-4.66-6.69l.15-29.15c.02-3.98-3.18-7.2-7.15-7.2H42.14c-3.96 0-7.17 3.24-7.14 7.23l.25 28.19c-.46 1.41-2.7 4.61-4.84 7.67-8.39 12-22.43 32.1-22.43 62.62L8 485.14c-.06 1.11-1.33 27.32 12.02 41.35 5.49 5.77 12.48 8.71 20.8 8.71h71.59c8.31 0 15.33-2.93 20.8-8.71 13.51-14.2 12.1-40.17 12.04-40.93m-19.8 33.54c-3.44 3.61-7.7 5.38-13.04 5.38h-71.6c-5.32 0-9.59-1.77-13.03-5.38-10.19-10.72-9.08-33.14-9.07-33.66V250.66c0-27.15 12.82-45.52 20.48-56.47 3.08-4.4 5.29-7.57 6.23-10.43l.39-1.64-.09-19.27c-.02-3.98 3.2-7.19 7.17-7.19h47.45c3.96 0 7.18 3.21 7.14 7.19l-.09 18.41.39 2.46c.94 2.89 3.15 6.04 6.2 10.4 7.7 10.94 20.53 29.28 20.53 56.53l.02 235.23c.02.22 1 22.61-9.09 33.22m-7.74-390.87.55-23.51c.07-2.64-1.33-5.1-3.63-6.39L95.68 87.62c-1.08-.6-2.28-.91-3.52-.91h-31.1c-1.22 0-2.44.31-3.51.91L38.61 98.33a7.18 7.18 0 0 0-3.64 6.39l.57 23.51c.1 3.87 3.26 6.98 7.15 6.98h67.86c3.87 0 7.06-3.11 7.15-6.98m-55.69-30.8h29.22l16.26 9.19-.43 17.87H46.17l-.42-17.87z"/><path d="M90.02 418.76v1.9l2.83-1.41v6.52h2.05v-6.54l2.88 1.39v-1.89l-3.89-1.84zm-8.21 7.01h2.04v-6.55l2.87 1.41v-1.89l-3.9-1.83-3.84 1.86v1.89l2.83-1.43zm-22.28 4.14h-1.94v8.72h7.26v-1.91h-5.32zm1.97-18.66c-1.49 0-2.46-.98-2.46-2.49-.01-1.5.94-2.5 2.43-2.5.87-.01 1.58.38 1.95 1.02l1.66-.98c-.73-1.18-2.09-1.92-3.61-1.92-2.53.01-4.36 1.92-4.35 4.39s1.86 4.36 4.39 4.35c1.54-.01 2.87-.77 3.59-1.96l-1.67-.95c-.36.66-1.08 1.03-1.93 1.03m.17 5.84h-4.08v8.84h4.38c1.53 0 2.77-1.02 2.77-2.53-.01-.89-.43-1.56-1.07-1.96.46-.39.74-.96.74-1.67-.01-1.5-1.24-2.68-2.74-2.68m-2.12 2.08h2.14c.45-.01.75.31.76.74 0 .45-.31.77-.76.77H59.6l-.04-1.51Zm2.41 4.92h-2.32v-1.64h2.31c.51-.01.82.32.82.8s-.31.84-.81.84m9.8-10.93a4.38 4.38 0 0 0 4.39-4.45c-.01-2.5-2-4.41-4.44-4.39a4.386 4.386 0 0 0-4.4 4.45c.01 2.5 2.01 4.41 4.44 4.39m-.03-6.87c1.35 0 2.46 1.05 2.46 2.43.01 1.4-1.08 2.46-2.43 2.46-1.36.01-2.46-1.03-2.47-2.44 0-1.38 1.08-2.44 2.44-2.44m.06 10.79c-2.41.01-4.35 1.92-4.33 4.38s1.96 4.35 4.38 4.33c2.4-.01 4.33-1.91 4.33-4.38a4.317 4.317 0 0 0-4.38-4.33m.03 6.78c-1.34 0-2.43-1.05-2.43-2.41-.01-1.37 1.08-2.41 2.4-2.43a2.42 2.42 0 0 1 2.44 2.42c0 1.37-1.08 2.43-2.41 2.43m10.99-10.82a4.337 4.337 0 0 0 4.35-4.39c-.01-2.46-1.99-4.35-4.39-4.33a4.3 4.3 0 0 0-4.33 4.38c0 2.47 1.96 4.36 4.38 4.35m-.03-6.79c1.34 0 2.42 1.03 2.44 2.41 0 1.37-1.07 2.41-2.41 2.44-1.35 0-2.44-1.05-2.44-2.41-.01-1.4 1.07-2.44 2.41-2.44m3.05 28.41q-.135-.24-.39-.45c-.16-.13-.31-.23-.43-.32-.14-.09-.3-.17-.54-.26-.23-.09-.4-.15-.54-.19-.12-.04-.31-.1-.56-.19-.6-.17-1-.34-1.19-.48a.64.64 0 0 1-.28-.52c0-.22.09-.36.24-.49.16-.13.4-.19.71-.2.65 0 1.13.31 1.45.96l.06.13 1.58-.92-.04-.1c-.3-.6-.72-1.08-1.24-1.4-.52-.34-1.14-.51-1.82-.49-.78 0-1.43.23-1.99.7-.55.47-.83 1.09-.83 1.88.01.39.07.73.22 1.03.15.29.36.54.63.74.25.19.52.34.79.44.25.12.57.23.94.34.65.17 1.11.35 1.35.51.21.13.33.31.33.55 0 .2-.09.38-.26.52-.18.15-.49.22-.91.22-.88 0-1.46-.38-1.78-1.16l-.04-.15-1.61.95.04.12c.24.64.64 1.15 1.22 1.53s1.28.57 2.12.55c.9 0 1.65-.25 2.23-.7.57-.48.87-1.12.87-1.91 0-.26-.05-.48-.11-.68-.06-.22-.13-.39-.22-.54m1.61-4.99H86.3v.3h.41v1.24h.32V430h.41zm1.65-.02h-.28l-.42.7-.43-.7h-.29v1.5l.02.06h.3v-.93l.33.55h.13l.35-.55v.93h.31l-.02-1.5z"/><path d="M77.3 384.56c-20.34.1-36.77 16.19-36.69 37.05.1 20.87 16.7 36.79 37.04 36.69 20.36-.09 36.79-16.18 36.69-37.05-.11-20.85-16.68-36.77-37.05-36.69m.34 69.68c-18.11.1-32.88-14.07-32.96-32.64-.09-18.58 14.52-32.87 32.65-32.96 18.12-.09 32.87 14.07 32.97 32.64.09 18.56-14.54 32.87-32.65 32.96"/><path d="M97.47 411.09h-5.32v-6.65h-1.94V413h7.26zm-29 27.51h3.45l3.27-.02v-1.88h-4.73v-1.46h3.88l-.01-1.88h-3.87v-1.47h4.73v-2.05h-6.72z"/></g><path fill="#000f9f" d="M82.94 15.13 84.52 20a6.65 6.65 0 0 0 6.31 4.59h5.12c6.43 0 9.1 8.23 3.9 12l-4.14 3.01a6.625 6.625 0 0 0-2.41 7.42l1.58 4.87c1.99 6.11-5.01 11.2-10.21 7.42l-4.14-3.01a6.63 6.63 0 0 0-7.8 0l-4.14 3.01c-5.2 3.78-12.2-1.31-10.21-7.42l1.58-4.87a6.63 6.63 0 0 0-2.41-7.42l-4.14-3.01c-5.2-3.78-2.53-12 3.9-12h5.12c2.87 0 5.42-1.85 6.31-4.59l1.58-4.87c1.99-6.11 10.64-6.11 12.62 0"/></svg>' );
$( ".header-item--navigation ul.site-navigation.horizontal-mega-menu li:nth-child(4) a i.mm-icon" ).replaceWith( '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 338.08 318.47"><path fill="#000f9f" d="M86.25 218.94v1.26l1.89-.94v4.34h1.36v-4.35l1.91.93v-1.26l-2.59-1.22zm-5.47 4.66h1.36v-4.35l1.92.93v-1.26l-2.6-1.22-2.56 1.24v1.26l1.88-.94zm-14.81 2.76h-1.3v5.8h4.83v-1.27h-3.53zm1.31-12.41c-.99 0-1.63-.65-1.64-1.65 0-1 .63-1.66 1.62-1.67.57 0 1.05.25 1.3.68l1.1-.64c-.49-.79-1.39-1.29-2.4-1.28-1.68 0-2.9 1.28-2.89 2.92 0 1.65 1.24 2.9 2.92 2.89 1.02 0 1.91-.51 2.39-1.3l-1.11-.63c-.24.43-.72.69-1.29.69Zm.11 3.88h-2.72v5.88h2.91c1.02 0 1.85-.67 1.85-1.69 0-.58-.28-1.02-.71-1.29.31-.27.5-.65.49-1.12 0-.99-.82-1.78-1.82-1.77Zm-1.42 1.38h1.43c.3 0 .5.2.5.5s-.2.51-.5.51H66zm1.61 3.27h-1.55v-1.09h1.55c.33 0 .54.22.54.54s-.21.55-.54.55m6.52-7.27c1.62 0 2.93-1.29 2.92-2.95 0-1.66-1.33-2.93-2.95-2.92-1.62 0-2.93 1.29-2.92 2.95 0 1.66 1.33 2.93 2.95 2.92m-.02-4.57c.9 0 1.63.7 1.64 1.62 0 .92-.72 1.64-1.62 1.64s-1.64-.7-1.64-1.62.72-1.64 1.63-1.64Zm.04 7.19c-1.6 0-2.89 1.27-2.88 2.91 0 1.64 1.31 2.89 2.91 2.88 1.6 0 2.89-1.27 2.88-2.91 0-1.64-1.31-2.89-2.91-2.88m.02 4.51c-.89 0-1.61-.69-1.62-1.6 0-.91.71-1.61 1.6-1.62.89 0 1.61.69 1.62 1.6 0 .91-.71 1.61-1.6 1.62m7.31-7.2c1.6 0 2.9-1.27 2.89-2.92 0-1.64-1.32-2.9-2.92-2.89-1.6 0-2.9 1.28-2.89 2.92 0 1.64 1.32 2.9 2.92 2.89m-.02-4.52c.89 0 1.62.69 1.62 1.61 0 .91-.71 1.62-1.61 1.62-.89 0-1.62-.69-1.62-1.61 0-.91.71-1.62 1.61-1.62m2.03 18.91c-.06-.1-.15-.2-.26-.29s-.2-.16-.29-.22-.2-.11-.36-.17c-.15-.06-.27-.1-.36-.13-.08-.03-.21-.07-.38-.12-.39-.12-.66-.23-.79-.33a.4.4 0 0 1-.18-.34c0-.13.05-.24.16-.32.11-.09.27-.13.47-.13.45 0 .76.21.97.64l.04.09 1.05-.61-.04-.07c-.19-.39-.47-.71-.82-.93s-.76-.33-1.21-.33c-.51 0-.95.16-1.32.47s-.55.73-.55 1.25c0 .26.05.49.14.69s.23.36.42.49c.17.12.35.22.52.3.17.07.38.15.63.22q.645.18.9.33c.15.09.22.21.22.37 0 .14-.06.25-.18.34-.12.1-.33.15-.61.15-.58 0-.97-.25-1.17-.77l-.04-.1-1.07.63.03.07c.16.43.43.77.82 1.02.38.25.86.37 1.41.37.6 0 1.1-.16 1.48-.47s.58-.74.57-1.27c0-.16-.02-.32-.06-.46a1.5 1.5 0 0 0-.15-.36Zm1.07-3.31h-.76v.2h.28v.79l.01.04h.2v-.83h.28zm1.1 0h-.19l-.28.46-.28-.46h-.19v1.03h.21v-.62l.22.37h.09l.22-.37v.61h.21l-.01-.98z"/><path fill="#000f9f" d="M77.79 196.19c-13.54.06-24.47 10.76-24.4 24.64s11.1 24.47 24.64 24.4 24.47-10.76 24.4-24.64-11.1-24.47-24.64-24.4m.22 46.35c-12.05.06-21.87-9.37-21.93-21.72s9.67-21.87 21.72-21.93 21.87 9.37 21.93 21.72-9.67 21.87-21.72 21.93"/><path fill="#000f9f" d="M91.2 213.84h-3.53v-4.43h-1.3v5.7h4.83zm-19.29 18.3h2.3l2.18-.01v-1.25h-3.16v-.97h.01v-.01h2.58l-.01-1.25h-2.58v-.97h3.16v-1.37h-4.48z"/><path fill="#000f9f" d="M2.79 79.01c0 .33-.17 1.3-.32 2.11-.42 2.25-.79 4.21-.04 5.72l.23.54-.09.84h.92c.07.05.16.09.23.13h148.36c.29-.18.6-.33.84-.6l.59-.79.06-.33c.63-1.48.27-3.37-.13-5.54-.16-.83-.33-1.62-.32-2.09.05-2.76.4-4.67.65-6.07.15-.83.27-1.55.33-2.19v-.02c.23-3.19-2.01-5.14-4.64-5.45h-1.01c-4.06-.03-19.83-.1-39.37-.15v-2.13a3.99 3.99 0 0 0-3.98-3.98H50.42a3.99 3.99 0 0 0-3.98 3.98v2.12l-8.98.04c-5.44.02-30.93.11-31.33.15-2.32.28-4.54 2.23-4.31 5.42.04.62.17 1.32.33 2.21.26 1.39.6 3.31.65 6.07Zm106.29 1.69V70.66c19.27.05 34.86.12 39.15.14h.3c-.05.34-.12.72-.2 1.14v.02c-.29 1.58-.68 3.75-.74 6.94-.02.92.2 2.05.43 3.27.07.36.17.92.25 1.45l-40.35.05c.72-.74 1.16-1.78 1.16-2.97m-71.6-10.01 8.96-.04v10.24c0 1.12.46 2.13 1.21 2.86l-37.1.04h-.41c-.41 0-1.17-.03-2.06-.17h-.43c.08-.53.19-1.1.26-1.48.24-1.26.43-2.45.42-3.24-.06-3.19-.45-5.36-.75-7.01-.07-.39-.14-.75-.19-1.09 3.24-.02 14.83-.07 30.09-.12Zm113.56 23.17c.24-.36.42-.76.53-1.2.16-.07.29-1.74.44-1.84H3.65c.17.11.34 1.74.52 1.82.11.48.32.93.6 1.32-1.17 2.32-1.27 4.83-1.25 4.83-.54 3.11-1.27 25.78 12.19 186.7l.03.86c.14 4.57.41 10.17 1.28 12.94 2.12 6.79 10.79 13.78 59.06 14.1h3.73c48.26-.32 56.93-7.31 59.05-14.1.86-2.75 1.14-8.34 1.28-12.94l.02-.8c13.46-160.94 12.74-183.64 12.23-186.45-.02-.41-.17-2.97-1.35-5.25Zm-17.4 192.31c-.19 5.93-.52 9.7-.98 11.2-.65 2.09-3.76 3.99-8.98 5.49-8.91 2.56-23.69 3.93-43.92 4.06h-3.65c-20.23-.13-35.01-1.5-43.92-4.06-5.22-1.5-8.33-3.4-8.98-5.49-.33-1.05-.76-3.84-.98-11.21l-.49-6.44c7.47 2.47 24.32 6.38 55.25 5.87 34.37-.57 50.02-3.33 57.13-5.68l-.47 6.25Zm1.07-13.46c-2.2 1.23-13.18 5.66-57.84 6.4-34.99.64-51.35-4.77-55.73-6.53C8.09 114.67 9.76 100.57 9.78 100.3l.19-.9c.07-1.12.47-2.59.42-2.77l134.71-.13c.26.25.57 1.21.72 2.16l.2 1.61c.21 2.47.99 23.66-11.31 172.44m129.26-51.86v1.48l2.22-1.1v5.09h1.59v-5.12l2.25 1.09v-1.47l-3.05-1.43zm-6.42 5.46h1.6v-5.1l2.24 1.09v-1.47l-3.04-1.44-3.02 1.46v1.47l2.22-1.1zm-17.39 3.24h-1.53v6.82h5.66v-1.5h-4.13zm1.53-14.58c-1.17.01-1.93-.77-1.93-1.94s.75-1.94 1.9-1.94c.66-.01 1.23.28 1.54.8l1.28-.76c-.57-.94-1.63-1.52-2.83-1.52-1.96.03-3.39 1.51-3.38 3.44 0 1.93 1.43 3.4 3.43 3.39 1.19 0 2.23-.6 2.79-1.52l-1.29-.75c-.28.51-.85.81-1.51.81m.14 4.55h-3.2v6.91h3.42c1.21-.01 2.18-.8 2.17-1.98 0-.69-.33-1.21-.84-1.52.37-.32.58-.76.58-1.32-.01-1.16-.96-2.08-2.13-2.08m-1.68 1.63h1.68c.37-.01.58.23.6.58 0 .34-.24.6-.58.6h-1.65l-.04-1.18Zm1.89 3.83h-1.82v-1.28h1.8c.39 0 .63.25.65.63 0 .38-.25.64-.63.65m7.68-8.53a3.423 3.423 0 0 0 3.42-3.47c0-1.97-1.55-3.44-3.47-3.44a3.425 3.425 0 0 0-3.43 3.47c.01 1.96 1.56 3.44 3.48 3.44m-.04-5.37c1.07-.01 1.93.83 1.93 1.9s-.85 1.92-1.9 1.92c-1.05.01-1.93-.81-1.93-1.89s.85-1.93 1.9-1.93m.04 8.44c-1.88.01-3.39 1.49-3.38 3.4 0 1.93 1.52 3.41 3.42 3.4 1.88-.01 3.39-1.5 3.38-3.43-.01-1.92-1.54-3.39-3.42-3.38m.03 5.28c-1.04.01-1.89-.81-1.9-1.88 0-1.07.84-1.89 1.89-1.89 1.04-.01 1.89.8 1.89 1.87.01 1.08-.83 1.9-1.88 1.9m8.59-8.43a3.38 3.38 0 0 0 3.38-3.43c0-1.93-1.54-3.4-3.43-3.39-1.88.01-3.4 1.5-3.39 3.43s1.55 3.4 3.44 3.39m-.04-5.31c1.05 0 1.9.83 1.9 1.89s-.84 1.89-1.89 1.9c-1.04 0-1.89-.81-1.9-1.89 0-1.07.85-1.89 1.89-1.9m2.39 22.21c-.06-.11-.18-.23-.29-.34-.13-.1-.24-.19-.34-.25s-.23-.13-.42-.2c-.18-.08-.32-.11-.42-.15-.1-.03-.24-.09-.44-.14-.46-.15-.77-.27-.93-.39a.46.46 0 0 1-.22-.41c0-.15.05-.28.19-.38.13-.09.3-.15.53-.15.53 0 .9.24 1.14.76l.05.09 1.24-.72-.05-.08c-.23-.47-.56-.83-.96-1.09-.41-.27-.89-.39-1.43-.38-.58 0-1.1.18-1.52.53-.44.37-.65.85-.65 1.47 0 .3.05.58.17.8.11.24.28.43.48.58s.41.27.62.36c.19.09.44.18.72.25.51.14.88.28 1.05.38.18.11.25.27.25.44s-.06.29-.19.41c-.15.11-.38.18-.71.18-.69 0-1.14-.3-1.38-.91l-.04-.11-1.26.75.03.08c.19.51.51.91.96 1.21.44.29 1 .44 1.65.43.71 0 1.3-.19 1.74-.55.46-.38.69-.86.67-1.5 0-.19-.03-.37-.08-.52-.05-.18-.1-.3-.18-.43m1.29-3.91-.85.01h-.05v.23h.33v.98h.25l-.01-.98h.33zm1.28-.01-.22.01-.33.54-.34-.54h-.22l.02 1.16v.05h.24l-.02-.73.27.44h.1l.27-.44.01.73.23-.01-.01-1.15z"/><path fill="#000f9f" d="M254.05 194.12c-15.91.1-28.73 12.66-28.67 28.96.08 16.29 13.04 28.73 28.93 28.65 15.91-.09 28.74-12.64 28.65-28.95-.06-16.29-13.03-28.74-28.92-28.67m.25 54.44c-14.16.08-25.68-10.99-25.75-25.51-.08-14.5 11.35-25.68 25.51-25.76 14.16-.05 25.67 11.01 25.75 25.51.08 14.51-11.34 25.7-25.51 25.76"/><path fill="#000f9f" d="M269.78 214.85h-4.14v-5.21h-1.52v6.71h5.66zm-22.65 21.49h2.69l2.57-.02v-1.47h-3.7v-1.14l3.02.01v-1.48h-3.02v-1.13h3.7v-1.62h-5.26z"/><path fill="#000f9f" d="M172.14 67.51h164.07v-3.62l-.1-.46c.1-.44.16-.91.16-1.38 0-2.09-1.04-4.34-2.79-6.02-1.41-1.33-3.88-2.93-7.73-2.93-.96 0-1.26-.19-1.17-.57V25.39c0-5.59-5.85-8.09-11.65-8.09h-31.96v-3.14c0-5.03-4.38-9.1-9.78-9.1h-34.04c-5.4 0-9.78 4.08-9.78 9.1v3.14h-31.96c-5.8 0-11.67 2.5-11.67 8.09l.1 27.52s-.3.19-1.27.19c-3.88 0-6.35 1.61-7.72 2.93-1.51 1.43-2.49 3.29-2.73 5.12v.04c-.04.29-.06.57-.06.86s.03.55.05.81v4.65Zm17.98-8.98c1.92-2.16 2.16-4.71 2.07-6.02V26.24c.74-.27 2.09-.52 3.25-.52h31.96v3.3c0 5.01 4.38 9.1 9.78 9.1h34.04c5.4 0 9.78-4.09 9.78-9.1v-3.3h31.96c1.16 0 2.51.25 3.24.52l.03 25.81c-.09.88-.23 3.92 2.04 6.48l.22.24H189.9c.06-.08.14-.15.2-.23m146.1 13.7H172.12v36.93c-.1 1.19-.47 7.44 2.69 12.67.7 1.18 1.46 2.16 2.26 3.15 2.09 2.62 4.08 5.08 4.91 15.6.67 8.52 3.52 49.78 8.46 122.67l1.98 23.56c.09.93 1.04 9.24 8.1 13.22 15.1 8.49 35.63 13.36 56.31 13.36s40.12-4.99 51.48-13.7c5.78-4.44 7.3-11.26 7.58-12.86l1.51-16.52c.32-4.68 7.78-114.89 8.95-129.73.83-10.51 2.81-12.99 4.91-15.6.77-.98 1.54-1.96 2.25-3.12 3.26-5.43 2.81-12.09 2.69-12.32zM198.38 255.79c-1.61-23.75-4.89-71.97-6.77-98.65 3.53 1.46 6.77 7.01 6.77 25.6zm112.22-9.45v-63.61c0-17.48 2.86-23.4 6.09-25.25-1.64 23.56-4.37 63.52-6.09 88.86m15.71-128.83-.03.03c-.48.83-1.02 1.49-1.59 2.18-2.54 3.17-5.7 7.12-6.73 20.22l-.62 8.51c-15.16 2.26-15.16 24.5-15.16 34.28v111.04c-9.93 7.03-26.74 11.21-45.35 11.21s-36.39-4.05-50.04-11.16V182.73c0-9.81 0-32.15-15.79-34.3-.28-3.86-.5-6.81-.63-8.48-1.03-13.08-4.18-17.03-6.78-20.29-.55-.67-1.08-1.33-1.56-2.15-1.82-3.01-1.54-7.24-1.49-7.96V80.06h147.25l.03 29.9c.04.44.3 4.54-1.51 7.55"/></svg>');
$( ".header-item--navigation ul.site-navigation.horizontal-mega-menu li:nth-child(5) a i.mm-icon" ).replaceWith('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 153.26 462.2"><path fill="#000f9f" d="M145.25 405.71V170.8c0-30.62-14.06-50.69-22.46-62.68-2.14-3.06-4.35-6.22-4.66-6.69l.15-29.15c.02-3.98-3.18-7.2-7.15-7.2H42.14c-3.96 0-7.17 3.24-7.14 7.23l.25 28.19c-.46 1.41-2.7 4.61-4.84 7.67-8.39 12-22.43 32.1-22.43 62.62L8 405.28c-.06 1.11-1.33 27.32 12.02 41.35 5.49 5.77 12.48 8.71 20.8 8.71h71.59c8.31 0 15.33-2.93 20.8-8.71 13.51-14.2 12.1-40.17 12.04-40.93m-19.8 33.54c-3.44 3.61-7.7 5.38-13.04 5.38h-71.6c-5.32 0-9.59-1.77-13.03-5.38-10.19-10.72-9.08-33.14-9.07-33.66V170.8c0-27.15 12.82-45.52 20.48-56.47 3.08-4.4 5.29-7.57 6.23-10.43l.39-1.64-.09-19.27c-.02-3.98 3.2-7.19 7.17-7.19h47.45c3.96 0 7.18 3.21 7.14 7.19l-.09 18.41.39 2.46c.94 2.89 3.15 6.04 6.2 10.4 7.7 10.94 20.53 29.28 20.53 56.53l.02 235.23c.02.22 1 22.61-9.09 33.22M117.7 48.38l.55-23.51c.07-2.64-1.33-5.1-3.63-6.39L95.68 7.77c-1.08-.6-2.28-.91-3.52-.91h-31.1c-1.22 0-2.44.31-3.51.91L38.61 18.48a7.18 7.18 0 0 0-3.64 6.39l.57 23.51c.1 3.87 3.26 6.98 7.15 6.98h67.86c3.87 0 7.06-3.11 7.15-6.98m-55.69-30.8h29.22l16.26 9.19-.43 17.87H46.17l-.42-17.87z"/><path d="M101.44 387.22H57.83V375.4H91.9v-17.62h9.54zm.58-52.41c0 3.96-.86 7.55-2.58 10.76s-4.24 5.75-7.57 7.62-7.4 2.81-12.22 2.81-8.96-.94-12.29-2.81-5.86-4.41-7.57-7.62-2.56-6.79-2.56-10.76.85-7.54 2.56-10.74 4.23-5.74 7.57-7.62 7.43-2.82 12.29-2.82 8.92.94 12.25 2.82 5.84 4.42 7.55 7.62 2.56 6.78 2.56 10.74Zm-10.3 0c0-1.97-.46-3.62-1.39-4.96q-1.395-2.01-4.08-3.03c-1.79-.68-3.99-1.02-6.58-1.02s-4.82.34-6.63 1.02c-1.8.68-3.17 1.69-4.1 3.03s-1.39 2.99-1.39 4.96.46 3.59 1.39 4.93 2.29 2.35 4.1 3.04 4.02 1.04 6.63 1.04 4.79-.35 6.58-1.04c1.8-.69 3.16-1.71 4.08-3.04.93-1.34 1.39-2.98 1.39-4.93m10.3-44.99c0 4.23-.9 7.96-2.71 11.17-1.8 3.21-4.38 5.71-7.71 7.51-3.34 1.79-7.3 2.69-11.88 2.69s-8.87-.96-12.22-2.88-5.89-4.49-7.64-7.71-2.62-6.79-2.62-10.71c0-2.58.37-4.97 1.1-7.19.73-2.21 1.77-4.18 3.12-5.9s2.93-3.1 4.76-4.14c1.82-1.04 3.83-1.68 6.01-1.92v11.94c-.74.18-1.4.46-1.99.86s-1.08.9-1.48 1.49-.7 1.28-.91 2.05-.31 1.62-.31 2.56c0 1.97.47 3.66 1.42 5.06q1.425 2.1 4.11 3.21c1.8.73 3.95 1.1 6.47 1.1s4.74-.35 6.56-1.05q2.715-1.05 4.17-3.12c.97-1.38 1.45-3.09 1.45-5.14 0-1.79-.26-3.29-.79-4.49s-1.27-2.1-2.24-2.69-2.1-.89-3.41-.89l.23-2.05v9.95h-8.43v-19.32h6.03q5.97 0 10.2 2.52c2.82 1.68 4.98 4 6.47 6.95s2.24 6.34 2.24 10.14m0-43.28c0 3.96-.86 7.55-2.58 10.76s-4.24 5.75-7.57 7.62-7.4 2.81-12.22 2.81-8.96-.94-12.29-2.81-5.86-4.41-7.57-7.62-2.56-6.79-2.56-10.76.85-7.54 2.56-10.74 4.23-5.74 7.57-7.62 7.43-2.82 12.29-2.82 8.92.94 12.25 2.82 5.84 4.42 7.55 7.62 2.56 6.78 2.56 10.74Zm-10.3 0c0-1.97-.46-3.62-1.39-4.96q-1.395-2.01-4.08-3.03c-1.79-.68-3.99-1.02-6.58-1.02s-4.82.34-6.63 1.02c-1.8.68-3.17 1.69-4.1 3.03s-1.39 2.99-1.39 4.96.46 3.59 1.39 4.93 2.29 2.35 4.1 3.04 4.02 1.04 6.63 1.04 4.79-.35 6.58-1.04c1.8-.69 3.16-1.71 4.08-3.04.93-1.34 1.39-2.98 1.39-4.93" fill="#000f9f"/></svg>');
});




